
import { LogCategory, log } from '../api/logger';

export default {
    language: "en",
    initialized: false,
    
    keys: {
        // Replayer
        "notAllowedByLicense": "",
        "selectHandToExport":"",
        "selectFormat": "",
        "originalFormat":"",
        "ctrlCToCopy":"",
        "availableTags": "",
        "welcomeToHm3": "",
        "theme": "",
        "deck": "",
        "showHandResults":"",
        "showHeroCards": "",
        "showBB": "",
        "combineFolds": "",
        "maskPlayerNames":"",
        "statsUpToTimeOfHand": "",
        "showHud": "",
        "replaySpeed": "",
        "hand": "",
        "next100Hands": "",
        "prev100Hands": "",
        "addEditHandMarking": "",
        "wonXBB": "",
        "lostXBB": "",
        "wonLossNA": "",
        "potBB": "",
        "userWentAllin": "",
        "pot": "",
        "potOdds": "",
        "hhGameStart": "",
        "hhHandNotes": "",
        "hhFold": "",
        "hhCheck": "",
        "hhCall": "",
        "hhBet": "",
        "hhRaise": "",
        "hhReturnedTo": "",
        "hhWin": "",
        "hhRake": "",
        "hhActionEnded": "",
        "hhMuck": "",
        "hhShow": "",
        "hhPostSB": "",
        "hhPostBB": "",
        "hhPostDB": "",
        "skipEndOfHandLabel": "",



























        // Situational Views
        "threebetResultsTitle": "",
        "threebetPositionTitle": "",
        "threebetRangeTitle": "",
        "threebetSuccessTitle": "",
        "threebetFlopHandStrengthTitle": "",
        "threebetWinrate": "",
        "threebetFrequency": "",
        "threebetRange": "",
        "threebetSuccessRate": "",
        "threebetFlopWinrate": "",
        "threebetWinrateHandStrengthAxis": "",
        "threebetHandCount": "",
        "threebetWinrateKey":"",
        "threebetThreeBetPercentKey":"",
        "threebetWinrateAxis":"",
        "threebetThreeBetPercentAxis":"",
        "threebetSuccessPercentAxis":"",
        "threebetNetwonTitle": "",
        "threebetNetwonMin": "",
        "threebetNetwonMax": "",
        "threebetDealtFrequencyTitle": "",
        "threebetDealtFrequencyMin": "",
        "threebetDealtFrequencyMax": "",
        "availableStringPositionString": "",
        "availableStringFlopMadeHandValueString": "",
        "availableStringRiverMadeHandValueSummary": "",
        "availableStringFlopFlushTextureTypeAsString": "",
        "availableStringFlopStraightTextureTypeAsString": "",
        "availableStringFlopPairedTextureTypeAsString": "",
        "availableStringInPositionOnFlopShort": "",
        "availableStringInPositionOnFlopLong": "",
        "availableStringRiverplayCallEfficiency": "",
        "availableStringRiverplayBetEfficiency": "",
        "availableStringCBetSpots": "",
        "availableStringRiverFirstActionString": "",
        "ECCallCallVsVillainOpenAllinPreflop": "",
        "ECCallEVCallVsVillainOpenAllinPreflop": "" ,
        "ECTBetCallVsVillainOpenAllinPreflop": "" ,
        "ECTBetEVCallVsVillainOpenAllinPreflop": "" ,
        "ERRaiseCallVsVillainOpenAllinPreflop" : "",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "",
        "ERTBetCallVsVillainOpenAllinPreflop": "",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "",
        "BPCCallCallVsVillainOpenAllinPreflop": "",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "",
        "BPCTBetCallVsVillainOpenAllinPreflop": "",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "",
        "BPRRaiseAllinVsRaisePreflop": "",
        "BPRRaiseEVAllinVsRaisePreflop": "",
        "BPRTBetAllinVsRaisePreflop": "",
        "BPRTBetEVAllinVsRaisePreflop": "",
        "threebetHandAxis": "",
        "threebetNetBbAxis": "",
        "tourneyallinCallingByStackTitle": "",
        "tourneyallinRaisingByStackTitle": "",
        "tourneyallinRaisingAllinRangeTitle": "",
        "tourneyallinCallingAllinRangeTitle": "",
        "tourneyallinCallingAllinByPositionTitle": "",
        "tourneyallinRaisingAllinByPositionTitle": "",
        "tourneyallinCallAIEVWinrate": "",
        "tourneyallinRaiseAIEVWinrate": "",
        "tourneyallinCallAIWinrate": "",
        "tourneyallinRaiseAIWinrate": "",
        "tourneyallinExpectedWon": "",
        "tourneyallinCallingOpenAI": "",
        "tourneyallinCalling3BetAI": "",
        "tourneyallinPositionAxis": "",
        "tourneyallinExpectationAxis": "",
        "tourneyallinRacesWonPAxis": "",
        "tourneyallinEquityPAxis": "",
        "tourneyallinCallvsOpen": "",
        "tourneyallinCallvs3Bet": "",
        "tourneyallinPreflopEffectiveStackSizeAxis": "",
        "tourneyallinRaisevsOpen": "",
        "tourneyallinRaisevs3Bet": "",
        "tourneyallinRaisingOpenAI": "",
        "tourneyallinRaising3BetAI": "",
        "bubblePrizePoolWinningsTitle" : "",
        "bubbleExpectationWhenReachingBubbleTitle" : "",
        "bubblePositionTitle" : "",
        "bubbleBeforeAndAfterTitle" : "",
        "bubbleStackSizeTitle" : "",
        "bubbleCallRangesTitle" : "",
        "bubbleShoveRangesTitle" : "",
        "bubblePrizePoolWon":"",
        "bubbleExpectedValue":"",
        "bubbleAverageStack":"",
        "bubbleCallAIWinrate":"",
        "bubbleShoveAIWinrate":"",
        "tooFewHands":"",
        "bubblePrizePoolP":"",
        "bubbleBubbleStage":"",
        "bubbleEVbb100hands":"",
        "bubbleICMDescription" : "",
        "bubblePercentageDescription" : "",
        "bubblePreflopDescription" : "",
        "bubblePreflopDescription2" : "",
        "bubbleBubblePlayers" : "",
        "bubblePlayersAtBubble" : "",
        "bubbleBubblePosition" : "",
        "bubbleICMDescription3" : "",
        "bubblePercentageDescription3" : "",
        "bubblePreflopDescription3" : "",
        "bubbleSitNGoEntrants" : "",
        "bubbleICMDescription4" : "",
        "bubblePercentageDescription4" : "",
        "bubblePreflopDescription4" : "",
        "bubbleCallingAllInRange": "",
        "bubbleBubbleStackSize": "",
        "bubbleEffectiveStackSizebb":"",
        "bubbleICMDescription5" : "",
        "bubblePercentageDescription5" : "",
        "bubblePreflopDescription5" : "",
        "cbetCBetSuccessBoardTexture":"",
        "cbetCBetSuccessPosition":"",
        "cbetHandStrengthwhenCBettting":"",
        "cbetCBetSpotsHeadsUpvsMultiway":"",
        "cbetCBetSpotsInPositionvsOutofPosition":"",
        "cbetResultsSkippedCBet":"",
        "cbetOverallSuccess" : "",
        "cbetFlopCBetSuccess" : "",
        "cbetCBetWinrate" : "",
        "cbetSkippedCBetWinnings" : "",
        "cbetActionIP": "",
        "cbetActionOOP": "",
        "cbetNoHandsIP": "",
        "cbetNoHandsOOP": "",
        "hands": "",
        "cbetResultsSkippedDonut1Title" : "",
        "cbetResultsSkippedDonutSubtitle" : "",
        "cbetResultsSkippedDonut1TitleNoHands" : "",
        "cbetResultsSkippedDonut2Title" : "",
        "cbetResultsSkippedDonut2TitleNoHands" : "",
        "cbetWonLost" : "",
        "cbetActionHU" : "",
        "cbetActionMultiway" : "",
        "cbetActionHUNoHands" : "",
        "cbetActionMultiwayNoHands" : "",
        "winrateBB100": "",
        "winrate": "",
        "cbetSuccessP":"",
        "leakonomicsWhenUporDownInSession":"",
        "leakonomicsSessionProgress":"",
        "leakonomicsAfterAllinSeries":"",
        "leakonomicsWhenMultitabling":"",
        "leakonomicsVsOpponentbyNoteColor":"",
        "leakonomicsAfterWinningorlosingapot":"",
        "leakonomicsNetWon":"",
        "leakonomicsRollingWindow":"",
        "leakonomicsUpDownSessionNames" : "",
        "leakonomicsBestWrt" : "",
        "leakonomicsBestWrtAt" : "",
        "leakonomicsWinlossSessionNames" : "",
        "leakonomicsAllinRate" : "",
        "leakonomicsWinningP" : "",
        "leakonomicsLosingP" : "",
        "leakonomicsBestWrt2" : "",
        "leakonomicsBestWrtAt2" : "",
        "at": "",
        "leakonomicsWinrateBb100P" : "",
        "leakonomicsPotsLost" : "",
        "leakonomicsPotsWon" : "",
        "leakonomicsPreflopStatsDev" : "",
        "leakonomicsAllinSplit" : "",
        "leakonomicsAllinWinsInaRow" : "",
        "winnings" : "",
        "orLess":"",
        "leakonomicsSessionsSplit" : "",
        "leakonomicsPotAmountWonbb" : "",
        "netWonBb":"",
        "leakonomicsSessionProgressMin" : "",
        "leakonomicsSessionProgressSessionNames" : "",
        "leakonomicsOpponentNoteColor" : "",
        "numberOfTables":"",
        "sessions":"",
        "riverRiverHoleCards":"",
        "riverRiverHandStrength":"",
        "riverRiverAgression":"",
        "riverRiverCallEfficiency":"",
        "riverRiverBetEfficiency":"",
        "riverRiverPotSize":"",
        "wonAtShowdown":"",
        "riverAggression":"",
        "riverCallEff":"",
        "riverBetEff":"",
        "riverWentToShowdown":"",
        "totalHands":"",
        "handFrequencyP":"",
        "riverAsPreflopAggressor":"",
        "riverVsPreflopAggressor":"",
        "riverCheckedToRiver":"",
        "riverHereyoucanfind":"",
        "tip":"",
        "riverCombinethisview":"",
        "riverRiverBetEfficiencyNetWon":"",
        "riverRBE":"",
        "riverCombinethisview2":"",
        "riverMadeRiverCbet":"",
        "riverMadeRiverDonkBet":"",
        "riverSmallriverbets":"",
        "riverBigriverbets":"",
        "riverFacedRiverCbet":"",
        "riverFacedRiverDonkBet":"",
        "riverRiverBet":"",
        "riverRiverCall":"",
        "riverRiverRaise":"",
        "riverRiverFold":"",
        "riverWonHand":"",
        "riverLostHand":"",
        "riverSawShowdown":"",
        "riverNoShowdown":"",
        "riverRiverCallEfficiencyNetWon":"",
        "riverRCE":"",
        "riverCombinethisview3":"",
        "riverHereyoucanfind4":"",
        "riverCombinethisview4":"",
        "riverHereyoucanfind5":"",
        "riverCombinethisview5":"",
        "potSizeFrequencyP":"",
        "riverHereyoucanfind6":"",
        "riverCombinethisview6":"",
        "ipOopTip":"",
        "threebetBetFrequencyTip":"",
        "tourneyallinRaisingCallingByPositionTip":"",
        "riverHandFrequencyTip":"",
        "riverPotSizeFrequencyTip":"",
        "riverCallEfficiencyTip":"",
        "riverBetEfficiencyTip":"",
        "cbetCbetSuccessTip":"",
        "amountBb":"",
        "amountBbPlus":"",
        "amountBb100":"",
        "inPosition":"",
        "outOfPosition":"",
        "overall":"",








        // HM3 Licensing UI
        "backToReleaseNotes": "",
        "backToMyLicense": "",
        "backToCardInfo": "",
        "backToPayment": "",
        "orderBuyNow": "",
        "orderProceed": "",
        "headerTextTrial": "",
        "headerTextFree": "",
        "smallStakes": "",
        "allStakes": "",
        "smallStakesCaps": "",
        "allStakesCaps": "",
        "smallStakesMaintenance": "",
        "allStakesMaintenance": "",
        "buyHoldemSmallStakes": "",
        "buyHoldemAllStakes": "",
        "buyHoldemOmahaAllStakes": "",
        "buyOmahaSmallStakes": "",
        "buyOmahaAllStakes": "",
        "holdemManager": "",
        "holdem": "",
        "omaha": "",
        "hmApps": "",
        "holdemManagerCaps": "",
        "omahaCaps": "",
        "hm3": "",
        "om3": "",
        "hm3andOm3": "",
        "expiredOn": "",
        "expiresOn": "",
        "recommended": "",
        "seeAllOptionsInStore": "",
        "paypalExternalBrowser": "",
        "skrillExternalBrowser": "",
        "selectProduct": "",
        "availableUpdate": "",
        "versionAvailable": "",
        "fullFaq": "",
        "reviewOptions": "",
        "maintenanceOptions": "",
        "addProductToLicense": "",
        "purchasePrice": "",
        "errorName": "",
        "errorAddress": "",
        "errorCountry": "",
        "errorCity": "",
        "errorZip": "",
        "name": "",
        "address": "",
        "city": "",
        "state": "",
        "zip": "",
        "country": "",
        "selectCountry": "",
        "billingInfo": "",
        "buyNowTip": "",
        "licenses": "",
        "version": "",
        "viewReleaseNotes": "",
        "updateAndRenewMaintenance": "",
        "renewGetUpdatesUntil": "",
        "update": "",
        "updateAndSwitchToFree": "",
        "updateAndSwitchToFreeDetails1": "",
        "updateAndSwitchToFreeDetails2": "",
        "updateAndSwitch": "",
        "errorCreditCardDigitsOnly": "",
        "errorCreditCard": "",
        "errorRequired": "",
        "errorCardExpired": "",
        "errorCvv": "",
        "cardInfo": "",
        "cardNo": "",
        "expiry": "",
        "year": "",
        "month": "",
        "month01": "",
        "month02": "",
        "month03": "",
        "month04": "",
        "month05": "",
        "month06": "",
        "month07": "",
        "month08": "",
        "month09": "",
        "month10": "",
        "month11": "",
        "month12": "",
        "cvv": "",
        "active": "",
        "manageSubscription": "",
        "youAreUpToDate": "",
        "releaseNotes": "",
        "netellerInfo": "",
        "netellerSignin": "",
        "continue_": "",
        "netellerAccount": "",
        "netellerPassword": "",
        "orderSummary": "",
        "changeProducts": "",
        "total": "",
        "paypalComplete": "",
        "paypalOpenedInNewBrowser": "",
        "reloadLicense": "",
        "thankYouForPurchase": "",
        "purchaseConfirm1": "",
        "purchaseConfirm2": "",
        "restricted": "",
        "restrictionsWithYourLicense": "",
        "paymentPleaseChoose": "",
        "paymentSelectExisting": "",
        "paymentSelectNew": "",
        "paymentMethod": "",
        "changePaymentMethod": "",
        "licensedTo": "",
        "learnMore": "",
        "startTrial": "",
        "purchase": "",
        "trialSuccessfullyStarted": "",
        "trialSuccessDetails1": "",
        "trialSuccessDetails2": "",
        "trialSuccessDetails3": "",
        "havingTrouble": "",
        "contactUs": "",
        "startUsing": "",
        "missedUpdates": "",
        "updatesAreCritical": "",
        "view": "",
        "oneYearOfUpdates": "",
        "renew": "",
        "startingAt": "",
        "upgrade": "",
        "removesRestrictions1": "",
        "removesRestrictions2": "",
        "removesRestrictions3": "",
        "upgradePrice": "",
        "continueFreemium": "",
        "defaultFatalError": "",
        "restrictCashHandsType": "",
        "restrictTourneyType": "",
        "restrictLimitCashHandsType": "",
        "restrictHudType": "",
        "restrictReportDataType": "",
        "restrictCashHands": "",
        "restrictTourney": "",
        "restrictLimitCashHands": "",
        "restrictHud": "",
        "restrictReportData": "",
        "restrictionUnlimited": "",
        "errorState": "",
        "activeHoldemLicense": "",
        "activeOmahaLicense": "",
        "reinstallOldVersion": "",
        "removesRestrictions3b": "",
        "removesRestrictions4b": "",
        "noActiveHoldemLicense": "",
        "noActiveOmahaLicense": "",
        "free": "",
        "netellerSecureId": "",
        "recurringPriceDescription": "",
        "recurringSubscription": "",
        "positivePrice": "",
        "faq": "",
        "forMoreDetails": "",
        "recurringYear": "",
        "recurringMonth": "",
        "recurringDay": "",
        "restrictionsSmall": "",
        "afterDiscount": "",
        "upgradeDiscount": "",
        "discountExpires": "",
        "discountSinglePurchase": "",
        "errorNetellerAccount": "",
        "errorNetellerSecureId": "",
        "continueTrial": "",
        "continueTrialDaysRemaining": "",
        "netellerInvalidCredentials": "",
        "required":"",
        "paymentSeeWebsite1":"",
        "paymentSeeWebsite2":"",
        "paymentSeeWebsite3":"",
        "paymentOr" : "",
        "couldNotStartMlaTitle":"",
        "couldNotStartMlaText":"",
        "restrictionsWithYourLicenseText":"",

        // 28 oct 2019
        "hm3ForFreeDidYouKnow": "",
        "hm3ForFreeStoreCredit":"",
        "hm3ForFreeToward":"",
        "hm3ForFreeAnyProduct":"",
        "hm3ForFreeExclusive":"",
        "hm3ForFreeSeeDetails":"",
        "hm3ForFreeContinueTrial":"",
        "hm3ForFreeContinueFreemium":"",
        "hm3ForFreeSeeAllOffers":"",
        "continueToHm3ForFree":"",

        // 15 sept 2020
        "versionAvailable2": "",
        "hmAppViewOptions": "",
        "hmAppRemoveRestrictions": "",
        "hmAppActive": "",
        "hmAppActiveUpcase": "",
        "hmAppManage": "",
        "hmAppActivate": "",
        "hmAppWatchVideo": "",
        "hmAppFree": "",
        "hmAppApps": "",
        "hmAppActivated": "",
        "hmAppDayTrial": "",
        "hmAppVersion": "",
        "hmAppIncluding": "",
        "hmAppTrial": "",
        "hmAppPrice": "",
        "hmAppVisitWebsite":"",
        "hmAppContactSupport":"",
        "hmAppActiveAppsLicense":"",
        "hmAppNoActiveAppsLicense":"",
        "hmAppBackToHmApps":"",
        "seeAllOptionsInStoreWeb":"",
        "expiredHeaderTextTrial": "",
        "rangeWizardRestrictionsSmall":"",
        "hmAppsAnnualSupport":"",
        "hmAppOrderSummary":"",
        "hmAppNoHmApps":"",
        "hmAppSubscribe":"",
        "hmOrOmahaRenewal": "",
        "renewalRecurringSubscription":"",
        "renewSingle":"",
        "afterRefund":"",

        "monthSingle":"",
        "monthPlural":"",
        "yearSingle":"",
        "yearPlural":"",
        "hmAppOrderSummaryFree":"",
        "daySingle":"",
        "dayPlural":"",
        "prefixMonthSingle":"",
        "prefixYearSingle":"",
        "prefixDaySingle":"",
        "annual":"",
        "monthly":"",
        "asteriskNotecadyIncluded":"",
    },

    // note: for POEEditor, we need the keys to be enclosed in quotes as well
    en : {
        "hmAppViewOptions": "View Options",
        "hmAppRemoveRestrictions": "Remove Restrictions",
        "hmAppActive": "Active",
        "hmAppActiveUpcase": "ACTIVE",
        "hmAppManage": "Manage",
        "hmAppActivate": "ACTIVATE",
        "hmAppWatchVideo": "Watch Video",
        "hmAppFree": "FREE",
        "hmAppApps": "HM APPS",
        "hmAppActivated": "Activated",
        "hmAppVersion": "version",
        "hmAppDayTrial": "${0}-Day",
        "hmAppIncluding": "Including",
        "hmAppTrial": "Trial",
        "hmAppPrice": "$${0}/${1}",
        "hmAppVisitWebsite":"Visit Website",
        "hmAppContactSupport":"Contact Support",
        "hmAppActiveAppsLicense":"ACTIVE ${0} LICENSE",
        "hmAppNoActiveAppsLicense":"NO ACTIVE ${0} LICENSE",
        "hmAppBackToHmApps":"Back to HM Apps",
        "seeAllOptionsInStoreWeb":"See all options in the store (WEB)",
        "expiredHeaderTextTrial": "Expired Trial",
        "rangeWizardRestrictionsSmall":"NL/PL Cash <b>restricted</b> up to $0.50 big blinds\r\nFL Cash <b>restricted</b> up to $0.50 big blinds\r\nTournaments <b>restricted</b> up to $22.00 buy-ins.",
        "hmAppsAnnualSupport":"Annual Support & Maintenance",
        "hmAppOrderSummary":"${0} will automatically renew every ${1} for the amount of $${2} unless canceled prior to renewal. View ",
        "hmAppNoHmApps":"HM Apps require a paid HM3 license with an active support and maintenance contract. ",
        "hmAppSubscribe":"Subscribe",
        "hmOrOmahaRenewal": "Renew Now",

        "renewalRecurringSubscription":"The annual Support & Maintenance will automatically renew in ${1} (${2}) for $${0}. View",
        "renewSingle":"Renew",
        "afterRefund":"After pro-rated discount of current support & maintenance subscription",
        "monthSingle":"month",
        "monthPlural":"${0} Months",
        "yearSingle":"Year",
        "yearPlural":"${0} Years",
        "hmAppOrderSummaryFree":"${0} is FREE. View ",
        "daySingle":"Day",
        "dayPlural":"${0} Days",

        "prefixMonthSingle":"1 Month",
        "prefixYearSingle":"1 Year",
        "prefixDaySingle":"1 Day",
        "annual":"Annual",
        "monthly":"Monthly",
        "asteriskNotecadyIncluded":"* As a NoteCaddy for HM2 license holder, you will receive 4 months free.",




        // Replayer
        "notAllowedByLicense": "Hand Not Allowed by License",
        "selectHandToExport": "Select Hand To Export",
        "selectFormat": "Select format...",
        "originalFormat": "Original Format",
        "ctrlCToCopy": "Ctrl-C to Copy to Clipboard",
        "availableTags": "Available Tags",
        "welcomeToHm3": "Welcome to the HoldemManager3 Replayer!",
        "theme": "Theme:",
        "deck": "Deck:",
        "showHandResults": "Show Hand Results:",
        "showHeroCards": "Always Show Hero Hole Cards:",
        "showBB": "Show Chips in BB:",
        "combineFolds": "Combine Folds:",
        "maskPlayerNames": "Mask Player Names:",
        "statsUpToTimeOfHand": "Stats Up To Time Of Hand:",
        "showHud": "Show HUD:",
        "replaySpeed": "Replay speed:",
        "hand": "Hand",
        "next100Hands": "Next 100 Hands",
        "prev100Hands": "Prev 100 Hands",
        "addEditHandMarking": "Add/Edit Hand Markings",
        "wonXBB": "Won ${0} BB",
        "lostXBB": "Lost ${0} BB",
        "wonLossNA": "Won/Loss NA",
        "potBB": "Pot: ${0} BB",
        "userWentAllin": "User Went Allin",
        "pot": "Pot: ${0}",
        "potOdds": "Pot Odds: ${0}:1",
        "hhGameStart": "${0} game ${1} begins at ${2}",
        "hhHandNotes": "Hand Note(s)",
        "hhFold": "${0} Folds",
        "hhCheck": "${0} Checks",
        "hhCall": "${0} Calls ${1}",
        "hhBet": "${0} Bets ${1}",
        "hhRaise": "${0} Raises ${1}",
        "hhReturnedTo": "${1} Returned to ${0}",
        "hhWin": "${0} Wins ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "Action has ended.",
        "hhMuck": "${0} mucks ${1}",
        "hhShow": "${0} shows ${1}",
        "hhPostSB": "${0} posts small blind",
        "hhPostBB": "${0} posts big blind",
        "hhPostDB": "${0} posts a dead blind",
        "skipEndOfHandLabel": "Skip End Of Hand",



        // Situational views
        "inPosition":"In Position",
        "outOfPosition":"Out Of Position",
        "amountBb":"${0} bb",
        "amountBbPlus":"${0}+ bb",
        "amountBb100":"${0} bb/100",
        "cbetCbetSuccessTip":"Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip":"${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip":"${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip":"Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip":"Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip":"${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip":"3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip":"${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6":"Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6":"Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP":"Pot Size Frequency (%)",
        "riverHereyoucanfind5":"Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5":"Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4":"Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4":"Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon":"River Call Efficiency Net Won",
        "riverRCE":"River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3":"Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown":"Saw Showdown",
        "riverNoShowdown":"No Showdown",
        "riverMadeRiverCbet":"Made River Cbet",
        "riverMadeRiverDonkBet":"Made River Donk Bet",
        "riverSmallriverbets":"Small river bets (<50% pot)",
        "riverBigriverbets":"Big river bets (>100% pot)",
        "riverFacedRiverCbet":"Faced River Cbet",
        "riverFacedRiverDonkBet":"Faced River Donk Bet",
        "riverRiverBet":"River Bet",
        "riverRiverCall":"River Call",
        "riverRiverRaise":"River Raise",
        "riverRiverFold":"River Fold",
        "riverWonHand":"Won Hand",
        "riverLostHand":"Lost Hand",
        "riverRiverBetEfficiencyNetWon":"River Bet Efficiency Net Won",
        "riverRBE":"River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2":"Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind":"Here you can find how aggressively you play on the river and your results for each action played.",
        "tip":"Tip",
        "riverCombinethisview":"Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor":"As Preflop Aggressor",
        "riverVsPreflopAggressor":"Vs Preflop Aggressor",
        "riverCheckedToRiver":"Checked To River",
        "handFrequencyP":"Hand Frequency (%)",
        "totalHands":"Total Hands",
        "wonAtShowdown":"Won At Showdown",
        "riverAggression":"River Aggression",
        "riverCallEff":"River Call Eff",
        "riverBetEff":"River Bet Eff",
        "riverWentToShowdown":"Went To Showdown",
        "riverRiverHoleCards":"River Hole Cards",
        "riverRiverHandStrength":"River Hand Strength",
        "riverRiverAgression":"River Agression %",
        "riverRiverCallEfficiency":"River Call Efficiency",
        "riverRiverBetEfficiency":"River Bet Efficiency",
        "riverRiverPotSize":"River Pot Size",
        "numberOfTables":"Number Of Tables",
        "sessions":"Sessions",
        "leakonomicsOpponentNoteColor" : "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames" : "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin" : "Session Progress (Min)",
        "netWonBb":"Net Won (bb)",
        "leakonomicsSessionsSplit" : "Sessions Split",
        "leakonomicsPotAmountWonbb" : "Pot Amount Won (bb)",
        "orLess":"${0} or less",
        "leakonomicsAllinSplit" : "All-in Split",
        "leakonomicsAllinWinsInaRow" : "All-in Wins in a Row",
        "winnings" : "Winnings",
        "leakonomicsRollingWindow":"Rolling Window Graph",
        "leakonomicsNetWon":"Net Won Up/Down",
        "leakonomicsUpDownSessionNames" : "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev" : "Preflop Stats Dev",
        "leakonomicsBestWrt" : "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt" : "At ${0} min",
        "leakonomicsWinlossSessionNames" : "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate" : "All-in Rate",
        "leakonomicsWinningP" : "Winning: ${0}%",
        "leakonomicsLosingP" : "Losing: ${0}%",
        "leakonomicsBestWrt2" : "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2" : "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P" : "Winrate: 5bb/100",
        "leakonomicsPotsLost" : "Pots lost: ${0}%",
        "leakonomicsPotsWon" : "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession":"When Up or Down In Session",
        "leakonomicsSessionProgress":"Session Progress",
        "leakonomicsAfterAllinSeries":"After All-in Series",
        "leakonomicsWhenMultitabling":"When Multitabling",
        "leakonomicsVsOpponentbyNoteColor":"Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot":"After Winning or losing a pot",
        "cbetSuccessP":"CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU" : "CBet action: Heads Up",
        "cbetActionMultiway" : "CBet action: Multiway",
        "cbetActionHUNoHands" : "Heads Up: No Hands",
        "cbetActionMultiwayNoHands" : "Multiway: No Hands",
        "cbetWonLost" : "$ Won / Lost",
        "cbetResultsSkippedDonut1Title" : "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle" : "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands" : "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title" : "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands" : "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess" : "Overall Success",
        "cbetFlopCBetSuccess" : "Flop CBet Success",
        "cbetCBetWinrate" : "CBet Winrate",
        "cbetSkippedCBetWinnings" : "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture":"CBet Success: Board Texture",
        "cbetCBetSuccessPosition":"CBet Success: Position",
        "cbetHandStrengthwhenCBettting":"Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway":"CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition":"CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet":"Results Skipped CBet",
        "bubbleICMDescription5" : "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5" : "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5" : "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb":"Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants" : "Sit 'N Go Entrants",
        "bubbleICMDescription4" : "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4" : "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4" : "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition" : "Bubble Position",
        "bubbleICMDescription3" : "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3" : "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3" : "Your preflop stats categorized by your position",
        "bubblePreflopDescription2" : "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble" : "# Players At Bubble",
        "bubbleBubblePlayers" : "Bubble Players at Bubble",
        "bubblePrizePoolP":"Prize Pool%",
        "bubbleBubbleStage":"Bubble Stage",
        "bubbleEVbb100hands":"EV BB/100 Hands",
        "bubbleICMDescription" : "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription" : "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription" : "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon":"Prize Pool Won",
        "bubbleExpectedValue":"Expected Value",
        "bubbleAverageStack":"Average Stack",
        "bubbleCallAIWinrate":"Call AI Winrate",
        "bubbleShoveAIWinrate":"Shove AI Winrate",
        "tooFewHands":"Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle" : "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle" : "Expectation When Reaching Bubble",
        "bubblePositionTitle" : "Position",
        "bubbleBeforeAndAfterTitle" : "Before And After",
        "bubbleStackSizeTitle" : "Stack Size",
        "bubbleCallRangesTitle" : "Call Ranges",
        "bubbleShoveRangesTitle" : "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey":"Winrate",
        "threebetThreeBetPercentKey":"3-Bet %",
        "threebetWinrateAxis":"Winrate (bb/100)",
        "threebetThreeBetPercentAxis":"3-Bet %",
        "threebetSuccessPercentAxis":"Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString":  "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary":  "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots":  "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF" ,
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF" ,
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF" ,
        "ERRaiseCallVsVillainOpenAllinPreflop" : "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall":"Overall",



        // HM3 Licensing UI
        "backToReleaseNotes": "Back To Release Notes",
        "backToMyLicense": "Back to My License",
        "backToCardInfo": "Back to Credit Card Info",
        "backToPayment": "Back to Payment Method",
        "orderBuyNow": "Buy Now",
        "orderProceed": "Proceed",
        "headerTextTrial": "Trial (${0} Days Remaining)",
        "headerTextFree": "Free",
        "smallStakes": "Small Stakes",
        "allStakes": "All Stakes",
        "smallStakesCaps": "SMALL STAKES",
        "allStakesCaps": "ALL STAKES",
        "smallStakesMaintenance": "SMALL STAKES MAINTENANCE",
        "allStakesMaintenance": "ALL STAKES MAINTENANCE",
        "buyHoldemSmallStakes": "Holdem Small Stakes",
        "buyHoldemAllStakes": "Holdem All Stakes",
        "buyHoldemOmahaAllStakes": "All Stakes",
        "buyOmahaSmallStakes": "Omaha Small Stakes",
        "buyOmahaAllStakes": "Omaha All Stakes",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "HM Apps",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Expired on ${0}",
        "expiresOn": "Expires on ${0}",
        "recommended": "RECOMMENDED",
        "seeAllOptionsInStore": "See all options in the Store",
        "paypalExternalBrowser": "PayPal will open in an external browser to complete the payment process.",
        "skrillExternalBrowser": "Skrill will load in an external browser to complete the payment process.",
        "selectProduct": "SELECT PRODUCT",
        "availableUpdate": "AVAILABLE UPDATE:",
        "versionAvailable": "Version ${0} is available: ${1}",
        "versionAvailable2": "Version ${0} is available",
        "fullFaq": "Full release notes FAQ",
        "reviewOptions": "Review your Holdem maintenance options before proceeding with the update",
        "maintenanceOptions": "Maintenance Options",
        "addProductToLicense": "ADD ${0} TO YOUR CURRENT LICENSE",
        "purchasePrice": "Purchase (${0})",
        "errorName": "Please enter your Full Name",
        "errorAddress": "Please enter your Street name and number",
        "errorCountry": "Please enter your Country",
        "errorCity": "Please enter your City",
        "errorZip": "Please enter a valid Zip Code",
        "billingInfo": "BILLING INFO",
        "name": "Full Name",
        "address": "Street Address",
        "city": "City",
        "state": "State/Province",
        "zip": "Zip/Postal Code",
        "country": "Country",
        "selectCountry": "Select a country",
        "buyNowTip": "Please select an existing or new payment method before proceeding",
        "licenses": "LICENSES",
        "version": "Version ${0}",
        "viewReleaseNotes": "View release notes on website",
        "updateAndRenewMaintenance": "UPDATE & RENEW MAINTENANCE",
        "renewGetUpdatesUntil": "By renewing maintenance you will receive all HM3 updates through ${0}",
        "update": "Update",
        "updateAndSwitchToFree": "UPDATE & SWITCH TO FREE VERSION",
        "updateAndSwitchToFreeDetails1": "You will receive the update but your HM3 (Holdem) software will revert to Free version and will have",
        "updateAndSwitchToFreeDetails2": "limited functionality",
        "updateAndSwitch": "Update & Switch",
        "errorCreditCardDigitsOnly": "The credit card number should contain digits only.",
        "errorCreditCard": "Please enter a valid card number.",
        "errorRequired": "Required",
        "errorCardExpired": "Card Expired",
        "errorCvv": "CVV should be ${0} digits in length",
        "cardInfo": "CREDIT CARD INFO",
        "cardNo": "Card No",
        "expiry": "Expiry",
        "year": "year",
        "month": "month",
        "month01": "Jan",
        "month02": "Feb",
        "month03": "Mar",
        "month04": "Apr",
        "month05": "May",
        "month06": "Jun",
        "month07": "Jul",
        "month08": "Aug",
        "month09": "Sep",
        "month10": "Oct",
        "month11": "Nov",
        "month12": "Dec",
        "cvv": "CVV",
        "active": "Active",
        "manageSubscription": "Manage Subscription",
        "youAreUpToDate": "You are up to date",
        "releaseNotes": "Release notes for ${0}",
        "netellerInfo": "NETELLER Account Information",
        "netellerSignin": "Sign into your NETELLER account to complete your purchase",
        "continue_": "Continue",
        "netellerAccount": "NETELLER email or Account ID",
        "netellerPassword": "Password",
        "orderSummary": "ORDER SUMMARY:",
        "changeProducts": "Change Product(s)",
        "total": "Total",
        "paypalComplete": "PLEASE COMPLETE YOUR PAYPAL PURCHASE IN YOUR BROWSER",
        "paypalOpenedInNewBrowser": "We have opened PayPal in your default internet browser window. Please login to your PayPal account and complete the purchase. Once the purchase has been completed, return here and click 'Reload License' to load the license that you have purchased.",
        "reloadLicense": "Reload License",
        "thankYouForPurchase": "Thank You For Your Purchase",
        "purchaseConfirm1": "You will receive an email confirmation shortly at ${0}",
        "purchaseConfirm2": "Please click the reload license button below and your purchased license will be active.",
        "restricted": "restricted",
        "restrictionsWithYourLicense": "RESTRICTIONS WITH YOUR CURRENT LICENSE",
        "paymentPleaseChoose": "Please choose a payment method",
        "paymentMethod": "Payment Method:",
        "changePaymentMethod": "Change Payment Method",
        "licensedTo": "LICENSED TO",
        "learnMore": "Learn more",
        "startTrial": "Start Trial",
        "purchase": "Purchase",
        "trialSuccessfullyStarted": "Trial Successfully Started",
        "trialSuccessDetails1": "Your 14 day trial is now active. Please",
        "trialSuccessDetails2": "upgrade",
        "trialSuccessDetails3": " as soon as possible to avoid interruptions to your service.",
        "havingTrouble": "Having trouble?",
        "contactUs": "Contact Us",
        "startUsing": "Start using HM3 Now",
        "missedUpdates": "${0} missed updates",
        "updatesAreCritical": "Updates are critical to ensuring that HM3 continues to import your hand histories after poker sites make changes to their software. New features and functionalities are also released through updates.",
        "view": "View",
        "oneYearOfUpdates": "Includes ${0} of updates",
        "renew": "Renew (${0})",
        "startingAt": "Starting At",
        "upgrade": "Upgrade",
        "removesRestrictions1": "Removes",
        "removesRestrictions2": "restrictions",
        "removesRestrictions3": " and includes ${0} of updates",
        "upgradePrice": "Upgrade (${0})",
        "required":"Required",
        "continueFreemium": "Continue Free Version",
        "defaultFatalError": "An unexpected internal server error has occurred and an administrator has been notified. Please try purchasing again later.",
        "restrictCashHandsType": "Cash Hands",
        "restrictTourneyType": "Tournament",
        "restrictLimitCashHandsType":"Limit Cash Hands",
        "restrictHudType": "HUD",
        "restrictReportDataType":"Report Data",
        "restrictCashHands": "$ ${0} and below",
        "restrictLimitCashHands":"$ ${0} and below",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Table(s)",
        "restrictReportData":"Last ${0} Hands",
        "restrictionUnlimited": "Unlimited",
        "errorState": "Required",
        "activeHoldemLicense":"ACTIVE HOLDEM LICENSE",
        "activeOmahaLicense":"ACTIVE OMAHA LICENSE",
        "reinstallOldVersion":"Reinstall Old Version",
        "removesRestrictions3b": "and reverts back to your paid license but updates are",
        "removesRestrictions4b": "NOT INCLUDED",
        "noActiveHoldemLicense":"NO ACTIVE HOLDEM LICENSE",
        "noActiveOmahaLicense":"NO ACTIVE OMAHA LICENSE",
        "free": "FREE",
        "netellerSecureId":"Your NETELLER Secure ID",
        "recurringPriceDescription":"${0} Included*",
        "recurringYear":"Year",
        "recurringMonth":"Month",
        "recurringDay":"Day",
        "restrictionsSmall":"No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\r\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\r\nTournaments <b>restricted</b> up to $22.00 buy-ins.",
        "afterDiscount":"Price after limited time discount",
        "upgradeDiscount":"UPGRADE DISCOUNT",
        "discountSinglePurchase":"Discount applies to a single purchase.",
        "errorNetellerAccount": "Invalid Neteller Account ID",
        "errorNetellerSecureId": "Please enter your 6-digit Secure ID",
        "continueTrial": "Continue Trial",
        "continueTrialDaysRemaining": "(${0} Days Remaining)",
        "netellerInvalidCredentials":"We could not validate your Neteller credentials. Please try logging in again.",
        "faq": "FAQ",
        "forMoreDetails":" for more details on managing your annual Support & Maintenance renewal.",
        "recurringSubscription":"* Payment method is required for the annual Support & Maintenance renewal of $${0} which will be billed in ${1} (${2}). View",
        "positivePrice":"* The annual Support & Maintenance renewal of $${0} will be billed in ${1} (${2}). View",
        "paymentSeeWebsite1":"See",
        "paymentSeeWebsite2":"STORE",
        "paymentSeeWebsite3":" for other payment options",
        "paymentSelectExisting": "Select existing payment method:",
        "paymentSelectNew": "Add new payment method:",
        "paymentOr" : "- OR -",
        "discountExpires":"Discount Expires on ${0}",
        "couldNotStartMlaTitle":"We encountered a problem",
        "couldNotStartMlaText":"Could Not Start My Licenses. An Administrator has been notified. Please check again later. If the problem persists, please contact our support.",
        "restrictionsWithYourLicenseText":"<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration",

        // 28 oct 2019
        "hm3ForFreeDidYouKnow": "Did you know you could get HM3 for FREE!",
        "hm3ForFreeStoreCredit":"CREDIT",
        "hm3ForFreeToward":"toward",
        "hm3ForFreeAnyProduct":"ANY Hold'em Manager product",
        "hm3ForFreeExclusive":"Exclusive Offer From",
        "hm3ForFreeSeeDetails":"See Offer Details",
        "hm3ForFreeContinueTrial":"Continue To Trial Version",
        "hm3ForFreeContinueFreemium":"Continue To Free Version",
        "hm3ForFreeSeeAllOffers":"See all \"Get It Free\" offers in our store",
        "continueToHm3ForFree":"Continue",

    },




    chinese :{
        "notAllowedByLicense": "许可证不允许的手牌",
        "selectHandToExport": "选择手牌并导出",
        "selectFormat": "选择格式……",
        "originalFormat": "原始格式",
        "ctrlCToCopy": "Ctrl-C，复制到剪切板",
        "availableTags": "可用标签",
        "welcomeToHm3": "欢迎来到HoldemManager3回放器！",
        "theme": "主题:",
        "deck": "一副扑克牌:",
        "showHandResults": "显示手牌结果:",
        "showHeroCards": "一直显示前手底牌:",
        "showBB": "显示大盲位上的筹码:",
        "combineFolds": "综合弃牌:",
        "maskPlayerNames": "隐藏玩家姓名:",
        "statsUpToTimeOfHand": "统计值达到了手牌时间：",
        "showHud": "显示HUD：",
        "replaySpeed": "回放速度：",
        "hand": "手牌",
        "next100Hands": "下100张手牌",
        "prev100Hands": "前100张手牌",
        "addEditHandMarking": "添加/编辑手牌标记",
        "wonXBB": "赢得${0}大盲注",
        "lostXBB": "损失${0}大盲注",
        "wonLossNA": "赢得/损失NA",
        "potBB": "彩池：${0}大盲注",
        "userWentAllin": "用户押上了全部赌注",
        "pot": "彩池：${0}",
        "potOdds": "彩池概率：${0}:1",
        "hhGameStart": "${0}游戏${1}开始于${2}",
        "hhHandNotes": "手牌记录",
        "hhFold": "${0}弃牌",
        "hhCheck": "${0}看牌",
        "hhCall": "${0} 跟注 ${1}",
        "hhBet": "${0} 下注 ${1}",
        "hhRaise": "${0} 加注 ${1}",
        "hhReturnedTo": "${1}回报${0}",
        "hhWin": "${0}赢得${1}",
        "hhRake": "佣金：${0}",
        "hhActionEnded": "操作已结束。",
        "hhMuck": "${0}盖牌 ${1}",
        "hhShow": "${0}显示 ${1}",
        "hhPostSB": "${0}发布小盲注",
        "hhPostBB": "${0}发布大盲注",
        "hhPostDB": "${0}发布死盲注",
        "backToReleaseNotes": "返回发行说明",
        "backToMyLicense": "返回我的许可证",
        "backToCardInfo": "返回信用卡信息",
        "backToPayment": "返回支付方式",
        "orderBuyNow": "立即购买",
        "orderProceed": "继续",
        "headerTextTrial": "试用（还有${0}天）",
        "headerTextFree": "免费",
        "smallStakes": "小额赌注",
        "allStakes": "全部赌注",
        "smallStakesCaps": "小额赌注",
        "allStakesCaps": "全部赌注",
        "smallStakesMaintenance": "小额赌注维护",
        "allStakesMaintenance": "全部赌注维护",
        "buyHoldemSmallStakes": "德州扑克小额赌注",
        "buyHoldemAllStakes": "德州扑克全部赌注",
        "buyHoldemOmahaAllStakes": "全部赌注",
        "buyOmahaSmallStakes": "奥马哈扑克小额赌注",
        "buyOmahaAllStakes": "奥马哈扑克全部赌注",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "奥马哈扑克",
        "holdem": "德州扑克",
        "omaha": "奥马哈扑克",
        "hmApps": "HM应用",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "于${0}到期",
        "expiresOn": "于 ${0}到期",
        "recommended": "推荐",
        "seeAllOptionsInStore": "查看商店所有选项",
        "paypalExternalBrowser": "PayPal将在外部浏览器中打开，完成支付过程。",
        "skrillExternalBrowser": "Skrill将在外部浏览器中加载，完成支付过程。",
        "selectProduct": "选择产品",
        "availableUpdate": "可用更新：",
        "versionAvailable": "版本${0} 可用： ${1}",
        "fullFaq": "完整发行说明常见问答",
        "reviewOptions": "在继续进行升级前，请查看您的德州扑克维护选项",
        "maintenanceOptions": "维护选项",
        "addProductToLicense": "将 ${0} 添加到您当前的许可证",
        "purchasePrice": "购买(${0})",
        "errorName": "请输入您的完整姓名",
        "errorAddress": "请输入您的街道名和编号",
        "errorCountry": "请输入您的国家",
        "errorCity": "请输入您的城市",
        "errorZip": "请输入有效邮编",
        "billingInfo": "账单信息",
        "name": "完整姓名",
        "address": "街道地址",
        "city": "城市",
        "state": "州/省",
        "zip": "邮编",
        "country": "国家",
        "selectCountry": "选择一个国家",
        "buyNowTip": "在继续之前，请选择现有的或新的支付方式",
        "licenses": "许可证",
        "version": "版本 ${0}",
        "viewReleaseNotes": "查看网站上的发行说明",
        "updateAndRenewMaintenance": "升级与更新维护",
        "renewGetUpdatesUntil": "通过更新维护，您将获得通过${0}完成的全部HM3升级",
        "update": "升级",
        "updateAndSwitchToFree": "升级并切换到免费版",
        "updateAndSwitchToFreeDetails1": "您将得以升级，但是您的HM3（德州扑克）软件将转为免费版并将有",
        "updateAndSwitchToFreeDetails2": "功能有限",
        "updateAndSwitch": "升级与切换",
        "errorCreditCardDigitsOnly": "信用卡号应只包含数字。",
        "errorCreditCard": "请输入有效的信用卡号。",
        "errorRequired": "需要",
        "errorCardExpired": "卡已过期",
        "errorCvv": "CVV长度应为{0}个数字",
        "cardInfo": "信用卡信息",
        "cardNo": "卡号",
        "expiry": "有效期",
        "year": "年",
        "month": "月",
        "month01": "一月",
        "month02": "二月",
        "month03": "三月",
        "month04": "四月",
        "month05": "五月",
        "month06": "六月",
        "month07": "七月",
        "month08": "八月",
        "month09": "九月",
        "month10": "十月",
        "month11": "十一月",
        "month12": "十二月",
        "cvv": "CVV",
        "active": "有效",
        "manageSubscription": "管理订阅",
        "youAreUpToDate": "您的版本是最新版本",
        "releaseNotes": "${0}发行说明",
        "netellerInfo": "NETELLER账户信息",
        "netellerSignin": "登录您的NETELLER账户，完成购买",
        "continue_": "继续",
        "netellerAccount": "NETELLER账户",
        "netellerPassword": "密码",
        "orderSummary": "订单汇总：",
        "changeProducts": "更换产品",
        "total": "总计",
        "paypalComplete": "请在您的浏览器中完成您的PAYPAL购买",
        "paypalOpenedInNewBrowser": "我们在您的默认网络浏览器窗口中打开了 PayPal。请登录您的 PayPal账户，完成本次购买。购买完成后，请返回到这里，点击‘重新加载许可证’，加载已购买的许可证。",
        "reloadLicense": "重新加载许可证",
        "thankYouForPurchase": "感谢您的购买",
        "purchaseConfirm1": "您很快将在${0}收到一封确认邮件。",
        "purchaseConfirm2": "请点击下方的重新加载许可证按钮，您购买的许可证将激活。",
        "restricted": "有限制的",
        "restrictionsWithYourLicense": "当前许可证的限制",
        "paymentPleaseChoose": "请选择一种支付方式",
        "paymentSelectExisting": "选择现有的支付方式：",
        "paymentSelectNew": "添加新的支付方式：",
        "paymentMethod": "支付方式：",
        "changePaymentMethod": "变更支付方式",
        "licensedTo": "授权给",
        "learnMore": "了解更多",
        "startTrial": "开始试用",
        "purchase": "购买",
        "trialSuccessfullyStarted": "成功开始试用",
        "trialSuccessDetails1": "您的14天试用现在已激活。请",
        "trialSuccessDetails2": "升级",
        "trialSuccessDetails3": " 尽早完成，避免打断您的服务。",
        "havingTrouble": "遇到问题？",
        "contactUs": "联系我们",
        "startUsing": "立即开始使用HM3",
        "missedUpdates": "${0}错过了升级",
        "updatesAreCritical": "扑克网站更改软件后，要保证HM3持续导入您的手牌历史，升级至关重要。通过升级还发布了全新的特征和功能。",
        "view": "查看",
        "oneYearOfUpdates": "包括一年的升级",
        "renew": "更新(${0})\n",
        "startingAt": "启动时间",
        "upgrade": "升级",
        "removesRestrictions1": "移除",
        "removesRestrictions2": "限制",
        "removesRestrictions3": " 并包括一年的升级",
        "upgradePrice": "升级(${0})",
        "required": "需要",
        "continueFreemium": "继续使用免费版本",
        "defaultFatalError": "内部服务器出现意外错误，已通知管理员。请稍后再次尝试购买。",
        "restrictCashHandsType": "现金手牌",
        "restrictTourneyType": "锦标赛",
        "restrictLimitCashHandsType": "限制现金手牌",
        "restrictHudType": "HUD",
        "restrictReportDataType": "报告数据",
        "restrictCashHands": "$ ${0}及以下",
        "restrictLimitCashHands": "$ ${0}及以下",
        "restrictTourney": "最多${0}",
        "restrictHud": "最多${0} 张牌桌",
        "restrictReportData": "最后${0}手牌",
        "restrictionUnlimited": "不限",
        "errorState": "需要",
        "activeHoldemLicense": "有效的德州扑克许可证",
        "activeOmahaLicense": "有效的奥马哈扑克许可证",
        "reinstallOldVersion": "重新安装旧版",
        "removesRestrictions3b": "返回到您已支付的许可证，但是升级是",
        "removesRestrictions4b": "不包含",
        "noActiveHoldemLicense": "没有有效的德州扑克许可证",
        "noActiveOmahaLicense": "没有有效的奥马哈扑克许可证",
        "free": "免费",
        "netellerSecureId": "安全ID",
        "recurringPriceDescription": "包括${0} ${1}*",
        "recurringYear": "年",
        "recurringMonth": "月",
        "recurringDay": "日",
        "restrictionsSmall": "无限注/底池限注现金 <b>限制</b>为$0.50大盲注 有限注现金<b>限制</b>为 $1.00大盲注 锦标赛<b>限制</b>为$22.00买入。",
        "afterDiscount": "限时折扣后的价格",
        "upgradeDiscount": "升级折扣",
        "discountExpires": "折扣将于${0}到期",
        "discountSinglePurchase": "折扣适用于单次购买。",
        "errorNetellerAccount": "无效的Neteller账户ID",
        "errorNetellerSecureId": "请输入您的6位数安全ID",
        "continueTrial": "继续试用",
        "continueTrialDaysRemaining": "（还剩下${0}天）",
        "netellerInvalidCredentials": "我们无法验证您的Neteller凭证。请尝试再次登录。",
        "faq": "常见问答",
        "forMoreDetails": " 了解更多关于管理您年度支持与维护更新的详情。",
        "recurringSubscription": "*$${0}的年度支持与维护更新（将在一年 (${1})后入账）需要支付方式。查看",
        "positivePrice": "$${0}的年度支持与维护更新将在一年 (${1})后入账。查看",
        "paymentSeeWebsite1": "查看",
        "paymentSeeWebsite2": "商店",
        "paymentSeeWebsite3": " 了解其他支付选项",
        "paymentOr": "- 或者 -",
        "couldNotStartMlaTitle": "我们遇到了一个问题",
        "couldNotStartMlaText": "无法启用我的许可证。已通知管理员。请稍后查看。如果问题仍然存在，请联系我们的帮助人员。",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    french : {
        "notAllowedByLicense": "Main non autorisée par la licence",
        "selectHandToExport": "Sélectionnez la main pour l'exporter",
        "selectFormat": "Sélectionnez le format...",
        "originalFormat": "Format d'origine",
        "ctrlCToCopy": "Faites CTRL + C  pour copier dans le presse-papier",
        "availableTags": "Tags disponibles",
        "welcomeToHm3": "Bienvenue sur le dispositif de rediffusion de Holdem Manager3 !",
        "theme": "Thème : ",
        "deck": "Jeu : ",
        "showHandResults": "Montrez les résultats pour la.les main.s :",
        "showHeroCards": "Toujours montrer les cartes cachées ou fermées (\"Hole Cards\")",
        "showBB": "Afficher les jetons en Grande blinde (BB) :",
        "combineFolds": "Combiner les couchers (\"Folds\") : ",
        "maskPlayerNames": "Masquer le nom des joueurs :",
        "statsUpToTimeOfHand": "Les stats jusqu'à l'heure de la main :",
        "showHud": "Montrer l'affichage tête haute (HUD) :",
        "replaySpeed": "Remontrer la vitesse :",
        "hand": "Main",
        "next100Hands": "Les 100 prochaines mains",
        "prev100Hands": "Les 100 mains précédentes",
        "addEditHandMarking": "Ajouter/modifier les marquages de main",
        "wonXBB": "A gagné ${0} en  BB",
        "lostXBB": "A perdu ${0} en  BB",
        "wonLossNA": "Gain/perte en NA",
        "potBB": "Cagnotte: ${0} en BB",
        "userWentAllin": "L'utilisateur a misé tous ses jetons sur le tapis",
        "pot": "Cagnotte: ${0}",
        "potOdds": "Cote de la cagnotte : ${0} : 1",
        "hhGameStart": "${0} partie ${1} commence à $ {2}",
        "hhHandNotes": "Note(s) sur la.les main.s",
        "hhFold": "Couchers ${0}",
        "hhCheck": "Paroles (\"checks\") ${0}",
        "hhCall": "${0} Calls ${1}",
        "hhBet": "${0} Mises ${1}",
        "hhRaise": "${0} Hausses ${1}",
        "hhReturnedTo": "${1} retour à  ${0}",
        "hhWin": "${0} rapporte.nt ${1}",
        "hhRake": "Commission: ${0}",
        "hhActionEnded": "L'action est terminée.",
        "hhMuck": "${0} mains face cachée ${1}",
        "hhShow": "${0} montre.nt ${1}",
        "hhPostSB": "${0} publie une petite blinde (SB)",
        "hhPostBB": " $ {0} publie une grosse blinde (BB)",
        "hhPostDB": "${0} publie une blinde morte (\"Dead Blind\")",
        "backToReleaseNotes": "Retour à l'affichage des notes",
        "backToMyLicense": "Retour à ma licence",
        "backToCardInfo": "Retour aux coordonnées de CB",
        "backToPayment": "Retour au moyen de paiement",
        "orderBuyNow": "Acheter tout de suite",
        "orderProceed": "Continuer",
        "headerTextTrial": "Période d'essai (${0} jours restants)",
        "headerTextFree": "Gratuit.e",
        "smallStakes": "Petites mises",
        "allStakes": "Toutes les mises",
        "smallStakesCaps": "PETITES MISES",
        "allStakesCaps": "TOUTES LES MISES",
        "smallStakesMaintenance": "MAINTENANCE DES PETITES MISES EN COURS",
        "allStakesMaintenance": "MAINTENANCE DE TOUTES LES MISES EN COURS",
        "buyHoldemSmallStakes": "Petites mises Holdem",
        "buyHoldemAllStakes": "Toutes les mises Holdem",
        "buyHoldemOmahaAllStakes": "Toutes les mises",
        "buyOmahaSmallStakes": "Petites mises Omaha",
        "buyOmahaAllStakes": "Toutes les mises Omaha",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "Applis HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Est arrivé.e à échéance le ${0}",
        "expiresOn": "Arrivera à échéance le ${0}",
        "recommended": "RECOMMANDÉ.E.S",
        "seeAllOptionsInStore": "Voir toutes les possibilités dans la boutique",
        "paypalExternalBrowser": "Paypal est sur le point d'ouvrir une nouvelle fenêtre pour finaliser votre règlement.",
        "skrillExternalBrowser": "Skrill est sur le point d'ouvrir une nouvelle fenêtre pour finaliser votre règlement.",
        "selectProduct": "SÉLECTIONNEZ VOTRE PRODUIT",
        "availableUpdate": "MISE À JOUR DE LA DISPONIBILITÉ:",
        "versionAvailable": "La version ${0} est disponible : ${1}",
        "fullFaq": "Foire aux questions complète sur les notes de publication",
        "reviewOptions": "Consultez vos options de maintenance Holdem avant de procéder à la mise à jour.",
        "maintenanceOptions": "Options de maintenance",
        "addProductToLicense": "AJOUTEZ ${0} À VOTRE LICENCE ACTUELLE",
        "purchasePrice": "Achat (${0})",
        "errorName": "Veuillez saisir votre nom complet.",
        "errorAddress": "Veuillez saisir le nom de votre rue et le numéro.",
        "errorCountry": "Veuillez saisir votre pays.",
        "errorCity": "Veuillez saisir votre ville.",
        "errorZip": "Veuillez saisir un code postal valide.",
        "billingInfo": "COORDONN\u000eÉES DE FACTURATION",
        "name": "Nom complet",
        "address": "Adresse postale",
        "city": "Ville",
        "state": "État/province",
        "zip": "Code postal",
        "country": "Pays",
        "selectCountry": "Sélectionnez un pays.",
        "buyNowTip": "Veuillez sélectionner le mode de paiement actuel ou souhaité avant de continuer.",
        "licenses": "LICENCES",
        "version": "Version ${0}",
        "viewReleaseNotes": "Affichez les notes de publication de la version sur le site Internet",
        "updateAndRenewMaintenance": "METTRE À JOUR ET RENOUVELER LA MAINTENANCE",
        "renewGetUpdatesUntil": "En acceptant de renouveler la maintenance, vous recevrez toutes les mises à jour HM3 par le biais de ${0}",
        "update": "Mettre à jour",
        "updateAndSwitchToFree": "METTRE À JOUR ET PASSER À LA VERSION GRATUITE",
        "updateAndSwitchToFreeDetails1": "Vous recevrez la mise à jour, mais votre logiciel MH3 (Holdem) passera de nouveau  à la version gratuite et vous ne disposerez plus que de",
        "updateAndSwitchToFreeDetails2": "fonctions limitées.",
        "updateAndSwitch": "Mettre à jour et commuter",
        "errorCreditCardDigitsOnly": "Le numéro de votre carte de paiement ne doit comporter que des chiffres.",
        "errorCreditCard": "Veuillez saisir un numéro de carte de paiement valable.",
        "errorRequired": "Champ obligatoire",
        "errorCardExpired": "Votre carte n'est plus valable.",
        "errorCvv": "Le CVV ne doit comporter que ${0} chiffres.",
        "cardInfo": "COORDONNÉES DE LA CARTE DE PAIEMENT",
        "cardNo": "Carte N°",
        "expiry": "Date d'échéance",
        "year": "année",
        "month": "mois",
        "month01": "janvier",
        "month02": "février",
        "month03": "mars",
        "month04": "avril",
        "month05": "mai",
        "month06": "juin",
        "month07": "juillet",
        "month08": "août",
        "month09": "septembre",
        "month10": "octobre",
        "month11": "novembre",
        "month12": "décembre",
        "cvv": "CVV",
        "active": "Activé.e",
        "manageSubscription": "Gérer mon abonnement",
        "youAreUpToDate": "Vous êtes à jour.",
        "releaseNotes": "Notes de publication pour ${0}",
        "netellerInfo": "Coordonnées du compte NETELLER",
        "netellerSignin": "Connectez-vous à votre compte NETTELLER pour terminer votre achat.",
        "continue_": "Continuer",
        "netellerAccount": "Compte Neteller",
        "netellerPassword": "Mot de passe",
        "orderSummary": "RÉCAPITULATIF DE LA COMMANDE :",
        "changeProducts": "Remplacer un.des produit.s",
        "total": "Total",
        "paypalComplete": "VEUILLEZ PROCÉDER À VOTRE ACHAT SUR PAYPAL DANS LA FENÊTRE À CET EFFET",
        "paypalOpenedInNewBrowser": "Nous avons ouvert Paypal dans la fenêtre de votre navigateur Internet par défaut. Veuillez vous connecter à votre compte Paypal pour finaliser l'achat. Une fois que celui-ci sera terminé, revenez sur cette page, puis cliquez sur \"Télécharger de nouveau la licence\" pour acquérir la licence que vous aurez réglée.\n",
        "reloadLicense": "Télécharger de nouveau la licence",
        "thankYouForPurchase": "Nous vous remercions de votre achat.",
        "purchaseConfirm1": "Vous recevrez prochainement un courriel de confirmation à l'adresse ${0}.",
        "purchaseConfirm2": "Veuillez cliquer sur le bouton du nouveau téléchargement de licence, afin d'activer la licence achetée.",
        "restricted": "Accès restreint",
        "restrictionsWithYourLicense": "LES RESTRICTIONS S'APPLIQUANT À VOTRE LICENCE ACTUELLE",
        "paymentPleaseChoose": "Veuillez choisir un moyen de paiement.",
        "paymentSelectExisting": "Sélectionnez votre moyen de paiement actuel.",
        "paymentSelectNew": "Moyen de paiement",
        "paymentMethod": "Moyen de paiement :",
        "changePaymentMethod": "Changer de moyen de paiement",
        "licensedTo": "LICENCE DÉLIVRÉE \u0012À",
        "learnMore": "En savoir plus",
        "startTrial": "Commencer la période d'essai",
        "purchase": "Acheter",
        "trialSuccessfullyStarted": "Début de la période d'essai confirmé",
        "trialSuccessDetails1": "Votre période d'essai de 14 jours vient d'être activée. Veuillez",
        "trialSuccessDetails2": "passer à une inscription payante",
        "trialSuccessDetails3": "dès que possible, afin d'éviter la suspension de nos prestations.",
        "havingTrouble": "Vous éprouvez des difficultés pour effectuer les opérations nécessaires?",
        "contactUs": "Contactez nous",
        "startUsing": "Commencez à profiter de HM3 dès maintenant.",
        "missedUpdates": "${0} mises à jour manquées",
        "updatesAreCritical": "Les mises à jour sont primordiales pour vous assurer que la plateforme MH3 ne s'est pas arrêtée d'importer les historiques de vos mains après que les sites de poker en ligne ont apporté des modifications à leur logiciels. Les nouveautés relatives aux fonctionnalités sont également mises en service grâce aux mises à jour.",
        "view": "Afficher",
        "oneYearOfUpdates": "L'achat comprend les mises à jour sur une année.",
        "renew": "Renouveler (${0})",
        "startingAt": "À partir de",
        "upgrade": "Le passage à une inscription payante",
        "removesRestrictions1": "supprime",
        "removesRestrictions2": "les restrictions d'accès",
        "removesRestrictions3": "et comprend également les mises à jour sur une année.",
        "upgradePrice": "Passer à une inscription payante  (${0})",
        "required": "Champ obligatoire",
        "continueFreemium": "Continuer à me servir de la version gratuite",
        "defaultFatalError": "Une erreur inattendue de notre serveur interne s'est produite : un administrateur en a été averti.",
        "restrictCashHandsType": "Me faire régler les mains",
        "restrictTourneyType": "Tournoi",
        "restrictLimitCashHandsType": "Limiter les mains pouvant être réglées",
        "restrictHudType": "Affichage tête haute (HUD)",
        "restrictReportDataType": "Signaler ces données",
        "restrictCashHands": "$ ${0} et en deçà",
        "restrictLimitCashHands": "$ ${0} et en deçà",
        "restrictTourney": "${0} au maximum",
        "restrictHud": "Nombre de table.s maximum ${0}",
        "restrictReportData": "${0} dernières mains ",
        "restrictionUnlimited": "Illimité",
        "errorState": "Champ obligatoire",
        "activeHoldemLicense": "LICENCE HOLDEM ACTIVÉE",
        "activeOmahaLicense": "LICENCE OMAHA ACTIVÉE",
        "reinstallOldVersion": "Réinstaller l'ancienne version",
        "removesRestrictions3b": "et retournez à votre licence payante, mais les mises à jour ne sont ",
        "removesRestrictions4b": "PAS COMPRISES.",
        "noActiveHoldemLicense": "AUCUNE LICENCE HOLDEM N'EST ACTIVÉE.",
        "noActiveOmahaLicense": "AUCUNE LICENCE OMAHA N'EST ACTIVÉE.",
        "free": "GRATUITE",
        "netellerSecureId": "Identification sécurisée",
        "recurringPriceDescription": "${0} ${1} sont compris.es*",
        "recurringYear": "Année",
        "recurringMonth": "Mois",
        "recurringDay": "Jour",
        "restrictionsSmall": "L'illimité/Paiement limité de la cagnotte <b>restreint</b> jusqu'aux 0.50 $ en\nBB  \nPaiement limité fixe <b>restreint</b> jusqu'à 1.00 $ en BB.\nTournois <b>restreints</b> jusqu'à $22.00 en niveaux supplémentaires.",
        "afterDiscount": "Le tarif après la réduction courant sur une période limitée",
        "upgradeDiscount": "SUPPRIMER LA RÉDUCTION",
        "discountExpires": "La réduction prendra fin le ${0}",
        "discountSinglePurchase": "La réduction ne peut porter que sur un seul achat.",
        "errorNetellerAccount": "Numéro de compte Netteler non valable",
        "errorNetellerSecureId": "Veuillez saisir votre numéro d'identification sécurisée à 6 chiffres.",
        "continueTrial": "Souhaite poursuivre la préiode d'essai",
        "continueTrialDaysRemaining": "(${0} jours restants)",
        "netellerInvalidCredentials": "Nous n'avons pas été en mesure de valider vos coordonnées Neteller. Veuillez tenter à nouveau de vous reconnecter . ",
        "faq": "Foire aux questions",
        "forMoreDetails": " pour une information complète relative à la gestion du renouvellement de votre abonnement à l'assistance technique et à la maintenance. ",
        "recurringSubscription": "* Le moyen de paiement enregistré sert pour le renouvellement annuel de l'abonnement à l'assistance technique et à la maintenance s'élevant à ${0} $, et qui vous sera facturé dans un an (${1}). Afficher",
        "positivePrice": "L'abonnement à l'assistance technique et à la maintenance s'élevant à ${0} $, et qui vous sera facturé dans un an (${1}). Afficher",
        "paymentSeeWebsite1": "Voir",
        "paymentSeeWebsite2": "BOUTIQUE",
        "paymentSeeWebsite3": " pour d'autres possibilités de paiement",
        "paymentOr": "- OU -",
        "couldNotStartMlaTitle": "Nous avons rencontré un problème",
        "couldNotStartMlaText": "Impossible de démarrer Mes Licences. Un administrateur a été prévenu. Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter notre support.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    german : {
        "notAllowedByLicense": "Lizenz erlaubt Hand nicht",
        "selectHandToExport": "Wähle Hand für Export",
        "selectFormat": "Wähle Format",
        "originalFormat": "Originalformat",
        "ctrlCToCopy": "Strg-C zum Kopieren in die Zwischenablage",
        "availableTags": "Verfügbare Tags",
        "welcomeToHm3": "Willkommen zum HoldemManager3 Replayer!",
        "theme": "Thema: ",
        "deck": "Deck: ",
        "showHandResults": "Zeige Hand Resultat: ",
        "showHeroCards": "Zeige Heros Hole Cards immer: ",
        "showBB": "Zeige Chips in BB: ",
        "combineFolds": "Kombiniere Folds: ",
        "maskPlayerNames": "Maskiere Spieler Namen: ",
        "statsUpToTimeOfHand": "Statistiken bis zur Zeit der Hand: ",
        "showHud": "Zeige Hud: ",
        "replaySpeed": "Replayer Geschwindigkeit: ",
        "hand": "Hand",
        "next100Hands": "Nächste 100 Hände",
        "prev100Hands": "Vorherige 100 Hände",
        "addEditHandMarking": "Hinzufügen/Bearbeiten von Hand Markierungen",
        "wonXBB": "Gewonnen ${0} BB",
        "lostXBB": "Verloren ${0} BB",
        "wonLossNA": "Gewonnen/Verloren NA",
        "potBB": "Pot ${0} BB",
        "userWentAllin": "Benutzer ging Allin",
        "pot": "Pot ${0}",
        "potOdds": "Pot Odds: ${0}:1",
        "hhGameStart": "${0} Spiel ${1} beginnt um ${2}",
        "hhHandNotes": "Hand Notiz(en)",
        "hhFold": "${0} foldet",
        "hhCheck": "${0} checkt",
        "hhCall": "${0} callt ${1}",
        "hhBet": "${0} bettet ${1}",
        "hhRaise": "${0} raist ${1}",
        "hhReturnedTo": "${1} zurück zu ${0}",
        "hhWin": "${0} gewinnt ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "Aktion ist beendet",
        "hhMuck": "${0} muckt ${1}",
        "hhShow": "${0} zeigt ${1}",
        "hhPostSB": "${0} postet Small Blind",
        "hhPostBB": "${0} postet Big Blind",
        "hhPostDB": "${0} postet einen Dead Blind",
        "backToReleaseNotes": "Zurück zu den Release Notes",
        "backToMyLicense": "Zurück zu meiner Lizenz",
        "backToCardInfo": "Zurück zu Kreditkarten Info",
        "backToPayment": "Zurück zu Zahlungsmethoden",
        "orderBuyNow": "Jetzt kaufen",
        "orderProceed": "Weiter",
        "headerTextTrial": "Trial (${0} Tage verbleibend)",
        "headerTextFree": "Frei",
        "smallStakes": "Small Stakes",
        "allStakes": "Alle Stakes",
        "smallStakesCaps": "SMALL STAKES",
        "allStakesCaps": "ALLE STAKES",
        "smallStakesMaintenance": "SMALL STAKES WARTUNG",
        "allStakesMaintenance": "ALLE STAKES WARTUNG",
        "buyHoldemSmallStakes": "Holdem Small Stakes",
        "buyHoldemAllStakes": "Holdem alle Stakes",
        "buyHoldemOmahaAllStakes": "Alle Stakes",
        "buyOmahaSmallStakes": "Omaha Small Stakes",
        "buyOmahaAllStakes": "Omaha alle Stakes",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "HM Appś",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Abgelaufen am ${0}",
        "expiresOn": "Läuft ab am ${0}",
        "recommended": "EMPFOHLEN",
        "seeAllOptionsInStore": "Zeige alle Optionen im Store",
        "paypalExternalBrowser": "PayPal wird in einem externen Browser geöffnet um den Zahlungsprozess abzuschließen",
        "skrillExternalBrowser": "Skrill wird in einem externen Browser geöffnet um den Zahlungsprozess abzuschließen",
        "selectProduct": "WÄHLE PRODUKT",
        "availableUpdate": "VERFÜGBARES UPDATE: ",
        "versionAvailable": "Version ${0} ist verfügbar: ${1}",
        "fullFaq": "Komplette Release Notes FAQ",
        "reviewOptions": "Prüfe deine Holdem Wartungsoptionen bevor du mit dem Update weiter machst",
        "maintenanceOptions": "Wartungsoptionen",
        "addProductToLicense": "FÜGE ${0} ZU DEINER AKTUELLEN LIZENZ",
        "purchasePrice": "Kauf (${0})",
        "errorName": "Bitte gib deinen vollständigen Namen ein",
        "errorAddress": "Bitte gib Straße und Hausnummer ein",
        "errorCountry": "Bitte gib dein Land ein",
        "errorCity": "Bitte gib deinen Wohnort ein",
        "errorZip": "Bitte gib eine gültige Postleitzahl ein",
        "billingInfo": "RECHNUNGSINFO",
        "name": "Voller Name",
        "address": "Straße",
        "city": "Stadt",
        "state": "Bundesland",
        "zip": "Postleitzahl",
        "country": "Land",
        "selectCountry": "Wähle ein Land",
        "buyNowTip": "Bitte wähle vor dem Weitermachen eine vorhandene oder neue Zahlungsmethode aus",
        "licenses": "LIZENZEN",
        "version": "Version ${0}",
        "viewReleaseNotes": "Zeige die Release Notes auf der Webseite",
        "updateAndRenewMaintenance": "UPDATE & ERNEUERUNG WARTUNG",
        "renewGetUpdatesUntil": "Durch die Erneuerung der Wartung bekommst du alle HM3 Updates durch ${0}",
        "update": "Update",
        "updateAndSwitchToFree": "UPDATE & UMSTELLEN ZUR FREIEN VERSION",
        "updateAndSwitchToFreeDetails1": "Du erhältst das Update aber deine HM3 (Holdem) Software wird umgestellt auf die freie Version und bekommt",
        "updateAndSwitchToFreeDetails2": "Eingeschränkte Funktionalität",
        "updateAndSwitch": "Update & Umstellung",
        "errorCreditCardDigitsOnly": "Die Kreditkartennummer sollte nur Zahlen enthalten.",
        "errorCreditCard": "Bitte gib eine gültige Kartennummer ein.",
        "errorRequired": "Erforderlich",
        "errorCardExpired": "Karte abgelaufen",
        "errorCvv": "CVV sollte eine Länge von ${0} haben",
        "cardInfo": "KREDITKARTEN INFO",
        "cardNo": "Kartennr",
        "expiry": "Ablaufdatum",
        "year": "Jahr",
        "month": "Monat",
        "month01": "Jan",
        "month02": "Feb",
        "month03": "Mär",
        "month04": "Apr",
        "month05": "Mai",
        "month06": "Jun",
        "month07": "Jul",
        "month08": "Aug",
        "month09": "Sep",
        "month10": "Okt",
        "month11": "Nov",
        "month12": "Dez",
        "cvv": "CVV",
        "active": "Aktiv",
        "manageSubscription": "Verwalte Abonnements",
        "youAreUpToDate": "Du bist auf dem aktuellen Stand",
        "releaseNotes": "Release Notes für ${0}",
        "netellerInfo": "Neteller Konto Informationen",
        "netellerSignin": "Melde dich in deinem Neteller Konto an um den Kauf abzuschließen",
        "continue_": "Weiter",
        "netellerAccount": "Neteller Konto",
        "netellerPassword": "Passwort",
        "orderSummary": "BESTELLZUSAMMENFASSUNG: ",
        "changeProducts": "Produkt(e) ändern",
        "total": "Gesamt",
        "paypalComplete": "BITTE VERVOLLSTÄNDIGE DEINEN PAYPAL KAUF IN DEINEM BROWSER",
        "paypalOpenedInNewBrowser": "Wir haben PayPal in deinem Default Internet Browser geöffnet. Bitte melde dich in deinem PayPal Konto an und vervollständige den Kauf. Sobald der Kauf abgeschlossen ist, kehre hierher zurück und klicke 'Lade Lizenz neu' um die gekaufte Lizenz zu laden.",
        "reloadLicense": "Lade Lizenz neu",
        "thankYouForPurchase": "Vielen Dank für den Kauf",
        "purchaseConfirm1": "Du erhältst in Kürze eine Bestätigung per Email an ${0}",
        "purchaseConfirm2": "Bitte klicke den Lade Lizenz neu Button unten und deine gekaufte Lizenz wird aktiviert.",
        "restricted": "eingeschränkt",
        "restrictionsWithYourLicense": "EINSCHRÄNKUNGEN DEINER AKTUELLEN LIZENZ",
        "paymentPleaseChoose": "Bitte wähle eine Zahlungsmethode",
        "paymentSelectExisting": "Wähle vorhandene Zahlungsmethode: ",
        "paymentSelectNew": "Zahlungsmethode",
        "paymentMethod": "Zahlungsmethode: ",
        "changePaymentMethod": "Ändere Zahlungsmethode",
        "licensedTo": "LIZENSIERT FÜR",
        "learnMore": "Erfahre mehr",
        "startTrial": "Starte Trial",
        "purchase": "Kauf",
        "trialSuccessfullyStarted": "Trial erfolgreich gestartet",
        "trialSuccessDetails1": "Deine 14 Tage Trial ist jetzt aktiv. Bitte ",
        "trialSuccessDetails2": "Upgrade",
        "trialSuccessDetails3": " sobald wie möglich um Unterbrechungen deiner Dienste zu vermeiden.",
        "havingTrouble": "Du hast Probleme? ",
        "contactUs": "Kontaktiere uns",
        "startUsing": "Starte jetzt HM3",
        "missedUpdates": "${0} fehlende Updates",
        "updatesAreCritical": "Updates sind wichtig um sicherzustellen, dass HM3 weiter Hände importieren kann nachdem Pokerseiten Änderungen an ihrer Software vorgenommen haben. Neue Features und Funktionalitäten werden ebenfalls durch Updates veröffentlicht.",
        "view": "Zeige",
        "oneYearOfUpdates": "inklusive 1 Jahr Updates",
        "renew": "Erneuere (${0})",
        "startingAt": "Starte um",
        "upgrade": "Upgrade",
        "removesRestrictions1": "Entfernt ",
        "removesRestrictions2": "Einschränkungen",
        "removesRestrictions3": " und enthält ein Jahr Updates",
        "upgradePrice": "Upgrade (${0})",
        "required": "Erforderlich",
        "continueFreemium": "mit freier Version weitermachen",
        "defaultFatalError": "Ein unerwarteter interner Serverfehler ist aufgetreten und ein Administrator wurde benachrichtigt. Bitte versuch es später nochmal.",
        "restrictCashHandsType": "Cash Hände",
        "restrictTourneyType": "Turnier",
        "restrictLimitCashHandsType": "Limit Cash Hände",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Report Daten",
        "restrictCashHands": "$ ${0} und darunter",
        "restrictLimitCashHands": "$ ${0} und darunter",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Tisch(e)",
        "restrictReportData": "Letzte ${0} Hände",
        "restrictionUnlimited": "Unbegrenzt",
        "errorState": "Erforderlich",
        "activeHoldemLicense": "AKTIVE HOLDEM LIZENZ",
        "activeOmahaLicense": "AKTIVE OMAHA LIZENZ",
        "reinstallOldVersion": "Installiere alte Version wieder",
        "removesRestrictions3b": "und kehre zu deiner bezahlten Lizenz zurück aber Updates werden",
        "removesRestrictions4b": "NICHT ENTHALTEN",
        "noActiveHoldemLicense": "KEINE AKTIVE HOLDEM LIZENZ",
        "noActiveOmahaLicense": "KEINE AKTIVE OMAHA LIZENZ",
        "free": "FREI",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} enthalten*",
        "recurringYear": "Jahr",
        "recurringMonth": "Monat",
        "recurringDay": "Tag",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>eingeschränkt</b> bis zu $0.50 big blinds\nFixed Limit Cash <b>eingeschränkt</b> bis zu $1.00 big blinds\nTournaments <b>eingeschränkt</b> bis zu $22.00 buy-ins.",
        "afterDiscount": "Preis nach zeitlich begrenztem Nachlass ",
        "upgradeDiscount": "UPGRADE NACHLASS",
        "discountExpires": "Nachlass läuft am ${0} ab",
        "discountSinglePurchase": "Nachlass gültig für einzelnen Kauf",
        "errorNetellerAccount": "Ungültige Neteller Konto ID",
        "errorNetellerSecureId": "Bitte gib deine 6-stellige Secure ID ein",
        "continueTrial": "Weiter mit Trial",
        "continueTrialDaysRemaining": "(${0} Tage verbleibend)",
        "netellerInvalidCredentials": "Wir konnten deine Neteller Anmeldedaten nicht überprüfen. Bitte versuch dich nochmal anzumelden.",
        "faq": "FAQ",
        "forMoreDetails": " für weitere Details zur Verwaltung deiner jährliche Support & Wartungs Verlängerung.",
        "recurringSubscription": "* Eine Zahlungsmethode ist erforderlich für die jährliche Support & Wartungs Verlängerung von $${0}. Dies wird in einem Jahr (${1}) berechnet.\nZeige ",
        "positivePrice": "Die jährliche Support & Wartungs Verlängerung von $${0} wird in einem Jahr (${1}) berechnet. Zeige ",
        "paymentSeeWebsite1": "Zeige ",
        "paymentSeeWebsite2": "STORE",
        "paymentSeeWebsite3": " für weitere Zahlungsoptionen",
        "paymentOr": "- ODER -",
        "couldNotStartMlaTitle": "Wir haben ein Problem entdeckt",
        "couldNotStartMlaText": "Konnte Meine Lizenzen nicht starten. Ein Administrator wurde informiert. Bitte versuche es später nochmal. Wenn das Problem weiterhin besteht, kontaktiere bitte unseren Support.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    italian :{
        "notAllowedByLicense": "Mano Non Consentita dalla Licenza",
        "selectHandToExport": "Seleziona Mano da Esportare",
        "selectFormat": "Seleziona il formato...",
        "originalFormat": "Formato Originale",
        "ctrlCToCopy": "Ctrl-C per Copiare negli Appunti",
        "availableTags": "Tag Disponibili",
        "welcomeToHm3": "Benvenuto al HoldemManager3 Replayer!",
        "theme": "Tema: ",
        "deck": "Mazzo: ",
        "showHandResults": "Mostra Risultati delle Mani: ",
        "showHeroCards": "Mostra Sempre le Carte Coperte dell'Eroe: ",
        "showBB": "Mostra le Chip del Grande Buio: ",
        "combineFolds": "Fold Combinato: ",
        "maskPlayerNames": "Maschera i Nomi dei Giocatori: ",
        "statsUpToTimeOfHand": "Statistiche in Corso Fino al Gioco della Mano: ",
        "showHud": "Mostra HUD: ",
        "replaySpeed": "Rigioca speed: ",
        "hand": "Mano",
        "next100Hands": "Le prossime 100 Mani",
        "prev100Hands": "Le 100 Mani Precedenti",
        "addEditHandMarking": "Aggiungi/Modifica Marcature Mani",
        "wonXBB": "Vinto ${0} Grande Buio",
        "lostXBB": "Perso ${0} Grande Buio\n",
        "wonLossNA": "Vincita/Perdita Non Disponibile",
        "potBB": "Piatto: ${0} Grande Buio\n",
        "userWentAllin": "L'Utente è andato All-in",
        "pot": "Piatto: ${0}",
        "potOdds": "Pot Odds: ${0}:1",
        "hhGameStart": "${0} gioco ${1} inizia con ${2}\n",
        "hhHandNotes": "Nota(e) della Mano",
        "hhFold": "${0} Fold\n",
        "hhCheck": "${0} Check\n",
        "hhCall": "${0} Call ${1}\n",
        "hhBet": "${0} Puntate ${1}\n",
        "hhRaise": "${0} Raise ${1}\n",
        "hhReturnedTo": "${1} Ritornato a ${0}\n",
        "hhWin": "${0} Vincite ${1}\n",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "L'azione è terminata.",
        "hhMuck": "${0} muck ${1}\n",
        "hhShow": "${0} mostra ${1}\n",
        "hhPostSB": "${0} piazza il piccolo buio\n",
        "hhPostBB": "${0} piazza il grande buio",
        "hhPostDB": "${0} piazza un dead blind",
        "backToReleaseNotes": "Torna alle Note di Rilascio",
        "backToMyLicense": "Torna alla Mia Licenza",
        "backToCardInfo": "Torna alle Informazioni Sulla Carta di Credito",
        "backToPayment": "Torna al Metodo di Pagamento",
        "orderBuyNow": "Acquista Ora",
        "orderProceed": "Procedi",
        "headerTextTrial": "Prova (${0} Giorni Rimanenti)",
        "headerTextFree": "Gratis",
        "smallStakes": "Piccole Puntate",
        "allStakes": "Tutte le Puntate",
        "smallStakesCaps": "PICCOLE PUNTATE",
        "allStakesCaps": "TUTTE LE PUNTATE",
        "smallStakesMaintenance": "MANUTENZIONE SULLE PICCOLE PUNTATE",
        "allStakesMaintenance": "MANUTENZIONE SU TUTTE LE PUNTATE",
        "buyHoldemSmallStakes": "Piccole Puntate Holdem",
        "buyHoldemAllStakes": "Tutte le Puntate Holdem",
        "buyHoldemOmahaAllStakes": "Tutte le Puntate",
        "buyOmahaSmallStakes": "Piccole Puntate Omaha",
        "buyOmahaAllStakes": "Tutte le Puntate Omaha",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "App HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3+OM3",
        "expiredOn": "Scaduto il ${0}",
        "expiresOn": "Scade il ${0}",
        "recommended": "CONSIGLIATO",
        "seeAllOptionsInStore": "Vedi tutte le opzioni nel Negozio",
        "paypalExternalBrowser": "PayPal si aprirà in un browser esterno per completare la procedura di pagamento.",
        "skrillExternalBrowser": "Skrill si caricherà in un browser esterno per completare la procedura di pagamento.",
        "selectProduct": "SELEZIONA IL PRODOTTO",
        "availableUpdate": "AGGIORNAMENTO DISPONIBILE: ",
        "versionAvailable": "La versione ${0} è disponibile: ${1}",
        "fullFaq": "Note di rilascio complete FAQ",
        "reviewOptions": "Controlla le opzioni di manutenzione del tuo Holdem prima di procedere con l'aggiornamento",
        "maintenanceOptions": "Opzioni di Manutenzione",
        "addProductToLicense": "AGGIUNGI ${0} ALLA TUA LICENZA ATTUALE",
        "purchasePrice": "Acquista (${0})",
        "errorName": "Si prega di inserire il proprio Nome e Cognome",
        "errorAddress": "Si prega di inserire il proprio indirizzo e numero civico",
        "errorCountry": "Si prega di inserire il proprio Paese",
        "errorCity": "Si prega di inserire la propria Città",
        "errorZip": "Si prega di inserire un Codice Postale valido",
        "billingInfo": "INFORMAZIONI DI FATTURAZIONE",
        "name": "Nome e Cognome",
        "address": "Indirizzo",
        "city": "Città",
        "state": "Stato/Provincia",
        "zip": "CAP/Codice Postale",
        "country": "Paese",
        "selectCountry": "Seleziona il tuo Paese",
        "buyNowTip": "Prima di procedere si prega di inserire un metodo di pagamento esistente o nuovo",
        "licenses": "LICENZE",
        "version": "Versione ${0}\n",
        "viewReleaseNotes": "Visualizza le note di rilascio sul sito web",
        "updateAndRenewMaintenance": "AGGIORNAMENTO E RINNOVO DELLA MANUTENZIONE",
        "renewGetUpdatesUntil": "Rinnovando la manutenzione riceverai tutti gli aggiornamenti HM3 attraverso ${0}",
        "update": "Aggiorna",
        "updateAndSwitchToFree": "AGGIORNA E PASSA ALLA VERSIONE GRATUITA",
        "updateAndSwitchToFreeDetails1": "Riceverai l'aggiornamento ma il tuo software HM3 (Holdem) tornerà alla versione Gratuita e avrà",
        "updateAndSwitchToFreeDetails2": "funzioni limitate",
        "updateAndSwitch": "Aggiorna & Cambia",
        "errorCreditCardDigitsOnly": "Il numero della carta di credito è composto solo da cifre.",
        "errorCreditCard": "Si prega di inserire un numero di carta valido.",
        "errorRequired": "Richiesto",
        "errorCardExpired": "Carta Scaduta",
        "errorCvv": "Il codice CVV è composto da ${0} cifre",
        "cardInfo": "INFORMAZIONI SULLA CARTA DI CREDITO",
        "cardNo": "Numero della Carta",
        "expiry": "Scadenza",
        "year": "anno",
        "month": "mese",
        "month01": "Gen",
        "month02": "Feb",
        "month03": "Mar",
        "month04": "Apr",
        "month05": "Mag",
        "month06": "Giu",
        "month07": "Lug",
        "month08": "Ago",
        "month09": "Set",
        "month10": "Ott",
        "month11": "Nov",
        "month12": "Dic",
        "cvv": "CVV",
        "active": "Attivo",
        "manageSubscription": "Gestisci la Sottoscrizione",
        "youAreUpToDate": "Sei aggiornato",
        "releaseNotes": "Note di rilascio per ${0}",
        "netellerInfo": "Informazioni sul Conto NETELLER",
        "netellerSignin": "Accedi al tuo conto NETELLER per completare il tuo acquisto",
        "continue_": "Continua",
        "netellerAccount": "Conto Neteller",
        "netellerPassword": "Password",
        "orderSummary": "RIEPILOGO DELL'ORDINE: ",
        "changeProducts": "Cambia Prodotto(i)",
        "total": "Totale",
        "paypalComplete": "SI PREGA DI COMPLETARE IL PROPRIO ACQUISTO PAYPAL NEL PROPRIO BROWSER",
        "paypalOpenedInNewBrowser": "Abbiamo aperto Paypal nella finestra del tuo browser internet predefinito. Si prega di effettuare il login al proprio conto PayPal per completare l'acquisto. Una volta completato l'acquisto, ritornare qui e cliccare su 'Ricarica Licenza' per caricare la licenza appena acquistata.",
        "reloadLicense": "Ricarica la Licenza",
        "thankYouForPurchase": "Grazie Per Il Tuo Acquisto",
        "purchaseConfirm1": "A breve riceverai una mail di conferma al ${0}",
        "purchaseConfirm2": "Cliccare sul tasto di ricarica licenza qui sotto e la tua licenza acquistata sarà attiva.",
        "restricted": "soggetta a restrizioni",
        "restrictionsWithYourLicense": "LA TUA LICENZA ATTUALE E' SOGGETTA A RESTRIZIONI",
        "paymentPleaseChoose": "Si prega di scegliere un metodo di pagamento",
        "paymentSelectExisting": "Seleziona un metodo di pagamento esistente: ",
        "paymentSelectNew": "Metodo di Pagamento",
        "paymentMethod": "Metodo di Pagamento: ",
        "changePaymentMethod": "Cambia Metodo di Pagamento",
        "licensedTo": "CONCESSO IN LICENZA A",
        "learnMore": "Per saperne di più",
        "startTrial": "Inizia la Prova",
        "purchase": "Acquista",
        "trialSuccessfullyStarted": "Prova Avviata con Successo",
        "trialSuccessDetails1": "Ora la tua prova di 14 giorni è attiva. Si prega di ",
        "trialSuccessDetails2": "effettuare l'aggiornamento",
        "trialSuccessDetails3": " il prima possibile per evitare interruzioni di servizio.",
        "havingTrouble": "Stai riscontrando problemi? ",
        "contactUs": "Contattaci",
        "startUsing": "Ora inizia a utilizzare l'HM3 ",
        "missedUpdates": "${0} aggiornamenti persi\n",
        "updatesAreCritical": "Gli aggiornamenti sono importanti per garantire che l'HM3 continui a importare le cronologie delle tue mani dopo che i siti poker avranno apportato modifiche ai loro software. Tramite gli aggiornamenti saranno rilasciati anche nuove caratteristiche e funzioni.",
        "view": "Visualizza",
        "oneYearOfUpdates": "Include un anno di aggiornamenti",
        "renew": "Rinnova (${0})",
        "startingAt": "Partendo da",
        "upgrade": "Aggiornamento",
        "removesRestrictions1": "Rimuove ",
        "removesRestrictions2": "restrizioni",
        "removesRestrictions3": " e include un anno di aggiornamenti",
        "upgradePrice": "Aggiornamento (${0})\n",
        "required": "Richiesto",
        "continueFreemium": "Continua con la Versione Gratuita",
        "defaultFatalError": "Si è verificato un errore imprevisto all'interno del server, un amministratore è stato avvisato. Provare ad effettuare l'acquisto più tardi.",
        "restrictCashHandsType": "Mani Cash",
        "restrictTourneyType": "Torneo",
        "restrictLimitCashHandsType": "Limite Mani Cash",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Rapporto Dati",
        "restrictCashHands": "$ ${0} e inferiore",
        "restrictLimitCashHands": "$ ${0} e inferiore",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Tavolo(i)",
        "restrictReportData": "Ultime Mani ${0} \n",
        "restrictionUnlimited": "Senza limiti",
        "errorState": "Richiesto",
        "activeHoldemLicense": "LICENZA HOLDEM ATTIVA",
        "activeOmahaLicense": "LICENZA OMAHA ATTIVA",
        "reinstallOldVersion": "Reinstalla la Versione Precedente",
        "removesRestrictions3b": "e torna alla tua licenza a pagamento ma gli aggiornamenti ",
        "removesRestrictions4b": "NON SONO INCLUSI",
        "noActiveHoldemLicense": "NESSUNA LICENZA HOLDEM ATTIVA",
        "noActiveOmahaLicense": "NESSUNA LICENZA OMAHA ATTIVA",
        "free": "GRATUITO",
        "netellerSecureId": "ID di Sicurezza",
        "recurringPriceDescription": "${0} ${1} Incluso*\n",
        "recurringYear": "Anno",
        "recurringMonth": "Mese",
        "recurringDay": "Giorno",
        "restrictionsSmall": "Nessun Limite/Limite Pot Cash <b>con restrizioni</b> fino a $0.50 per il grande buio\nLimite Fisso Cash <b>con restrizioni</b> fino a $1,00 per il grande buio\nTornei <b>con restrizioni</b> fino a $22,00 per i buy-in.\n",
        "afterDiscount": "Prezzo dopo lo sconto a scadenza limitata",
        "upgradeDiscount": "AGGIORNA LO SCONTO",
        "discountExpires": "Lo Sconto Scade il ${0}",
        "discountSinglePurchase": "Lo Sconto si applica ad un singolo acquisto.",
        "errorNetellerAccount": "Conto ID Neteller Non Valido",
        "errorNetellerSecureId": "Inserisci il tuo ID di Sicurezza a 6 cifre",
        "continueTrial": "Continua con la Prova",
        "continueTrialDaysRemaining": "(${0} Giorni Rimanenti)",
        "netellerInvalidCredentials": "Non è stato possibile convalidare le tue credenziali Neteller. Prova ad accedere di nuovo.",
        "faq": "FAQ",
        "forMoreDetails": " per ottenere maggiori dettagli su come gestire il rinnovo annuale del servizio di Supporto & Manutenzione",
        "recurringSubscription": "* È richiesto un metodo di pagamento per il rinnovo annuale del servizio di Supporto & Manutenzione di $${0} che verrà fatturato in un anno (${1}). Visualizza ",
        "positivePrice": "Il rinnovo annuale del servizio di Supporto & Manutenzione pari a $${0} verrà fatturato in un anno (${1}). Visualizza ",
        "paymentSeeWebsite1": "Vedi",
        "paymentSeeWebsite2": "NEGOZIO",
        "paymentSeeWebsite3": " per altre opzioni di pagamento",
        "paymentOr": "- O -",
        "couldNotStartMlaTitle": "Abbiamo riscontrato un problema",
        "couldNotStartMlaText": "Impossibile avviare le Mie Licenze. Un Amministratore è stato notificato. Si prega di ricontrollare più tardi. Se il problema persiste contattare il nostro supporto.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    japanese  :{
        "notAllowedByLicense": "ライセンスで許可されていないハンド",
        "selectHandToExport": "エクスポートするハンドを選択",
        "selectFormat": "フォーマットを選択してください...",
        "originalFormat": "オリジナルのフォーマット",
        "ctrlCToCopy": "Ctrl + Cでクリップボードにコピー",
        "availableTags": "利用可能なタグ",
        "welcomeToHm3": "ホールデムマネージャー3のリプレイヤーの皆さん、ようこそ！",
        "theme": "テーマ：　",
        "deck": "デッキ：",
        "showHandResults": "ハンドの結果を表示：",
        "showHeroCards": "常にヒーローホールカードを表示：",
        "showBB": "BBでチップを表示：",
        "combineFolds": "フォ―ルドを結合：",
        "maskPlayerNames": "プレーヤーネームを隠す：",
        "statsUpToTimeOfHand": "ハンドの時間までの統計：",
        "showHud": "HUD (ヘッズアップディスプレイ)を表示：",
        "replaySpeed": "再生速度：",
        "hand": "ハンド",
        "next100Hands": "次の100ハンド",
        "prev100Hands": "前の100ハンド",
        "addEditHandMarking": "ハンドマーキング（マーク）の追加/編集",
        "wonXBB": "$ {0} BBを獲得",
        "lostXBB": "$ {0} BBを失いました",
        "wonLossNA": "勝ち/負けの該当なし",
        "potBB": "ポット：$ {0} BB",
        "userWentAllin": "ユーザーがオールイン（全額勝負）",
        "pot": "ポット：$ {0}",
        "potOdds": "ポットオッズ：$ {0}：1",
        "hhGameStart": "$ {0}ゲーム$ {1}は$ {2}で開始",
        "hhHandNotes": "ハンドノート",
        "hhFold": "$ {0}フォ―ルド",
        "hhCheck": "$ {0}チェック",
        "hhCall": "$ {0}コール$ {1}",
        "hhBet": "$ {0}ベット${1}",
        "hhRaise": "$ {0}レイズ$ {1}",
        "hhReturnedTo": "$ {1}リターンド $ {0}",
        "hhWin": "$ {0}勝ち$ {1}",
        "hhRake": "レイク：$ {0}",
        "hhActionEnded": "アクションは終了しました。",
        "hhMuck": "$ {0}マック$ {1}",
        "hhShow": "$ {0}表示 {1}",
        "hhPostSB": "$ {0}件のスモールブラインド",
        "hhPostBB": "$ {0}件のビッグブラインド",
        "hhPostDB": "$ {0}件のデッドブラインド",
        "backToReleaseNotes": "リリースノートに戻る",
        "backToMyLicense": "私のライセンスに戻る",
        "backToCardInfo": "クレジットカード情報に戻る",
        "backToPayment": "支払い方法に戻る",
        "orderBuyNow": "今すぐ購入する",
        "orderProceed": "進む",
        "headerTextTrial": "トライアル（残り日数$ {0}日）",
        "headerTextFree": "無料",
        "smallStakes": "スモール•ステークス",
        "allStakes": "すべてのステークス",
        "smallStakesCaps": "スモール•ステークス",
        "allStakesCaps": "すべてのステークス",
        "smallStakesMaintenance": "スモール•ステークスの管理",
        "allStakesMaintenance": "すべてのステークスの管理",
        "buyHoldemSmallStakes": "ホールデムのスモール•ステークス",
        "buyHoldemAllStakes": "ホールデムのすべてのステークス",
        "buyHoldemOmahaAllStakes": "すべてのステークス",
        "buyOmahaSmallStakes": "オマハのスモール•ステークス",
        "buyOmahaAllStakes": "オマハのすべてのステークス",
        "holdemManager": "ホールデム•マネージャー",
        "holdemManagerCaps": "ホールデム•マネージャー",
        "omahaCaps": "オマハ",
        "holdem": "ホールデム",
        "omaha": "オマハ",
        "hmApps": "HM（ホールデムマネージャー）アプリ",
        "hm3": "HM3（ホールデムマネージャー３）",
        "om3": "OM3（オマハマネージャー３）",
        "hm3andOm3": "HM3（ホールデムマネージャー３）および OM3（オマハマネージャー３）",
        "expiredOn": "  $ {0}に期限切れ",
        "expiresOn": "$ {0}に期限切れとなります",
        "recommended": "おすすめ",
        "seeAllOptionsInStore": "ストア内のすべてのオプションを表示",
        "paypalExternalBrowser": "PayPalは支払いプロセスを完了するために外部のブラウザで開きます。",
        "skrillExternalBrowser": "Skrillは支払いプロセスを完了するために外部ブラウザを読み込みます。",
        "selectProduct": "製品を選択",
        "availableUpdate": "入手可能なアップデート：",
        "versionAvailable": "バージョン$ {0}が利用可能です：$ {1}",
        "fullFaq": "フルリリースノートのよくある質問",
        "reviewOptions": "アップデートを続行する前にHoldem (ホールデム）のメンテナンスオプションを確認してください。",
        "maintenanceOptions": "メンテナンスのオプション",
        "addProductToLicense": "現在のライセンスに$ {0}を追加",
        "purchasePrice": "購入額（$ {0}）",
        "errorName": "あなたのフルネームを入力してください",
        "errorAddress": "あなたの住所の通りの名前と番号を入力してください",
        "errorCountry": "あなたの国を入力してください",
        "errorCity": "あなたの住所の市区町村を入力してください",
        "errorZip": " 有効な郵便番号を入力してください",
        "billingInfo": "  請求書情報",
        "name": "フルネーム",
        "address": "通り名",
        "city": "都市名",
        "state": "都道府県",
        "zip": "郵便番号",
        "country": "国",
        "selectCountry": "国を選択",
        "buyNowTip": "先に進む前に、既存または新しいお支払い方法を選択してください",
        "licenses": "ラインセンス",
        "version": "バージョン$ {0}",
        "viewReleaseNotes": "Webサイトでリリースノートを表示する",
        "updateAndRenewMaintenance": "アップデートと更新のメンテナンス",
        "renewGetUpdatesUntil": "メンテナンスを更新すると、$ {0}を通じてすべてのHM3（ホールデム•マネージャー３）のアップデートを受け取ることができます。",
        "update": "アップデート",
        "updateAndSwitchToFree": "アップデートおよび無料版への切り替え",
        "updateAndSwitchToFreeDetails1": "あなたはアップデートを受け取る事ができますが、あなたのHM3（ホールデム）ソフトウェアは無料版に戻り、維持されます",
        "updateAndSwitchToFreeDetails2": "制限付き機能",
        "updateAndSwitch": "アップデートおよび切り替え",
        "errorCreditCardDigitsOnly": "クレジットカード番号には数字のみを入力してください",
        "errorCreditCard": "  有効なカード番号を入力してください。",
        "errorRequired": "必須",
        "errorCardExpired": "期限切れのカードです",
        "errorCvv": "CVVは$ {0}桁の長さです",
        "cardInfo": "クレジットカード情報",
        "cardNo": "カード番号",
        "expiry": "有効期限",
        "year": "年",
        "month": "月",
        "month01": "1月",
        "month02": "2月",
        "month03": "3月",
        "month04": "4月",
        "month05": "5月",
        "month06": "6月",
        "month07": "7月",
        "month08": "8月",
        "month09": "9月",
        "month10": "10月",
        "month11": "11月",
        "month12": "12月",
        "cvv": "CVV",
        "active": "有効",
        "manageSubscription": "購読を管理する",
        "youAreUpToDate": "あなたは最新の状態です",
        "releaseNotes": "$ {0}のリリースノート",
        "netellerInfo": "NETELLERアカウント情報",
        "netellerSignin": "購入を完了するには、NETELLERアカウントにサインインしてください",
        "continue_": "続行する",
        "netellerAccount": "Netellerアカウント",
        "netellerPassword": "パスワード",
        "orderSummary": "注文の概要：",
        "changeProducts": "製品を変更する",
        "total": "合計",
        "paypalComplete": "あなたのブラウザでPaypalによる購入手続きを完了させてください",
        "paypalOpenedInNewBrowser": "デフォルトのインターネットブラウザウィンドウでPayPalが開かれます。あなたのPayPalアカウントにログインして購入手続きを完了させてください。購入が完了したら、ここに戻り[ライセンスを再読み込み]ボタンをクリックして購入したライセンスを読み込んでください。",
        "reloadLicense": "ライセンスを再読み込み",
        "thankYouForPurchase": "ご購入いただきありがとうございます",
        "purchaseConfirm1": "間もなく$ {0}にEメールによる確認が届きます",
        "purchaseConfirm2": "下の[ライセンスを再読み込み]ボタンをクリックすると、購入されたライセンスが有効になります。",
        "restricted": "制限あり",
        "restrictionsWithYourLicense": "現在のあなたのライセンスによる制限",
        "paymentPleaseChoose": "お支払い方法を選択してください",
        "paymentSelectExisting": "既存のお支払い方法を選択してください：",
        "paymentSelectNew": "支払方法",
        "paymentMethod": "支払方法：",
        "changePaymentMethod": "支払い方法を変更",
        "licensedTo": "ライセンス対象",
        "learnMore": "もっと詳しく知りたい場合はこちら",
        "startTrial": "トライアルを開始",
        "purchase": "購入",
        "trialSuccessfullyStarted": "トライアルは正常に開始されました",
        "trialSuccessDetails1": "あなたの14日間のトライアルが有効になりました。 よろしくお願いします。",
        "trialSuccessDetails2": "アップグレードする",
        "trialSuccessDetails3": "あなたのサービスの中断を避けるためにできるだけ早く行ってください。",
        "havingTrouble": "何かお困りですか？",
        "contactUs": "お問い合わせ",
        "startUsing": "今すぐHM3（ホールデム•マネージャー３）を使い始める",
        "missedUpdates": "$ {0}が更新を見逃しました",
        "updatesAreCritical": "更新を行う事は、ポーカーサイトがソフトウェアに変更を加えた後もHM3（ホールデムマネージャー３）があなたのハンド履歴をインポートし続けることを保証するために重要です。 新しい特徴や機能もアップデートを通じてリリースされています。",
        "view": "表示する",
        "oneYearOfUpdates": "1年間のアップデートが含まれています",
        "renew": "更新（$ {0}）",
        "startingAt": "開始時",
        "upgrade": "アップグレードする",
        "removesRestrictions1": "削除する",
        "removesRestrictions2": "制限事項",
        "removesRestrictions3": "1年間のアップデートが含まれます",
        "upgradePrice": "アップグレード（$ {0}）",
        "required": "必須",
        "continueFreemium": "無料版を続ける",
        "defaultFatalError": "予期しない内部のサーバーエラーが発生し、管理者に通知されました。 後でもう一度購入してみてください。",
        "restrictCashHandsType": "キャッシュハンド",
        "restrictTourneyType": "トーナメント",
        "restrictLimitCashHandsType": "キャッシュハンドの制限",
        "restrictHudType": "HUD（ヘッズアップディスプレイ）",
        "restrictReportDataType": "レポートデータ",
        "restrictCashHands": "$ $ {0}以下",
        "restrictLimitCashHands": "$ $ {0}以下",
        "restrictTourney": "最大$ {0}",
        "restrictHud": "最大$ {0}テーブル",
        "restrictReportData": "最後の$ {0}ハンド",
        "restrictionUnlimited": "無制限",
        "errorState": "必須",
        "activeHoldemLicense": "有効なホールデム•ライセンス",
        "activeOmahaLicense": "有効なオマハ•ライセンス",
        "reinstallOldVersion": "古いバージョンを再インストールする",
        "removesRestrictions3b": "有料ライセンスに戻りますが、更新は",
        "removesRestrictions4b": "含まれていません",
        "noActiveHoldemLicense": "有効なホールデム•ライセンスはありません",
        "noActiveOmahaLicense": "有効なオマハ•ライセンスはありません",
        "free": "無料",
        "netellerSecureId": "セキュアID",
        "recurringPriceDescription": "$ {0} $ {1}が含まれています*",
        "recurringYear": "年",
        "recurringMonth": "月",
        "recurringDay": "日",
        "restrictionsSmall": "ノーリミットキャッシュおよびポット•リミットキャッシュは最大$ 0.50のビッグブラインドに<b>制限</b> されています。固定リミットキャッシュは最大$ 1.00のビッグブラインドに<b>制限</b> されています。トーナメントには最大$ 22.00のバイインの<b>制限</b> があります。",
        "afterDiscount": "期間限定割引後の価格",
        "upgradeDiscount": "割引のアップグレード",
        "discountExpires": " 割引は 2019年3月31日に終了します",
        "discountSinglePurchase": "割引は1回の購入に適用されます。",
        "errorNetellerAccount": "無効なNetellerアカウントID",
        "errorNetellerSecureId": "6桁のセキュアIDを入力してください",
        "continueTrial": "トライアルを続ける",
        "continueTrialDaysRemaining": "（$ {0}日の残り日数）",
        "netellerInvalidCredentials": "あなたのNetellerの認証情報を検証できませんでした。 もう一度ログインしてください。",
        "faq": "よくある質問",
        "forMoreDetails": "年間のサポートとメンテナンスの更新管理の詳細についてはこちらをご覧ください。",
        "recurringSubscription": "*$$ {0}1年以内に請求される（$ {1}）年1回のサポートとメンテナンスの更新にはお支払い方法が必要です。 表示する",
        "positivePrice": "$$ {0}1年以内に請求される（$ {1}）年1回のサポートとメンテナンスの更新。 表示する",
        "paymentSeeWebsite1": "表示する",
        "paymentSeeWebsite2": "ストア",
        "paymentSeeWebsite3": "他の支払い方法について",
        "paymentOr": "- または -",
        "couldNotStartMlaTitle": "問題が発生しました",
        "couldNotStartMlaText": "My Licenses を開始できませんでした。管理者に通知が送られました。後でもう一度チェックしてください。問題が続く場合は、当社サポートにご連絡ください。",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    polish : {
        "notAllowedByLicense": "Ręka niedozwolona przez Licencję",
        "selectHandToExport": "Wybierz rękę do zaimportowania",
        "selectFormat": "Wybierz format...",
        "originalFormat": "Oryginalny format",
        "ctrlCToCopy": "Ctrl-C, aby skopiować do schowka",
        "availableTags": "Dostępne tagi",
        "welcomeToHm3": "Witamy w HoldemManager3 Replayer!",
        "theme": "Motyw:",
        "deck": "Talia:",
        "showHandResults": "Pokaż wyniki rąk:",
        "showHeroCards": "Zawsze pokazuj karty Hero Hole:",
        "showBB": "Pokazuj żetony w BB:",
        "combineFolds": "Połącz spasowania:",
        "maskPlayerNames": "Maskuj Nazwy Graczy:",
        "statsUpToTimeOfHand": "Statystyki do czasu ręki:",
        "showHud": "Pokaż HUD:",
        "replaySpeed": "Prędkość powtórki:",
        "hand": "Ręka",
        "next100Hands": "Następne 100 rąk",
        "prev100Hands": "Poprzednie 100 rąk",
        "addEditHandMarking": "Dodaj/Edytuj Oznaczenia Rąk",
        "wonXBB": "Wygrano ${0} BB",
        "lostXBB": "Przegrano ${0} BB",
        "wonLossNA": "Wygrano/Przegrano NA",
        "potBB": "Pula: ${0} BB",
        "userWentAllin": "Użytkownik wszedł Allin",
        "pot": "Pula: ${0}",
        "potOdds": "Szanse puli: ${0}1",
        "hhGameStart": "${0} gra ${1} zaczyna się od ${2}",
        "hhHandNotes": "Notatki ręki",
        "hhFold": "${0} pasuje",
        "hhCheck": "${0} czeka",
        "hhCall": "${0} sprawdza ${1}",
        "hhBet": "${0} podbija ${1}",
        "hhRaise": "${0} przebija ${1}",
        "hhReturnedTo": "${1} wrócił do ${0}",
        "hhWin": "${0} wygrywa ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "Akcja zakończona.",
        "hhMuck": "${0} muck ${1}",
        "hhShow": "${0} pokazuje ${1}",
        "hhPostSB": "${0} daje małą w ciemno",
        "hhPostBB": "${0} daje dużą w ciemno",
        "hhPostDB": "${0} daje martwą w ciemno",
        "backToReleaseNotes": "Powrtót do Informacji o wydaniu",
        "backToMyLicense": "Powrót do Mojej Licencji",
        "backToCardInfo": "Powrót do Danych Karty Kredytowej",
        "backToPayment": "Powrót do Metod Płatności",
        "orderBuyNow": "Kup teraz",
        "orderProceed": "Kontynuuj",
        "headerTextTrial": "Trial (pozostało ${0} dni)",
        "headerTextFree": "Za darmo",
        "smallStakes": "Niskie stawki",
        "allStakes": "Wszystkie stawki",
        "smallStakesCaps": "MAŁE STAWKI",
        "allStakesCaps": "WSZYSTKIE STAWKI",
        "smallStakesMaintenance": "KONSERWACJA NISKICH STAWEK",
        "allStakesMaintenance": "KONSERWACJA WSZYSTKICH STAWEK",
        "buyHoldemSmallStakes": "Holdem Niskie stawki",
        "buyHoldemAllStakes": "Holdem Wszystkie stawki",
        "buyHoldemOmahaAllStakes": "Wszystkie stawki",
        "buyOmahaSmallStakes": "Omaha Niskie stawki",
        "buyOmahaAllStakes": "Omaha Wszystkie stawki",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "Aplikacje HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Wygasło dnia ${0}",
        "expiresOn": "Wygasa dnia ${0}",
        "recommended": "REKOMENDOWANE",
        "seeAllOptionsInStore": "Zobacz wszystkie opcje w Sklepie",
        "paypalExternalBrowser": "PayPal otworzy się w nowym oknie, aby dokończyć proces płatności.",
        "skrillExternalBrowser": "Skrill otworzy się w nowym oknie, aby dokończyć proces płatności.",
        "selectProduct": "WYBIERZ PRODUKT",
        "availableUpdate": "DOSTĘPNA AKTUALIZACJA:",
        "versionAvailable": "Wersja ${0} jest dostępna: ${1}",
        "fullFaq": "Pełne informacje o wersji FAQ",
        "reviewOptions": "Przed kontynuowaniem aktualizacji przejrzyj opcje konserwacji Holdem",
        "maintenanceOptions": "Opcje konserwacji",
        "addProductToLicense": "DODAJ ${0} DO OBECNEJ LICENCJI",
        "purchasePrice": "Zakup (${0})",
        "errorName": "Wprowadź swoje Imię i Nazwisko",
        "errorAddress": "Wprowadź nazwę ulicy oraz numer domu",
        "errorCountry": "Wprowadź swój kraj",
        "errorCity": "Wprowadź swoje miasto",
        "errorZip": "Wprowadź poprawny kod pocztowy",
        "billingInfo": "INFORMACJE ROZLICZENIOWE",
        "name": "Imię i Nazwisko",
        "address": "Nazwa ulicy",
        "city": "Miasto",
        "state": "Województwo",
        "zip": "Kod pocztowy",
        "country": "Kraj",
        "selectCountry": "Wybierz kraj",
        "buyNowTip": "Przed kontynuowaniem wybierz istniejącą lub nową metodę płatności",
        "licenses": "LICENCJE",
        "version": "Wersja ${0}",
        "viewReleaseNotes": "Zobacz uwagi do wydania na stronie",
        "updateAndRenewMaintenance": "AKTUALIZUJ I ODNÓW KONSERWACJĘ",
        "renewGetUpdatesUntil": "Odnawiając konserwację, otrzymasz wszystkie aktualizacje HM3 poprzez ${0}",
        "update": "Aktualizacja",
        "updateAndSwitchToFree": "AKTUALIZUJ I PRZEŁĄCZ DO DARMOWEJ WERSJI",
        "updateAndSwitchToFreeDetails1": "Otrzymasz aktualizację, ale Twoje oprogramowanie HM3 (Holdem) powróci do wersji darmowej i będzie miało",
        "updateAndSwitchToFreeDetails2": "ograniczoną funkcjonalność",
        "updateAndSwitch": "Aktualizuj i przełącz",
        "errorCreditCardDigitsOnly": "Numer karty kredytowej powinien zawierać tylko cyfry.",
        "errorCreditCard": "Wprowadź poprawny numer karty.",
        "errorRequired": "Wymagany",
        "errorCardExpired": "Karta wygasła",
        "errorCvv": "CVV powinien mieć ${0} cyfr.",
        "cardInfo": "DANE KARTY KREDYTOWEJ",
        "cardNo": "Numer karty",
        "expiry": "Data ważności",
        "year": "rok",
        "month": "miesiąc",
        "month01": "Sty",
        "month02": "Lut",
        "month03": "Mar",
        "month04": "Kwi",
        "month05": "Maj",
        "month06": "Cze",
        "month07": "Lip",
        "month08": "Sie",
        "month09": "Wrz",
        "month10": "Paź",
        "month11": "Lis",
        "month12": "Gru",
        "cvv": "CVV",
        "active": "Aktywne",
        "manageSubscription": "Zarządzaj subskrypcją",
        "youAreUpToDate": "Jesteś na bieżąco",
        "releaseNotes": "Uwagi do wydania dla ${0}",
        "netellerInfo": "Dane konta NETELLER",
        "netellerSignin": "Zaloguj się do konta NETELLER, aby ukończyć zakup.",
        "continue_": "Kontynuuj",
        "netellerAccount": "Konto Neteller",
        "netellerPassword": "Hasło",
        "orderSummary": "PODSUMOWANIE ZAMÓWIENIA: ",
        "changeProducts": "Zmień produkt(y)",
        "total": "Suma",
        "paypalComplete": "PROSZĘ DOKOŃCZYĆ ZAKUP PAYPAL W PRZEGLĄDARCE",
        "paypalOpenedInNewBrowser": "Otworzyliśmy PayPal w nowym oknie domyślnej przeglądarki. Zaloguj się do swojego konta PayPal i dokończ zakup. Po zakończeniu zakupu wróć tutaj i kliknij „Przeładuj licencję”, aby załadować zakupioną licencję",
        "reloadLicense": "Przeładuj licencję",
        "thankYouForPurchase": "Dziękujemy za zakup",
        "purchaseConfirm1": "Wkrótce otrzymasz potwierdzenie e-mailem na ${0}",
        "purchaseConfirm2": "Kliknij przycisk przeładowania licencji poniżej, a zakupiona licencja będzie aktywna.",
        "restricted": "ograniczone",
        "restrictionsWithYourLicense": "OGRANICZENIA TWOJEJ AKTUALNEJ LICENCJI",
        "paymentPleaseChoose": "Proszę wybrać metodę płatności",
        "paymentSelectExisting": "Wybierz istniejącą metodę płatności:",
        "paymentSelectNew": "Dodaj nową metodę płatności:",
        "paymentMethod": "Metoda płatności:",
        "changePaymentMethod": "Zmień metodę płatności",
        "licensedTo": "LICENCJA DLA",
        "learnMore": "Dowiedz się więcej",
        "startTrial": "Rozpocznij okres próbny",
        "purchase": "Zakup",
        "trialSuccessfullyStarted": "Pomyślnie rozpoczęto okres próbny",
        "trialSuccessDetails1": "Twój 14-dniowy okres próbny jest aktywny. Prosimy",
        "trialSuccessDetails2": "ulepszyć",
        "trialSuccessDetails3": " tak szybko, jak to możliwe, aby uniknąć przerw w usłudze.",
        "havingTrouble": "Masz problemy?",
        "contactUs": "Skontaktuj się z nami",
        "startUsing": "Zacznij używać HM3 teraz",
        "missedUpdates": "${0} brakujących aktualizacji",
        "updatesAreCritical": "Aktualizacje są kluczowe dla zapewnienia, że HM3 będzie kontynuował importowanie historii rozdań po wprowadzeniu zmian w oprogramowaniu przez strony pokerowe. Nowe funkcje są również udostępniane poprzez aktualizacje.",
        "view": "Wyświetl",
        "oneYearOfUpdates": "Zawiera rok aktualizacji",
        "renew": "Odnów (${0})",
        "startingAt": "Od",
        "upgrade": "Ulepszenie",
        "removesRestrictions1": "Usuwa",
        "removesRestrictions2": "ograniczenia",
        "removesRestrictions3": " i zawiera rok aktualizacji",
        "upgradePrice": "Ulepszenie (${0})",
        "required": "Wymagane",
        "continueFreemium": "Kontynuuj bezpłatną wersję",
        "defaultFatalError": "Wystąpił nieoczekiwany wewnętrzny błąd serwera i powiadomiono administratora. Spróbuj ponownie później.",
        "restrictCashHandsType": "Rozdania gotówkowe",
        "restrictTourneyType": "Turniej",
        "restrictLimitCashHandsType": "Rozdania gotówkowe limit",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Dane raportu",
        "restrictCashHands": "$ ${0} i poniżej",
        "restrictLimitCashHands": "$ ${0} i poniżej",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Stołów",
        "restrictReportData": "Ostatnie ${0} rąk",
        "restrictionUnlimited": "Nieograniczone",
        "errorState": "Wymagane",
        "activeHoldemLicense": "AKTYWNA LICENCJA HOLDEM",
        "activeOmahaLicense": "AKTYWNA LICENCJA OMAHA",
        "reinstallOldVersion": "Przywraca starą wersję",
        "removesRestrictions3b": "i powraca do Twojej płatnej licencji, ale aktualizacje są",
        "removesRestrictions4b": "NIE WLICZONE",
        "noActiveHoldemLicense": "BRAK AKTYWNEJ LICENCJI HOLDEM",
        "noActiveOmahaLicense": "BRAK AKTYWNEJ LICENCJI OMAHA",
        "free": "DARMOWA",
        "netellerSecureId": "Bezpieczne ID",
        "recurringPriceDescription": "${0} ${1} wliczone*",
        "recurringYear": "Rok",
        "recurringMonth": "Miesiąc",
        "recurringDay": "Dzień",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>ograniczone</b> do $0.50 dużych w ciemno\nFixed Limit Cash <b>ograniczone</b> do $1.00 dużych w ciemno\nTurnieje <b>ograniczone</b> do $22.00 wpisowego.",
        "afterDiscount": "Cena po ograniczonym czasowo rabacie",
        "upgradeDiscount": "RABAT NA ULEPSZENIE",
        "discountExpires": "Rabat wygasa dnia 31 marca 2019",
        "discountSinglePurchase": "Rabat dotyczy jednego zakupu.",
        "errorNetellerAccount": "Niepoprawne ID konta Neteller",
        "errorNetellerSecureId": "Wprowadź 6-cyfrowe bezpieczne ID",
        "continueTrial": "Kontynuuj trial",
        "continueTrialDaysRemaining": "(pozostało ${0} dni)",
        "netellerInvalidCredentials": "Nie mogliśmy zweryfikować Twoich danych Neteller. Proszę spróbować zalogować się ponownie.",
        "faq": "FAQ",
        "forMoreDetails": ", aby dowiedzieć się więcej na temat zarządzania rocznym odnowieniem wsparcia i konserwacji.",
        "recurringSubscription": "*Metoda płatności jest wymagana do corocznego odnawiania wsparcia i konserwacji w wysokości $${0}, które zostanie rozliczone w ciągu jednego roku (${1}). Wyświetl ",
        "positivePrice": "Roczne odnowienie wsparcia i konserwacji $$ {0} będzie rozliczane w ciągu jednego roku (${1}). Wyświetl ",
        "paymentSeeWebsite1": "Zobacz",
        "paymentSeeWebsite2": "SKLEP",
        "paymentSeeWebsite3": " dla innych opcji płatności",
        "paymentOr": "- LUB -",
        "couldNotStartMlaTitle": "Napotkaliśmy problem",
        "couldNotStartMlaText": "Nie można uruchomić Moje Licencje. Administrator został powiadomiony. Sprawdź ponownie później. Jeśli problem będzie się powtarzał, skontaktuj się z naszym wsparciem.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    portugese :{
        "notAllowedByLicense": "Mãos não permitidas pela licença",
        "selectHandToExport": "Selecione a mão para exportar",
        "selectFormat": "Selecione o formato",
        "originalFormat": "Formato Original",
        "ctrlCToCopy": "CTRL-C para copiar para área de transferência",
        "availableTags": "Etiquetas disponíveis",
        "welcomeToHm3": "Seja bem vindo ao HoldemManager 3 Replayer!",
        "theme": "Tema:",
        "deck": "Cartas de Jogar:",
        "showHandResults": "Mostrar os resultados de uma mão",
        "showHeroCards": "Mostrar sempre o Hero nas cartas do jogador",
        "showBB": "Mostrar fichas na BB",
        "combineFolds": "Combinar Folds",
        "maskPlayerNames": "Esconder o nome dos jogadores",
        "statsUpToTimeOfHand": "Estatísticas para o tempo da mão",
        "showHud": "Mostrar HUD",
        "replaySpeed": "Replay a velocidade",
        "hand": "Mão",
        "next100Hands": "Próximas 100 Mãos",
        "prev100Hands": "100 Mãos Anteriores",
        "addEditHandMarking": "Adicionar/Editar Marcações",
        "wonXBB": "Won ${0} BB",
        "lostXBB": "Lost ${0} BB",
        "wonLossNA": "Won/Loss NA",
        "potBB": "Pote: ${0} BB",
        "userWentAllin": "Utilizador foi Allin",
        "pot": "Pote: ${0}",
        "potOdds": "Pot Odds: ${0}:1",
        "hhGameStart": "${0} jogo ${1} começa nos ${2}",
        "hhHandNotes": "Nota(s) de Mão(s)",
        "hhFold": "${0} Folds",
        "hhCheck": "${0} Checks",
        "hhCall": "${0} Calls ${1}",
        "hhBet": "${0} Bets ${1}",
        "hhRaise": "${0} Raises ${1}",
        "hhReturnedTo": "${1} Voltou para ${0}",
        "hhWin": "${0} Wins ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "A ação terminou.",
        "hhMuck": "${0} mucks ${1}",
        "hhShow": "${0} mostrar ${1}",
        "hhPostSB": "${0} posts small blind",
        "hhPostBB": "${0} posts big blind",
        "hhPostDB": "${0} posts a dead blind",
        "backToReleaseNotes": "Voltar para a liberação de notas",
        "backToMyLicense": "Voltar para a minha licença",
        "backToCardInfo": "Voltar para a informação do cartão de crédito",
        "backToPayment": "Voltar para o método de pagamento",
        "orderBuyNow": "Comprar Agora",
        "orderProceed": "Continuar",
        "headerTextTrial": "Teste (${0} Dias Restantes)",
        "headerTextFree": "Gratuíto",
        "smallStakes": "Small Stakes",
        "allStakes": "All Stakes",
        "smallStakesCaps": "SMALL STAKES",
        "allStakesCaps": "ALL STAKES",
        "smallStakesMaintenance": "MANUTENÇÃO SMALL STAKES",
        "allStakesMaintenance": "MANUTENÇÃO ALL STAKES",
        "buyHoldemSmallStakes": "Holdem Small Stakes",
        "buyHoldemAllStakes": "Holdem All Stakes",
        "buyHoldemOmahaAllStakes": "All Stakes",
        "buyOmahaSmallStakes": "Omaha Small Stakes",
        "buyOmahaAllStakes": "Omaha All Stakes",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "Aplicações HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Expirou em ${0}",
        "expiresOn": "Expira em ${0}",
        "recommended": "RECOMENADO",
        "seeAllOptionsInStore": "Ver todas as opções na loja",
        "paypalExternalBrowser": "O PayPal irá abrir uma outra página para que possa continuar a processar o pagamento.",
        "skrillExternalBrowser": "Skrill irá abrir uma outra página para que possa continuar a processar o pagamento.",
        "selectProduct": "SELECIONE O PRODUTO",
        "availableUpdate": "ATUALIZAÇÃO DISPONÍVEL",
        "versionAvailable": "A versão ${0} está disponível: ${1}",
        "fullFaq": "Mostrar todas as notas FAQ",
        "reviewOptions": "Reveja a opção de manutenção do Holdem antes de iniciar o processo de atualização",
        "maintenanceOptions": "Opções de Manutenção",
        "addProductToLicense": "ADICIONAR ${0} PARA A ATUAL LICENÇA",
        "purchasePrice": "Comprar (${0})",
        "errorName": "Por favor introduza o seu Nome Completo",
        "errorAddress": "Por favor introduza a sua Morada e Número",
        "errorCountry": "Por favor introduza o seu País",
        "errorCity": "Por favor introduza a sua Cidade",
        "errorZip": "Por favor introduza o seu Código Postal",
        "billingInfo": "Informação de Faturação",
        "name": "Nome Completo",
        "address": "Morada",
        "city": "Cidade",
        "state": "Estado/Província",
        "zip": "Código Postal",
        "country": "País",
        "selectCountry": "Selecione o país",
        "buyNowTip": "Por favor selecione uma forma de pagamento já existente ou introduza um novo método de pagamento antes de continuar",
        "licenses": "LICENÇAS",
        "version": "Versão ${0}",
        "viewReleaseNotes": "Visualizar versão de notas na página do site",
        "updateAndRenewMaintenance": "ATUALIZAR & RENOVAR A MANUTENÇÃO ",
        "renewGetUpdatesUntil": "Ao renovar a manutenção irá receber todas as atualizações do HM3 através de ${0}",
        "update": "Atualizar",
        "updateAndSwitchToFree": "ATUALIZAR & ALTERAR PARA A VERSÃO GRATUÍTA",
        "updateAndSwitchToFreeDetails1": "Irá receber uma atualização mas o programa HM3 (Holdem) será revertido para a versão gratuíta ",
        "updateAndSwitchToFreeDetails2": "funcionalidade limitada",
        "updateAndSwitch": "Atualizar & Alterar",
        "errorCreditCardDigitsOnly": "O cartão de crédito deverá apenas conter números.",
        "errorCreditCard": "Por favor introduza um número válido do cartão.",
        "errorRequired": "Requerido",
        "errorCardExpired": "O Cartão Expirou",
        "errorCvv": "O CVV deverá ser ${0} em números",
        "cardInfo": "INFORMAÇÃO DO CARTÃO DE CRÉDITO",
        "cardNo": "Num do Cartão",
        "expiry": "Expira",
        "year": "ano",
        "month": "mês",
        "month01": "Jan",
        "month02": "Fev",
        "month03": "Mar",
        "month04": "Abril",
        "month05": "Maio",
        "month06": "Jun",
        "month07": "Jul",
        "month08": "Agosto",
        "month09": "Set",
        "month10": "Out",
        "month11": "Nov",
        "month12": "Dec",
        "cvv": "CVV",
        "active": "Ativo",
        "manageSubscription": "Gestão de Subscrição",
        "youAreUpToDate": "Está atualizado",
        "releaseNotes": "Release notes for ${0}",
        "netellerInfo": "Informação da conta NETELLER",
        "netellerSignin": "Entre na sua conta NETELLER para completar a sua compra.",
        "continue_": "Continue",
        "netellerAccount": "Conta Neteller",
        "netellerPassword": "Palavra Passe",
        "orderSummary": "RESUMO DO PEDIDO",
        "changeProducts": "Alterar Produto(s)",
        "total": "Total",
        "paypalComplete": "POR FAVOR COMPLETE A SUA COMPRA PAYPAL NA PÁGINA WEB",
        "paypalOpenedInNewBrowser": "O PayPal foi aberto em uma janela do navegador de internet padrão. Por favor entre com a sua conta PayPal e complete a compra. Assim que a compra seja realizada, volte aqui e pressione \"Recarregar Licença\" para que a licença que comprou possa ficar disponível.",
        "reloadLicense": "Recarregar Licença",
        "thankYouForPurchase": "Obrigado Pela Sua Compra",
        "purchaseConfirm1": "Irá receber um email em breve com a confirmação em ${0}",
        "purchaseConfirm2": "Por favor pressione o botão recarregar licença e a sua licença comprada ficará ativa.",
        "restricted": "restrito",
        "restrictionsWithYourLicense": "RESTRIÇÕES COM A SUA LICENÇA ATUAL",
        "paymentPleaseChoose": "Por favor escolha um método de pagamento",
        "paymentSelectExisting": "Selecione um método de pagamento já existente",
        "paymentSelectNew": "Método de Pagamento",
        "paymentMethod": "Método de Pagamento:",
        "changePaymentMethod": "Alterar o Método de Pagamento",
        "licensedTo": "LICENÇA PARA",
        "learnMore": "Saber mais",
        "startTrial": "Iniciar Período de Teste ",
        "purchase": "Compra",
        "trialSuccessfullyStarted": "Iniciou o Período de Teste Com Sucesso",
        "trialSuccessDetails1": "O seu período de teste de 14 dias está ativo. Por favor...",
        "trialSuccessDetails2": "Atualizar",
        "trialSuccessDetails3": "...Assim que possível para evitar interrupções no seu serviço.",
        "havingTrouble": "Está a ter problemas?",
        "contactUs": "Contate-nos",
        "startUsing": "Começar a usar o HM3 agora",
        "missedUpdates": "${0} atualizações perdidas",
        "updatesAreCritical": "As atualizações são importantes para assegurarem que o HM3 continua a importar o seu histórico de mãos mesmo quando as salas de jogo alteram o seu próprio programa. Os novos recursos e funcionalidades também são disponíveis através das atualizações.",
        "view": "Visualizar",
        "oneYearOfUpdates": "Inclui um ano de atualizações",
        "renew": "Renovar (${0})",
        "startingAt": "Começar Em",
        "upgrade": "Atualizar",
        "removesRestrictions1": "Remover",
        "removesRestrictions2": "restrições",
        "removesRestrictions3": "e inclui um ano de atualizações",
        "upgradePrice": "Atualizar (${0})",
        "required": "Requirido",
        "continueFreemium": "Continue na Versão Gratuíta",
        "defaultFatalError": "Ocorreu um erro inesperado no servidor interno e um administrador foi notificado. Por favor tente efetuar a sua compra mais tarde.",
        "restrictCashHandsType": "Cash Hands",
        "restrictTourneyType": "Torneio",
        "restrictLimitCashHandsType": "Limit Cash Hands",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Relatório de Data",
        "restrictCashHands": "$ ${0} e abaixo",
        "restrictLimitCashHands": "$ ${0} e abaixo",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Mesa(s)",
        "restrictReportData": "Última(s) ${0} Mão(s)",
        "restrictionUnlimited": "Ilimitado",
        "errorState": "Requirido",
        "activeHoldemLicense": "ATIVAR A LICENÇA HOLDEM",
        "activeOmahaLicense": "ATIVAR A LICENÇA OMAHA",
        "reinstallOldVersion": "Reinstalar a Versão Antiga",
        "removesRestrictions3b": "e retorna de volta para a licença paga e as atualizações são",
        "removesRestrictions4b": "NÃO INCLUSO",
        "noActiveHoldemLicense": "SEM LICENÇA ATIVA HOLDEM",
        "noActiveOmahaLicense": "SEM LICENÇA ATIVA OMAHA",
        "free": "GRATUÍTO",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} Incluso*",
        "recurringYear": "Ano",
        "recurringMonth": "Mês",
        "recurringDay": "Dia",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\nTournaments <b>restricted</b> up to $22.00 buy-ins.",
        "afterDiscount": "Preço após desconto por tempo limitado",
        "upgradeDiscount": "DESCONTO ATUALIZADO",
        "discountExpires": "O desconto expira em ${0}",
        "discountSinglePurchase": "O desconto aplica-se apenas a uma compra única.",
        "errorNetellerAccount": "Número ID Inválido de Conta Neteller",
        "errorNetellerSecureId": "Por favor introduza os seis dígitos do Secure ID",
        "continueTrial": "Continuar teste",
        "continueTrialDaysRemaining": "(${0} Dias Restantes)\n",
        "netellerInvalidCredentials": "Nós não pudemos validar as suas credenciais Neteller. Por favor tente entrar novamente.",
        "faq": "FAQ",
        "forMoreDetails": "para obter mais detalhes sobre como administrar a sua renovação anual de suporte e manutenção.",
        "recurringSubscription": "* O Método de Pagamento é necessário para a renovação da Manutenção e Suporte anual de $${0} que será cobrada em um ano (${1}). Visualizar.",
        "positivePrice": "A renovação anual da Manutenção e Suporte de $${0}  será cobrada em um ano  (${1}). Visualizar.",
        "paymentSeeWebsite1": "Veja",
        "paymentSeeWebsite2": "LOJA",
        "paymentSeeWebsite3": "para outras opções de pagamento",
        "paymentOr": "- OU - ",
        "couldNotStartMlaTitle": "Nós encontramos um problema",
        "couldNotStartMlaText": "Não poderá Iniciar Minhas Licenças. Um Administrador foi informado. Por favor volte a verificar novamente mais tarde. Se o problema persistir, por favor contacte o nosso suporte.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    portugese_br : {
        "notAllowedByLicense": "Mão não permitida pela licença",
        "selectHandToExport": "Selecione a mão para exportar",
        "selectFormat": "Selecionar o formato",
        "originalFormat": "Formato Original",
        "ctrlCToCopy": "Ctrl-C para copiar para a área de transferência",
        "availableTags": "Marcas Disponíveis",
        "welcomeToHm3": "Seja bem vindo ao HoldemManager3 Replayer!",
        "theme": "Tema",
        "deck": "Baralho",
        "showHandResults": "Mostrar Resultado da Mão",
        "showHeroCards": "Sempre mostrar o Herói quando as cartas do jogador estão viradas para baixo",
        "showBB": "Mostrar fichas na BB",
        "combineFolds": "Combinar Folds",
        "maskPlayerNames": "Mascarar os nomes do jogador",
        "statsUpToTimeOfHand": "Estatísticas até o tempo da mão",
        "showHud": "Mostrar HUD",
        "replaySpeed": "Velocidade de Repetição",
        "hand": "Mão",
        "next100Hands": "Próximas 100 mãos",
        "prev100Hands": "100 Mãos Anteriores",
        "addEditHandMarking": "Adicionar/Editar Marcação Manual",
        "wonXBB": "Won ${0} BB",
        "lostXBB": "Lost ${0} BB",
        "wonLossNA": "Won/Loss NA",
        "potBB": "Pote: ${0} BB",
        "userWentAllin": "Usuário foi Allin",
        "pot": "Pote: ${0}",
        "potOdds": "Pot Odds: ${0}:1",
        "hhGameStart": "${0} jogo ${1} começa em ${2}",
        "hhHandNotes": "Nota(s) da Mão",
        "hhFold": "${0} Folds",
        "hhCheck": "${0} Checks",
        "hhCall": "${0} Calls ${1}",
        "hhBet": "${0} Bets ${1}",
        "hhRaise": "${0} Raises ${1}\n",
        "hhReturnedTo": "${1} Returned to ${0}",
        "hhWin": "${0} Wins ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "A ação acabou.",
        "hhMuck": "${0} mucks ${1}",
        "hhShow": "${0} shows ${1}",
        "hhPostSB": "${0} posts small blind",
        "hhPostBB": "${0} posts big blind",
        "hhPostDB": "${0} posts a dead blind",
        "backToReleaseNotes": "Voltar para as Notas da Versão atual",
        "backToMyLicense": "Voltar para a Minha Licença",
        "backToCardInfo": "Voltar para a Informação do Cartão de Crédito",
        "backToPayment": "Voltar para o Método de Pagamento",
        "orderBuyNow": "Comprar Agora",
        "orderProceed": "Continuar",
        "headerTextTrial": "O período de teste (${0} Dias Seguintes)",
        "headerTextFree": "Gratuíto",
        "smallStakes": "Small Stakes",
        "allStakes": "All Stakes\n",
        "smallStakesCaps": "SMALL STAKES",
        "allStakesCaps": "ALL STAKES",
        "smallStakesMaintenance": "MANUTENÇÃO DE SMALL STAKES ",
        "allStakesMaintenance": "MANUTENÇÃO DE TODAS AS STAKES",
        "buyHoldemSmallStakes": "Holdem Small Stakes",
        "buyHoldemAllStakes": "Hodem Todas as Stakes",
        "buyHoldemOmahaAllStakes": "All Stakes",
        "buyOmahaSmallStakes": "Omaha Small Stakes",
        "buyOmahaAllStakes": "Omaha All Stakes",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "HOLDEM",
        "omaha": "Omaha",
        "hmApps": "HM Apps",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Expirou em ${0}",
        "expiresOn": "Expira em ${0}",
        "recommended": "RECOMENDADO",
        "seeAllOptionsInStore": "Veja todas as opções da loja",
        "paypalExternalBrowser": "O PayPal será aberto numa janela externa para que você possa completar o pagamento.",
        "skrillExternalBrowser": "A Skrill irá abrir uma janela externa para que você possa completar o pagamento.",
        "selectProduct": "SELECIONE O PRODUTO",
        "availableUpdate": "ATUALIZAÇÃO DISPONÍVEL",
        "versionAvailable": "Versão ${0} está disponível: ${1}",
        "fullFaq": "FAQ de notas da versão completa",
        "reviewOptions": "Reveja as opções de manutenção Holdem antes de continuar com a atualização",
        "maintenanceOptions": "Opções de Manutenção",
        "addProductToLicense": "ADICIONE ${0} PARA A SUA ATUAL LICENÇA",
        "purchasePrice": "Compra (${0})\n",
        "errorName": "Por favor insira o seu Nome Completo",
        "errorAddress": "Por favor insira o nome da sua Rua e número",
        "errorCountry": "Por favor insira o seu País",
        "errorCity": "Por favor insira a sua Cidade",
        "errorZip": "Por favor insira o seu CEP",
        "billingInfo": "Informação de Cobrança",
        "name": "Nome Completo",
        "address": "Nome da Rua",
        "city": "Cidade",
        "state": "Estado/Bairro",
        "zip": "CEP",
        "country": "País",
        "selectCountry": "Selecione o País",
        "buyNowTip": "Por favor selecione uma opção de pagamento existente ou um novo método antes de continuar",
        "licenses": "LICENÇAS",
        "version": "Versão ${0}",
        "viewReleaseNotes": "Visualizar notas atualizadas no navegador",
        "updateAndRenewMaintenance": "ATUALIZAR & RENOVAR A MANUTENÇÃO",
        "renewGetUpdatesUntil": "Renovando a manutenção você irá receber todas as atualizações do HM3 através de ${0}",
        "update": "Atualizar",
        "updateAndSwitchToFree": "ATUALIZAR & TROCAR PARA A VERSÃO GRATUÍTA",
        "updateAndSwitchToFreeDetails1": "Você irá receber a atualização mas o seu programa HM3 (Holdem) irá ser revertido para a versão gratuíta ",
        "updateAndSwitchToFreeDetails2": "funcionalidade limitada",
        "updateAndSwitch": "Atualizar & Trocar",
        "errorCreditCardDigitsOnly": "O número do seu cartão de crédito deverá conter apenas dígitos.",
        "errorCreditCard": "Por favor insira um número de cartão válido.",
        "errorRequired": "Requerido",
        "errorCardExpired": "O Cartão Expirou",
        "errorCvv": "CVV deverá ser ${0} em dígitos",
        "cardInfo": "INFORMAÇÃO DO CARTÃO DE CRÉDITO",
        "cardNo": "Cartão No",
        "expiry": "Expira",
        "year": "ano",
        "month": "mês",
        "month01": "Jan",
        "month02": "Fev",
        "month03": "Mar",
        "month04": "Abril",
        "month05": "Maio",
        "month06": "Jun",
        "month07": "Jul",
        "month08": "Ago",
        "month09": "Set",
        "month10": "Out",
        "month11": "Nov",
        "month12": "Dec",
        "cvv": "CVV",
        "active": "Ativo",
        "manageSubscription": "Gerenciar Assinatura",
        "youAreUpToDate": "Você está atualizado até a data",
        "releaseNotes": "Versão de notas para ${0}",
        "netellerInfo": "Informação da Conta NETELLER",
        "netellerSignin": "Inicie a sessão com a sua conta NETELLER para completar a sua compra",
        "continue_": "Continuar",
        "netellerAccount": "Conta Neteller",
        "netellerPassword": "Senha",
        "orderSummary": "RESUMO DO PEDIDO",
        "changeProducts": "Mudar produto (s)",
        "total": "Total",
        "paypalComplete": "POR FAVOR COMPLETE A SUA COMPRA ATRAVÉS DA PAPYPAL NO SEU NAVEGADOR",
        "paypalOpenedInNewBrowser": "Nós abriremos o PayPal no seu navegador de internet padrão. Por favor inicie sessão com a sua conta PayPal e complete a sua compra. Assim que a sua compra esteja completa, volte aqui e clique em \"Recarregar Licença\" para que a licença que você comprou seja atualizada.",
        "reloadLicense": "Recarregar a licença",
        "thankYouForPurchase": "Obrigado pela sua compra",
        "purchaseConfirm1": "Você irá receber um email em breve com a confirmação em ${0}",
        "purchaseConfirm2": "Por favor clique em recarregar licença no botão abaixo e a sua licença comprada ficará ativa.",
        "restricted": "restrito",
        "restrictionsWithYourLicense": "RESTRIÇÕES COM A SUA LICENÇA ATUAL",
        "paymentPleaseChoose": "Por favor escolha um método de pagamento",
        "paymentSelectExisting": "Selecione um método de pagamento já existente",
        "paymentSelectNew": "Método de Pagamento",
        "paymentMethod": "Método de Pagamento",
        "changePaymentMethod": "Mudar o Método de Pagamento",
        "licensedTo": "LICENÇA PARA",
        "learnMore": "Leia mais",
        "startTrial": "Iniciar o teste",
        "purchase": "Compra",
        "trialSuccessfullyStarted": "O teste começou com sucesso",
        "trialSuccessDetails1": "Os seus 14 dias de teste estão agora ativos. Por favor",
        "trialSuccessDetails2": "atualizar",
        "trialSuccessDetails3": "assim que for possível para evitar interrupções no seu serviço.",
        "havingTrouble": "Você está tendo problemas?",
        "contactUs": "Entre em contato conosco",
        "startUsing": "Iniciar usando o HM3 agora",
        "missedUpdates": "${0} atualizações em falta",
        "updatesAreCritical": "As atualizações são importantes para assegurarem que o HM3 continua a importação do histórico das suas mãos quando que as salas de poker mudam o seu programa. Novos recursos e funcionalidade serão também adicionados com essas atualizações.",
        "view": "Visualizar",
        "oneYearOfUpdates": "Inclui o ano das atualizações",
        "renew": "Renova (${0})",
        "startingAt": "Iniciando em",
        "upgrade": "Atualizar",
        "removesRestrictions1": "Remove",
        "removesRestrictions2": "restrições",
        "removesRestrictions3": "e inclui um ano de atualizações",
        "upgradePrice": "Atualizar (${0})",
        "required": "Requerido",
        "continueFreemium": "Continuar com a Versão Gratuíta",
        "defaultFatalError": "Um erro interno inesperado ocorreu e um administrador foi informado. Por favor tente comprar novamente mais tarde.",
        "restrictCashHandsType": "Mãos de Cash",
        "restrictTourneyType": "Torneio",
        "restrictLimitCashHandsType": "Mãos de Limit Cash",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Reportar Data",
        "restrictCashHands": "$ ${0} e abaixo",
        "restrictLimitCashHands": "$ ${0} e abaixo",
        "restrictTourney": "Máx ${0}",
        "restrictHud": "Máx ${0} Table(s)\n",
        "restrictReportData": "Últimas ${0} Mãos",
        "restrictionUnlimited": "Ilimiatdo",
        "errorState": "Requerido",
        "activeHoldemLicense": "LICENÇA HOLDEM ATIVADA",
        "activeOmahaLicense": "LICENÇA OMAHA ATIVADA",
        "reinstallOldVersion": "Reinstale a Versão Antiga",
        "removesRestrictions3b": "e reverte novamente para a sua versão paga mas as atualizações são",
        "removesRestrictions4b": "NÃO INCLUSO",
        "noActiveHoldemLicense": "SEM LICENÇA HOLDEM ATIVA",
        "noActiveOmahaLicense": "SEM LICENÇA OMAHA ATIVA",
        "free": "GRATUÍTO",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} Incluso",
        "recurringYear": "Ano",
        "recurringMonth": "Mês",
        "recurringDay": "Dia",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>restricted</b> up to $0.50 big blinds\nFixed Limit Cash <b>restricted</b> up to $1.00 big blinds\nTournaments <b>restricted</b> up to $22.00 buy-ins.",
        "afterDiscount": "Preço depois do tempo limitado de desconto",
        "upgradeDiscount": "DESCONTO ATUALIZADO",
        "discountExpires": "O desconto expira em ${0}",
        "discountSinglePurchase": "O desconto só se aplica para uma compra única",
        "errorNetellerAccount": "Número de ID da Conta Neteller Inválido",
        "errorNetellerSecureId": "Por favor insira os 6 dígitos do seu ",
        "continueTrial": "Continuar com o teste",
        "continueTrialDaysRemaining": "(${0} Dias Restantes)",
        "netellerInvalidCredentials": "Nós não podemos validar a sua credencial Netteler. Por favor tente iniciar novamente.",
        "faq": "FAQ",
        "forMoreDetails": "para mais detalhes em como gerenciar a sua renovação anual de Suporte & Manutenção.",
        "recurringSubscription": "O Método de Pagamento é solicitado para a renovação anual de Suporte & Manutenção de $${0}  pelo qual será debitaqdo em um ano (${1}). Visualizar",
        "positivePrice": "A renovação de Suporte & Manutenção anual de $${0} será debitada em um ano ${1}). Visualizar",
        "paymentSeeWebsite1": "Veja",
        "paymentSeeWebsite2": "LOJA",
        "paymentSeeWebsite3": "para outras opções de pagamento",
        "paymentOr": "- OU -",
        "couldNotStartMlaTitle": "Nós encontramos um problema",
        "couldNotStartMlaText": "Não pode Iniciar as Minhas Licenças. Um Administrador foi informado. Por favor volte a verificar novamente mais tarde. Se o problema persistir, por favor entre em contato com o nosso suporte.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    romanian : {
        "notAllowedByLicense": "Mâna nu este Permisă de Licență",
        "selectHandToExport": "Selectează Mâna pentru Exportare",
        "selectFormat": "Selectează Formatul...",
        "originalFormat": "Formatul Original",
        "ctrlCToCopy": "Ctrl-C pentru Copiere pe Clipboard",
        "availableTags": "Etichete Disponibile",
        "welcomeToHm3": "Bine ai venit la HoldemManager 3 Replayer!",
        "theme": "Tema:",
        "deck": "Pachetul:",
        "showHandResults": "Arată Rezultatele Mânii ",
        "showHeroCards": "Întotdeauna Arată Cărțile Principale",
        "showBB": "Arată Jetoanele în BB:",
        "combineFolds": "Aruncări Combinate:",
        "maskPlayerNames": "Ascunde Numele Jucătorului:",
        "statsUpToTimeOfHand": "Intervalul de Timp pentru Mână:",
        "showHud": "Arată HUD:",
        "replaySpeed": "Viteza reluării:",
        "hand": "Mâna",
        "next100Hands": "Următoarele 100 de Mâini",
        "prev100Hands": "Cele 100 de Mâini Anterioare",
        "addEditHandMarking": "Adăugare/Editare Marcaje Mână",
        "wonXBB": "Ai câștigat ${0} BB",
        "lostXBB": "Ai pierdut ${0} BB",
        "wonLossNA": "Câștiguri/Pierderi NA",
        "potBB": "Pot: ${0} BB",
        "userWentAllin": "Utilizatorul a Mizat AllIn",
        "pot": "Pot: ${0}",
        "potOdds": "Cote Pot: ${0}:1",
        "hhGameStart": " ${0} jocul ${1} începe de la ${2}",
        "hhHandNotes": "Notă/Note Mână ",
        "hhFold": "${0} Se Aruncă",
        "hhCheck": "${0} Verificat",
        "hhCall": "${0} Cere ${1}",
        "hhBet": "${0} Pariază ${1}",
        "hhRaise": "${0} Crește Miza cu ${1}",
        "hhReturnedTo": "${1} Obținuți de ${0}",
        "hhWin": "${0} A câștigat ${1}",
        "hhRake": "Miza:${0}",
        "hhActionEnded": "Acțiunea s-a terminat.",
        "hhMuck": "${0} distruge miza cu ${1}",
        "hhShow": "${0} arată ${1}",
        "hhPostSB": "${0} joacă cu blind-uri mici",
        "hhPostBB": "${0} joacă cu blind-uri mari",
        "hhPostDB": "${0} joacă cu un blind mort",
        "backToReleaseNotes": "Înapoi la Notele de Eliberare",
        "backToMyLicense": "Înapoi la Licența Mea",
        "backToCardInfo": "Înapoi la Informații Card de Credit",
        "backToPayment": "Înapoi la Metoda de Plată",
        "orderBuyNow": "Cumpără Acum",
        "orderProceed": "Continuă",
        "headerTextTrial": "Demo (${0} Zile Rămase)",
        "headerTextFree": "Gratis",
        "smallStakes": "Mize Mici",
        "allStakes": "Toate Mizele",
        "smallStakesCaps": "MIZE MICI",
        "allStakesCaps": "TOATE MIZELE",
        "smallStakesMaintenance": "ÎNTREȚINERE MIZE MICI",
        "allStakesMaintenance": "ÎNTREȚINERE TOATE MIZELE",
        "buyHoldemSmallStakes": "Holdem Mize Mici",
        "buyHoldemAllStakes": "Holdem Toate Mizele",
        "buyHoldemOmahaAllStakes": "Toate Mizele",
        "buyOmahaSmallStakes": "Omaha Mize Mici",
        "buyOmahaAllStakes": "Omaha Toate Mizele",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "Aplicații HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Expirată în ${0}",
        "expiresOn": "Expiră în ${0}",
        "recommended": "RECOMANDATE",
        "seeAllOptionsInStore": "Vezi toate Opțiunile în Magazin",
        "paypalExternalBrowser": "Pay Pal va deschide o pagină externă de browser pentru a completa procesul de plată.",
        "skrillExternalBrowser": "Skrill va deschide o pagină externă de browser pentru a completa procesul de plată.",
        "selectProduct": "SELECTEAZĂ PRODUSUL",
        "availableUpdate": "ACTUALIZARE DISPONIBILĂ:",
        "versionAvailable": "Versiunea ${0} este disponibilă: ${1}",
        "fullFaq": "FAQ Note Complete despre lansare",
        "reviewOptions": "Citește despre opțiunile de întreținere Holdem înainte de a continua cu actualizarea.",
        "maintenanceOptions": "Opțiuni Întreținere",
        "addProductToLicense": "ADAUGĂ ${0} LA LICENȚA TA ACTUALĂ ",
        "purchasePrice": "Preț de Achiziție (${0})",
        "errorName": "Te rugăm să-ți introduci Numele Complet",
        "errorAddress": "Te rugăm să introduci numele și numărul Străzii",
        "errorCountry": "Te rugăm să introduci Țara",
        "errorCity": "Te rugăm să introduci Orașul",
        "errorZip": "Te rugăm să introduci un Cod Poștal valabil",
        "billingInfo": "INFORMAȚII FACTURARE",
        "name": "Nume Complet",
        "address": "Adresa Străzii",
        "city": "Oraș",
        "state": "Județ/Sector",
        "zip": "Zip/Cod Poștal",
        "country": "Țara",
        "selectCountry": "Selectează o Țară",
        "buyNowTip": "Te rugăm să selectezi o metodă de plată nouă sau una deja existentă înainte de a continua",
        "licenses": "LICENȚE",
        "version": "Versiunea ${0}",
        "viewReleaseNotes": "Vizualizează notele de lansare de pe site",
        "updateAndRenewMaintenance": "ÎNTREȚINERE ACTUALIZARE&REÎNNOIRE",
        "renewGetUpdatesUntil": "Prin alegerea mentenanței de reînnoire, vei primi toate actualizările HM3 prin ${0}",
        "update": "Actualizare",
        "updateAndSwitchToFree": "ACTUALIZARE&TRECERE LA VERSIUNEA GRATUITĂ",
        "updateAndSwitchToFreeDetails1": "Vei primi actualizarea, dar software-ul tău HM3 (Holdem) se va schimba în versiunea Gratuită și vei avea",
        "updateAndSwitchToFreeDetails2": "o funcționalitate limitată",
        "updateAndSwitch": "Actualizează & Schimbă",
        "errorCreditCardDigitsOnly": "Numărul cardului de credit trebuie să conțină doar cifre.",
        "errorCreditCard": "Te rugăm să introduci un card de credit valabil.",
        "errorRequired": "Solicitat",
        "errorCardExpired": "Card Expirat",
        "errorCvv": "CVV-ul trebuie să aibă o lungime de ${0} cifre",
        "cardInfo": "INFORMAȚII CARD DE CREDIT",
        "cardNo": "Nr. Card",
        "expiry": "Expiră",
        "year": "anul",
        "month": "luna",
        "month01": "Ian",
        "month02": "Feb",
        "month03": "Mar",
        "month04": "Apr",
        "month05": "Mai",
        "month06": "Iun",
        "month07": "Iul",
        "month08": "Aug",
        "month09": "Sep",
        "month10": "Oct",
        "month11": "Nov",
        "month12": "Dec",
        "cvv": "CVV",
        "active": "Activ",
        "manageSubscription": "Gestionează Abonamentul",
        "youAreUpToDate": "Este valid până la data de ",
        "releaseNotes": "Note de lansare pentru ${0}",
        "netellerInfo": "Informații cont  NETELLER",
        "netellerSignin": "Loghează-te în contul tău NETELLER pentru a putea completa achiziția",
        "continue_": "Continuă",
        "netellerAccount": "Cont Neteller",
        "netellerPassword": "Parola ",
        "orderSummary": "SUMAR COMANDĂ",
        "changeProducts": "Schimbă Produs/e",
        "total": "Total",
        "paypalComplete": "TE RUGĂM SĂ FINALIZEZI ACHIZIȚIA DIN CONTUL TĂU DE PAYPAL",
        "paypalOpenedInNewBrowser": "Am creat o fereastră în browserul de internet pentru logarea în contul tău de PayPal. Te rugăm să te loghezi în contul tău de PayPal și să finalizezi achiziția. Imediat ce ai finalizat achiziția, întoarce-te aici și apasă butonul \"Reîncărcare Licență\" pentru a încărca licența pe care tocmai ai cumpărat-o.",
        "reloadLicense": "Reîncărcare Licență",
        "thankYouForPurchase": "Îți Mulțumim pentru Achiziție",
        "purchaseConfirm1": "Vei primi un email de confirmare intr-un interval scurt de timp la ${0}",
        "purchaseConfirm2": "Vei primi un email de confirmare într-un interval scurt de timp la ${0}",
        "restricted": "restricționat",
        "restrictionsWithYourLicense": "RESTRICȚII PENTRU LICENȚA TA ACTUALĂ",
        "paymentPleaseChoose": "Te rugăm să alegi o metodă de plată",
        "paymentSelectExisting": "Selectează o metodă de plată dintre cele existente:",
        "paymentSelectNew": "Adaugă o nouă metodă de plată:",
        "paymentMethod": "Metodă de Plată:",
        "changePaymentMethod": "Schimbă Metoda de Plată",
        "licensedTo": "LICENȚIAT PENTRU",
        "learnMore": "Află mai multe",
        "startTrial": "Începe Versiunea Demo",
        "purchase": "Achiziționează",
        "trialSuccessfullyStarted": "Versiunea Demo a început cu Succes",
        "trialSuccessDetails1": "Versiunea ta demo de 14 zile este activă. Te rugăm ",
        "trialSuccessDetails2": "să actualizezi",
        "trialSuccessDetails3": "cât de curând posibil pentru a evita orice fel de întreruperi în furnizarea serviciului.",
        "havingTrouble": "Întâmpini probleme?",
        "contactUs": "Contactează-ne",
        "startUsing": "Începe să utilizezi HM3 chiar acum",
        "missedUpdates": " ${0} actualizări ratate",
        "updatesAreCritical": "Actualizările sunt esențiale pentru a asigura continuitatea HM3 și posibilitatea de a importa istoricele mâinilor jucate după ce site-ul de poker își modifică software-ul. Noi caracteristici și funcții sunt lansate odată cu actualizările realizate de noi.",
        "view": "Vizualizare",
        "oneYearOfUpdates": "Include un an de actualizări",
        "renew": "Reînnoire ${0})",
        "startingAt": "Începe La ",
        "upgrade": "Actualizare",
        "removesRestrictions1": "Elimină",
        "removesRestrictions2": "restricțiile\n",
        "removesRestrictions3": "și include un an de actualizări",
        "upgradePrice": "Actualizare (${0})",
        "required": "Necesară",
        "continueFreemium": "Continuă cu Versiunea Gratuită",
        "defaultFatalError": "O eroare internă neașteptată a survenit la server și un administrator a fost informat despre situație. Te rugăm să încerci să efectuezi achiziția din nou, mai târziu.",
        "restrictCashHandsType": "Mâini Cash",
        "restrictTourneyType": "Turneu",
        "restrictLimitCashHandsType": "Mâini Cash Limitate",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Raport de Date",
        "restrictCashHands": "$ ${0} și jos",
        "restrictLimitCashHands": "$ ${0} și jos",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Masă/Mese",
        "restrictReportData": "Ultimele ${0} Mâini",
        "restrictionUnlimited": "Nelimitată",
        "errorState": "Necesară",
        "activeHoldemLicense": "LICENȚĂ HOLDEM ACTIVĂ",
        "activeOmahaLicense": "LICENȚĂ OMAHA ACTIVĂ",
        "reinstallOldVersion": "Reinstalează Versiunea Veche",
        "removesRestrictions3b": "și reîntoarce-te la licența ta plătită, dar actualizările ",
        "removesRestrictions4b": "NU SUNT INCLUSE",
        "noActiveHoldemLicense": "LICENȚA HOLDEM INACTIVĂ",
        "noActiveOmahaLicense": "LICENȚA OMAHA INACTIVĂ",
        "free": "GRATIS",
        "netellerSecureId": "ID Sigur",
        "recurringPriceDescription": "${0} ${1} Inclus*",
        "recurringYear": "Anul",
        "recurringMonth": "Luna",
        "recurringDay": "Ziua",
        "restrictionsSmall": "Pot Fără Limită/Cu Limită Cash <b>restricționat</b> până la $0.50 blind-uri mari\nLimită Fixă de Cash  <b>restricționată</b> până la $1.00 blind-uri mari\nTurnee <b>restricționate</b> până la $22.00 buy-in-uri.",
        "afterDiscount": "Prețul după oferta de reducere promoțională",
        "upgradeDiscount": "REDUCERE PENTRU UPGRADE",
        "discountExpires": "Reducerea expiră în ${0}",
        "discountSinglePurchase": "Reducerea se aplică unei singure achiziții",
        "errorNetellerAccount": "ID Cont Neteller Invalid",
        "errorNetellerSecureId": "Te rugăm să introduci ID-ul de Siguranță din 5 cifre",
        "continueTrial": "Continuă Versiunea Demo",
        "continueTrialDaysRemaining": "(${0} Zile Rămase)",
        "netellerInvalidCredentials": "Nu am putut să-ți validăm acreditările contului tău de Neteller. Te rugăm să te loghezi din nou.",
        "faq": "FAQ",
        "forMoreDetails": "pentru mai multe detalii despre gestionarea opțiunii de reînnoire anuală a funcției Asistență & Întreținere.",
        "recurringSubscription": "Metoda de plată este necesară pentru reînnoirea opțiunii anuale a funcției Asistență & Întreținere pentru $${0}, aceasta fiind facturată pentru un an (${1}). Vezi",
        "positivePrice": "Reînnoirea opțiunii anuale a funcției Asistență & Întreținere pentru $${0} va fi facturată pentru un an (${1}). Vezi",
        "paymentSeeWebsite1": "Vizitează",
        "paymentSeeWebsite2": "MAGAZINUL",
        "paymentSeeWebsite3": "pentru alte metode de plată",
        "paymentOr": "- SAU -",
        "couldNotStartMlaTitle": "Am întâmpinat o problemă",
        "couldNotStartMlaText": "Nu A Fost Posibilă Pornirea Licențelor Mele. Un Administrator a fost notificat despre această problemă. Te rugăm să verifici din nou, mai târziu. Dacă problema continuă, te rugăm să contactezi echipa noastră de asistență.",
        "skipEndOfHandLabel": "Sări Finalul Mâinii ",
        "inPosition": "Pe Poziție",
        "outOfPosition": "În Afara Poziției",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Succes Cbet: ${0} % <br/>Rata de Câștig: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Eficiență Pariu: ${1}<br/>Pe Poziție: ${2}<br/>În Afara Poziției: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Eficiență Call: ${1}<br/>Pe Poziție: ${2}<br/>În Afara Poziției: ${3}",
        "riverHandFrequencyTip": "Frecvența Mâinii: ${0} % <br/>Rata de Câștig: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Frecvență Mărime Pot: ${0} % <br/>Rata de Câștig: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Curse Câștigate: ${2}",
        "threebetBetFrequencyTip": "3-Pariu: ${0} % <br/>Rata de Câștig: ${1} bb/100",
        "ipOopTip": "${0}<br/>Pe Poziție: ${1}<br/>În Afara Poziției: ${2}",
        "riverHereyoucanfind6": "Aici poți afla cât de des și cât de eficient joci în etapa de River, pe baza mărimii pot-ului.",
        "riverCombinethisview6": "Combină acest mod de vizualizare cu filtrele pentru a afla dacă câștigi mai multe pot-uri mici, pierzi pot-uri mari și altele.",
        "potSizeFrequencyP": "Frecvență Mărime Pot (%)",
        "riverHereyoucanfind5": "Aici poți afla cât de des și cât de eficient joci diverse Cărți întoarse în etapa River.",
        "riverCombinethisview5": "Combină acest mod de vizualizare cu filtrele pentru a afla cum diferă limitele atunci când pariezi, ceri cărți, crești miza și altele.",
        "riverHereyoucanfind4": "Aici poți afla cât de des și cât de eficient joci mâinile în etapa River cu diferite niveluri de putere.",
        "riverCombinethisview4": "Combină acest mod de vizualizare cu filtrele pentru a afla dacă ajungi în etapa de River cu prea multe mâini slabe, dacă mergi în etapa Showdown cu mâini puternice și altele.",
        "riverRiverCallEfficiencyNetWon": "Eficiență Câștig Net la Call River",
        "riverRCE": "Eficiența la Call River (RCE) îți indică nivelul de câștig pentru fiecare blind mare investit în River Calls sau în Check Calls.",
        "riverCombinethisview3": "Combină acest mod de vizualizare cu filtrele pentru a afla cât de eficiente sunt River Calls atunci când joci contra pariurilor CBets, Donk, a diferitelor mărimi de pariuri și altele.",
        "riverSawShowdown": "Vezi Showdown",
        "riverNoShowdown": "Fără Showdown ",
        "riverMadeRiverCbet": "Cbet River Realizat",
        "riverMadeRiverDonkBet": "Pariu River Donk Realizat",
        "riverSmallriverbets": "Pariuri mici River (<50% pot)",
        "riverBigriverbets": "Pariuri mari River (>100% pot)",
        "riverFacedRiverCbet": "Cbet River Întâmpinat",
        "riverFacedRiverDonkBet": "Pariu River Donk Întâmpinat",
        "riverRiverBet": "Pariu River",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Mână Câștigată",
        "riverLostHand": "Mână Pierdută",
        "riverRiverBetEfficiencyNetWon": "Eficiență Câștig Net Pariu River",
        "riverRBE": "Eficiența Pariu River (RBE) indică valoarea câștigului tău pentru fiecare blind mare investit în pariurile river.",
        "riverCombinethisview2": "Combină acest mod de vizualizare cu filtrele pentru a afla cât de eficiente sunt pariurile tale river atunci când realizezi pariuri CBet, Donk, diferite mărimi de pariuri și altele.",
        "riverHereyoucanfind": "Aici poți afla cât de agresiv joci în etapa River și care sunt rezultatele tale pentru fiecare acțiune realizată.",
        "tip": "Pont",
        "riverCombinethisview": "Combină acest mod de vizualizare cu filtrele pentru a afla cum diferă jocul tău atunci când joci agresiv, împotriva unui jucător agresiv și altele.",
        "riverAsPreflopAggressor": "Ca Stil Agresiv Preflop",
        "riverVsPreflopAggressor": "Vs Stil Agresiv Preflop",
        "riverCheckedToRiver": "Verificat la River",
        "handFrequencyP": "Frecvența Mâinii (%)",
        "totalHands": "Total Mâini ",
        "wonAtShowdown": "Câștigate la Showdown",
        "riverAggression": "Agresivitate la River",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "Pariu River Eff",
        "riverWentToShowdown": "Venite la Showdown",
        "riverRiverHoleCards": "Cărți Întoarse la River",
        "riverRiverHandStrength": "Forța Mâinii la River",
        "riverRiverAgression": "Agresivitate la River %",
        "riverRiverCallEfficiency": "Eficiență River Call",
        "riverRiverBetEfficiency": "Eficiență Pariu River",
        "riverRiverPotSize": "Mărime Pot River",
        "numberOfTables": "Numărul de Mese",
        "sessions": "Sesiuni",
        "leakonomicsOpponentNoteColor": "Culoare Notă Adversar",
        "leakonomicsSessionProgressSessionNames": "Lungimea Sesiunii Mai Scurtă;Medie;Mai Lungă",
        "leakonomicsSessionProgressMin": "Evoluția Sesiunii (Min)",
        "netWonBb": "Câștig Net (bb)",
        "leakonomicsSessionsSplit": "Împărțire Sesiuni",
        "leakonomicsPotAmountWonbb": "Valoarea Pot-ului Câștigat (bb)",
        "orLess": "${0} sau mai puțin",
        "leakonomicsAllinSplit": "Împărțire All-In",
        "leakonomicsAllinWinsInaRow": "Câștiguri All-In la Rând",
        "winnings": "Câștiguri ",
        "leakonomicsRollingWindow": "Grafic Ferestre de Rulaj",
        "leakonomicsNetWon": "Câștig Net Sus/Jos",
        "leakonomicsUpDownSessionNames": "Când este în Jos; Neutru; Când este în Sus",
        "leakonomicsPreflopStatsDev": "Dev Statusuri Preflop",
        "leakonomicsBestWrt": "Cel mai bun wrt: ${0} bb",
        "leakonomicsBestWrtAt": "La min ${0}",
        "leakonomicsWinlossSessionNames": "Serii Pierdute; Neutre; Serii Câștigătoare",
        "leakonomicsAllinRate": "Rata All-In",
        "leakonomicsWinningP": "Câștig: ${0}%",
        "leakonomicsLosingP": "Pierdere: ${0}%",
        "leakonomicsBestWrt2": "Cel mai bun wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "La masa/mesele ${0}",
        "at": "La",
        "leakonomicsWinrateBb100P": "Rata de Câștig: 5bb/100",
        "leakonomicsPotsLost": "Pot-uri pierdute: ${0}%",
        "leakonomicsPotsWon": "Pot-uri câștigate: ${0}%",
        "leakonomicsWhenUporDownInSession": "Când este Sus sau Jos în Sesiune",
        "leakonomicsSessionProgress": "Evoluția Sesiunii",
        "leakonomicsAfterAllinSeries": "Seriile După All-In",
        "leakonomicsWhenMultitabling": "Când Este la Mai multe Mese",
        "leakonomicsVsOpponentbyNoteColor": "Vs. Adversar după Culoarea Notei",
        "leakonomicsAfterWinningorlosingapot": "După Câștigarea sau pierderea unui pot",
        "cbetSuccessP": "Nivel Reușită CBet %",
        "winrate": "Rata de Câștig",
        "winrateBB100": "Rata de câștig (bb/100)",
        "cbetActionHU": "Acțiune CBet: Heads Up",
        "cbetActionMultiway": "Acțiune CBet: Moduri Multiple",
        "cbetActionHUNoHands": "Heads Up: Fără Mâini",
        "cbetActionMultiwayNoHands": "Moduri Multiple: Fără Mâini",
        "cbetWonLost": "$ Pierduți / Câștigați",
        "cbetResultsSkippedDonut1Title": "CBet General Sărit ",
        "cbetResultsSkippedDonutSubtitle": "Peste ${0} Mâini<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "CBet General Sărit:Fără Mâini",
        "cbetResultsSkippedDonut2Title": "Nivelul de Reușită General CBet",
        "cbetResultsSkippedDonut2TitleNoHands": "Nivelul de Reușită General CBet: Fără Mâini",
        "hands": "Mâini",
        "cbetActionIP": "Acțiune CBet: Pe Poziție",
        "cbetActionOOP": "Acțiune CBet: În Afara Poziției",
        "cbetNoHandsIP": "Pe Poziție: Fără Mâini",
        "cbetNoHandsOOP": "În Afara Poziției: Fără Mâini",
        "cbetOverallSuccess": "Nivelul de Reușită General",
        "cbetFlopCBetSuccess": "Nivel de Reușită CBet Flop",
        "cbetCBetWinrate": "Rata de Câștig CBet",
        "cbetSkippedCBetWinnings": "Câștiguri Sărite CBet",
        "cbetCBetSuccessBoardTexture": "Nivelul de Reușită CBet: Textura Mesei",
        "cbetCBetSuccessPosition": "Nivelul de Reușită CBet: Poziția",
        "cbetHandStrengthwhenCBettting": "Forța Mâinii când CBetting",
        "cbetCBetSpotsHeadsUpvsMultiway": "Locuri CBet: HeadsUp vs. Moduri Multiple",
        "cbetCBetSpotsInPositionvsOutofPosition": "Locuri CBet: Pe Poziție vs. În Afara Poziției",
        "cbetResultsSkippedCBet": "Rezultate Sărite CBet",
        "bubbleICMDescription5": "Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă și care se bazează pe mărimea efectivă a mizei de la începutul mâinii.",
        "bubblePercentageDescription5": "Procentajul de la premiul în câștiguri de la masă, grupat după mărimea efectivă a mizei",
        "bubblePreflopDescription5": "Status-urile tale la preflop, grupate după mărimea mizei",
        "bubbleEffectiveStackSizebb": "Mărimea Efectivă a Mizei (bb)",
        "bubbleBubbleStackSize": "Mărimea Mizei la Bubble",
        "bubbleCallingAllInRange": "Limita Calling All-In",
        "bubbleSitNGoEntrants": "Intrați Sit 'N Go",
        "bubbleICMDescription4": "Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, grupat după numărul de intrați în turneu.",
        "bubblePercentageDescription4": "Procentajul de la premiul în câștiguri de la masă, grupat după numărul de intrați",
        "bubblePreflopDescription4": "Status-urile tale la preflop, grupate după mărimea mizei tale",
        "bubbleBubblePosition": "Poziția Bubble",
        "bubbleICMDescription3": "Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, bazată pe poziția adoptată de tine la masă.",
        "bubblePercentageDescription3": "Procentajul de la premiul în câștiguri de la masă, grupat după poziția ta",
        "bubblePreflopDescription3": "Status-urile tale la preflop, grupate după poziția ta",
        "bubblePreflopDescription2": "Procentajul de la premiul în câștiguri de la masă, grupat după numărul de jucători rămași la bulă.",
        "bubblePlayersAtBubble": "# Jucătorii la Bubble",
        "bubbleBubblePlayers": "Jucătorii la Bulă la Bubble",
        "bubblePrizePoolP": "Premiul General%",
        "bubbleBubbleStage": "Etapa Bubble",
        "bubbleEVbb100hands": "EV BB/100 Mâini",
        "bubbleICMDescription": "Informațiile prezentate mai jos reprezintă ICM (modelul independent de jetoane) - o reprezentare a premiului în câștigurile de la masă, bazată pe nivelul atins la turneu. Înainte de Bubble reprezintă toate mâinile în care ești implicat înainte de atingerea nivelului din turneu în care următorul jucătorul \"iese afară\", iar ceilalți jucători rămași primesc premiile pentru rundă.",
        "bubblePercentageDescription": "Procentajul de la premiul în câștiguri de la masă, înainte, în timpul și după Bubble",
        "bubblePreflopDescription": "Status-urile tale la preflop, grupate după mărimea mizei tale",
        "bubblePrizePoolWon": "Premiu Câștigat la Masă",
        "bubbleExpectedValue": "Valoarea Așteptată",
        "bubbleAverageStack": "Miza Medie",
        "bubbleCallAIWinrate": "Rata de Câștig Call AI",
        "bubbleShoveAIWinrate": "Rata de Câștig Împinse AI",
        "tooFewHands": "Prea Puține Mâini pentru Acest Raport",
        "bubblePrizePoolWinningsTitle": "Premiu Câștiguri la Masă",
        "bubbleExpectationWhenReachingBubbleTitle": "Așteptările Când Se Atinge Bula",
        "bubblePositionTitle": "Poziție",
        "bubbleBeforeAndAfterTitle": "Înainte Și După",
        "bubbleStackSizeTitle": "Mărime Miză",
        "bubbleCallRangesTitle": "Limite Call",
        "bubbleShoveRangesTitle": "Limite Împinse",
        "tourneyallinRaisingOpenAI": "Creștere Open AI ",
        "tourneyallinRaising3BetAI": "Creștere 3Bet AI",
        "tourneyallinRaisevsOpen": "Creștere vs Deschis",
        "tourneyallinRaisevs3Bet": "Creștere vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Deschis",
        "tourneyallinCallvs3Bet": "Call vs. 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Mărime Efectivă Miză Preflop",
        "tourneyallinRacesWonPAxis": "Curse Câștigate %",
        "tourneyallinEquityPAxis": "Valoare %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Poziție",
        "tourneyallinExpectationAxis": "Așteptări ",
        "threebetResultsTitle": "Rezultate",
        "threebetPositionTitle": "Poziția",
        "threebetRangeTitle": "Trei Limite de Pariu",
        "threebetSuccessTitle": "Trei Niveluri de Reușită la Pariu",
        "threebetFlopHandStrengthTitle": "Forța Mâinii la Flop",
        "threebetWinrate": "Rata de Câștig 3Bet",
        "threebetFrequency": "Frecvența 3Bet",
        "threebetRange": "Limita 3Bet",
        "threebetSuccessRate": "Rata de Reușită 3Bet",
        "threebetFlopWinrate": "Rata de Câștig la Flop",
        "threebetWinrateHandStrengthAxis": "Forța Ratei de Reușită a Mâinii (bb/100)",
        "threebetHandCount": "${0} (${1} Mâini)",
        "threebetWinrateKey": "Rata de Câștig ",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Rata de Câștig (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Nivel de Succes %",
        "threebetNetwonTitle": "Câștig Net",
        "threebetNetwonMin": "Pierdere",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Frecvența Împărțirii Cărților",
        "threebetDealtFrequencyMin": "Mai Puțin Frecvent",
        "threebetDealtFrequencyMax": "Mai Frecvent",
        "tourneyallinExpectedWon": "Câștig Așteptat ",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Necunoscut;Carte Mare;O Pereche;Doua Perechi;3 de Același Fel;Culoare;Flush;Full House;4 de Același Fel;Chintă la Culoare",
        "availableStringRiverMadeHandValueSummary": "Necunoscut;Carte Mare;O Pereche;Doua Perechi;Trei de Același Fel;Culoare;Flush;Full House;Careu;Chintă la Culoare",
        "availableStringFlopFlushTextureTypeAsString": "Flush la Culoare;Flush În Două Nuanțe;Flush Monocrom",
        "availableStringFlopStraightTextureTypeAsString": "Str - Neconectat;Str - Conectat;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Masă Împerecheată; Neîmperecheată",
        "availableStringInPositionOnFlopShort": "\nIP;OOP",
        "availableStringInPositionOnFlopLong": "Pe Poziție;În Afara Poziției",
        "availableStringRiverplayCallEfficiency": "Eficiență Call;Pe Poziție;În Afara Poziției",
        "availableStringRiverplayBetEfficiency": "Eficiență Pariu;Pe Poziție;În Afara Poziției",
        "availableStringCBetSpots": "CBet Sărit;Confruntare Donk;CBet & Mână Câștigată;CBet & Mână Pierdută",
        "availableStringRiverFirstActionString": "Renunțare;Verificare;Cerere;Pariu;Creștere",
        "ECCallCallVsVillainOpenAllinPreflop": "Calling Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Așteptările Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Așteptările Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Creștere",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Așteptările AI PF vs Creștere",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Creștere",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Așteptările 3Bet AI PF vs Re-Creștere",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Așteptările Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Așteptările Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Creștere",
        "BPRRaiseEVAllinVsRaisePreflop": "Așteptările AI PF vs Creștere",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Creștere",
        "BPRTBetEVAllinVsRaisePreflop": "Așteptările 3Bet AI PF vs Re-Creștere",
        "threebetHandAxis": "Mâna",
        "threebetNetBbAxis": "BB-uri Nete",
        "tourneyallinCallingByStackTitle": "Așteptările Calling All-In După Mărimea Mizei",
        "tourneyallinRaisingByStackTitle": "Așteptările Creșterii All-In După Mărimea Mizei",
        "tourneyallinRaisingAllinRangeTitle": "Limita All-In la Creștere",
        "tourneyallinCallingAllinRangeTitle": "Limita Calling All-In",
        "tourneyallinCallingAllinByPositionTitle": "Rezultatele Calling All-In După Poziție",
        "tourneyallinRaisingAllinByPositionTitle": "Rezultatele Creșterii All-In După Poziție",
        "tourneyallinCallAIEVWinrate": "Call Rata de Câștig AI",
        "tourneyallinRaiseAIEVWinrate": "Creștere Rata de Câștig AI EV",
        "tourneyallinCallAIWinrate": "Call Rata de Câștig AI",
        "tourneyallinRaiseAIWinrate": "Creștere Rata de Câștig AI",
        "overall": "General",
        "restrictionsWithYourLicenseText": "<b>Fără acces</b> la Aplicațiile HM3 \nMesaj versiunea demo în rapoarte și HUD, cu durata de 14 zile"
    },
    russian :{
        "notAllowedByLicense": "Раздача не допускается лицензией",
        "selectHandToExport": "Выбрать раздачу для экспорта",
        "selectFormat": "Выбрать формат...",
        "originalFormat": "Оригинальный формат",
        "ctrlCToCopy": "Ctrl-C для копирования в буфер",
        "availableTags": "Доступные метки",
        "welcomeToHm3": "Добро пожаловать в реплеер HoldemManager3!",
        "theme": "Тема: ",
        "deck": "Колода: ",
        "showHandResults": "Показать результат раздачи: ",
        "showHeroCards": "Всегда показывать карты Hero: ",
        "showBB": "Показать фишки в ББ: ",
        "combineFolds": "Объединить сбросы: ",
        "maskPlayerNames": "Скрыть имена игроков: ",
        "statsUpToTimeOfHand": "Статы на момент начала раздачи: ",
        "showHud": "Показать HUD: ",
        "replaySpeed": "Скорость реплеера: ",
        "hand": "Раздача",
        "next100Hands": "След. 100 рук",
        "prev100Hands": "Пред. 100 рук",
        "addEditHandMarking": "Добавить/Править метки рук",
        "wonXBB": "Выиграно ${0} ББ",
        "lostXBB": "Проиграно ${0} ББ",
        "wonLossNA": "Выигрыш/Проигрыш NA",
        "potBB": "Банк: ${0} ББ",
        "userWentAllin": "Игрок пошел олл-ин",
        "pot": "Банк: ${0}",
        "potOdds": "Шансы банка: ${0}:1",
        "hhGameStart": "${0} игра ${1} начинается на ${2}",
        "hhHandNotes": "Метка(и) рук",
        "hhFold": "${0} сбрасывает",
        "hhCheck": "${0} пропускает",
        "hhCall": "${0} коллирует ${1}",
        "hhBet": "${0} ставит ${1}",
        "hhRaise": "${0} повышает ${1}",
        "hhReturnedTo": "${1} возвращено ${0} ",
        "hhWin": "${0} выиграл ${1}",
        "hhRake": "Рейк: ${0}",
        "hhActionEnded": "Действие завершено.",
        "hhMuck": "${0} сбросил ${1}",
        "hhShow": "${0} показал ${1}",
        "hhPostSB": "${0} поставил малый блайнд",
        "hhPostBB": "${0} поставил большой блайнд",
        "hhPostDB": "${0} поставил мертвый блайнд",
        "backToReleaseNotes": "Назад к списку изменений",
        "backToMyLicense": "Назад к моим лицензиям",
        "backToCardInfo": "Назад к данным кредитной карты",
        "backToPayment": "Назад к методу платежа",
        "orderBuyNow": "Купить сейчас",
        "orderProceed": "Выполнить",
        "headerTextTrial": "Триал (${0} дней осталось)",
        "headerTextFree": "Бесплатно",
        "smallStakes": "Малые ставки",
        "allStakes": "Все лимиты",
        "smallStakesCaps": "МАЛЫЕ СТАВКИ",
        "allStakesCaps": "ВСЕ ЛИМИТЫ",
        "smallStakesMaintenance": "ОБСЛУЖИВАНИЕ МАЛЫХ СТАВОК",
        "allStakesMaintenance": "ОБСЛУЖИВАНИЕ ВСЕХ ЛИМИТОВ",
        "buyHoldemSmallStakes": "Холдем для малых ставок",
        "buyHoldemAllStakes": "Холдем для всех лимитов",
        "buyHoldemOmahaAllStakes": "Все лимиты",
        "buyOmahaSmallStakes": "Омаха для малых ставкок",
        "buyOmahaAllStakes": "Омаха для всех лимитов",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "ОМАХА",
        "holdem": "Холдем",
        "omaha": "Омаха",
        "hmApps": "HM Apps",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Истёк в ${0}",
        "expiresOn": "Истекает в ${0}",
        "recommended": "РЕКОМЕНДОВАНО",
        "seeAllOptionsInStore": "См. все варианты в магазине",
        "paypalExternalBrowser": "PayPal откроется во внешнем браузере для завершения процесса оплаты.",
        "skrillExternalBrowser": "Skrill откроется во внешнем браузере для завершения процесса оплаты.",
        "selectProduct": "ВЫБРАТЬ ПРОДУКТ",
        "availableUpdate": "ДОСТУПНО ОБНОВЛЕНИЕ: ",
        "versionAvailable": "Версия ${0} доступна: ${1}",
        "fullFaq": "FAQ по списку изменений",
        "reviewOptions": "Просмотр опций обслуживания для Холдем перед запуском обновления",
        "maintenanceOptions": "Опции обслуживания",
        "addProductToLicense": "ДОБАВИТЬ ${0} К ТЕКУЩЕЙ ЛИЦЕНЗИИ",
        "purchasePrice": "Приобрести ${0}",
        "errorName": "Введите свое имя и фамилию",
        "errorAddress": "Введите улицу и номер дома",
        "errorCountry": "Введите страну проживания",
        "errorCity": "Введите город",
        "errorZip": "Введите почтовый индекс",
        "billingInfo": "ПЛАТЁЖНЫЕ ДАННЫЕ",
        "name": "Полное имя",
        "address": "Улица",
        "city": "Город",
        "state": "Область/провинция",
        "zip": "Почтовый индекс",
        "country": "Страна",
        "selectCountry": "Выбор страны",
        "buyNowTip": "Выберите примененный или новый способ платежа перед началом",
        "licenses": "ЛИЦЕНЗИИ",
        "version": "Версия ${0}",
        "viewReleaseNotes": "Просмотр списка изменений на сайте",
        "updateAndRenewMaintenance": "ОБСЛУЖИВАНИЕ ОБНОВЛЕНИЙ И ВОЗОБНОВЛЕНИЙ",
        "renewGetUpdatesUntil": "При возобновлении обслуживания вы также получите все обновления HM3 ${0}",
        "update": "Обновить",
        "updateAndSwitchToFree": "ОБНОВИТЬ И ПЕРЕЙТИ НА БЕСПЛАТНУЮ ВЕРСИЮ",
        "updateAndSwitchToFreeDetails1": "Вы получите обновление, но программа HM3 (Holdem) вернется к бесплатной версии и будет иметь",
        "updateAndSwitchToFreeDetails2": "ограниченную функциональность",
        "updateAndSwitch": "Обновить и переключиться",
        "errorCreditCardDigitsOnly": "Номер банковской карты должен содержать только цифры.",
        "errorCreditCard": "Введите верный номер карты.",
        "errorRequired": "Обязательно",
        "errorCardExpired": "Карта просрочена",
        "errorCvv": "CVV должен быть длиной в ${0} цифры",
        "cardInfo": "ДАННЫЕ БАНКОВСКОЙ КАРТЫ",
        "cardNo": "Номер карты",
        "expiry": "Истекает",
        "year": "год",
        "month": "месяц",
        "month01": "Янв",
        "month02": "Фев",
        "month03": "Мар",
        "month04": "Апр",
        "month05": "Май",
        "month06": "Июн",
        "month07": "Июл",
        "month08": "Авг",
        "month09": "Сен",
        "month10": "Окт",
        "month11": "Ноя",
        "month12": "Дек",
        "cvv": "CVV",
        "active": "Активна",
        "manageSubscription": "Управление подпиской",
        "youAreUpToDate": "Программа обновлена",
        "releaseNotes": "Список изменений для ${0}",
        "netellerInfo": "Информация счета NETELLER",
        "netellerSignin": "Войдите в свой счет NETELLER для завершения покупки",
        "continue_": "Продолжить",
        "netellerAccount": "Счет Neteller",
        "netellerPassword": "Пароль",
        "orderSummary": "ИТОГ ЗАКАЗА: ",
        "changeProducts": "Сменить продукт(ы)",
        "total": "Итого",
        "paypalComplete": "ЗАВЕРШИТЕ ОПЛАТУ ЧЕРЕЗ PAYPAL В БРАУЗЕРЕ",
        "paypalOpenedInNewBrowser": "Мы открыли PayPal в окне интернет-браузера. Зайдите в ваш счет PayPal и завершите покупку. После чего вернитесь сюда и нажмите \"Перезагрузить лицензию\" для загрузки купленной лицензии.",
        "reloadLicense": "Перезагрузить лицензию",
        "thankYouForPurchase": "Спасибо за покупку",
        "purchaseConfirm1": "Вы скоро получите подтверждающее письмо на ${0}",
        "purchaseConfirm2": "Нажмите \"Перезагрузить лицензию\" ниже и купленная вами лицензия станет активной.",
        "restricted": "ограничено",
        "restrictionsWithYourLicense": "ОГРАНИЧЕНИЯ ТЕКУЩЕЙ ЛИЦЕНЗИИ",
        "paymentPleaseChoose": "Выберите способ платежа",
        "paymentSelectExisting": "Выберите способ платежа из имеющихся: ",
        "paymentSelectNew": "Способ платежа",
        "paymentMethod": "Способ платежа: ",
        "changePaymentMethod": "Изменить способ платежа",
        "licensedTo": "ЛИЦЕНЗИЯ ДЛЯ",
        "learnMore": "Узнать больше",
        "startTrial": "Начать триал",
        "purchase": "Купить",
        "trialSuccessfullyStarted": "Триал успешно запущен",
        "trialSuccessDetails1": "Ваша 14-дневная пробная версия теперь активна. Пожалуйста ",
        "trialSuccessDetails2": "улучшите",
        "trialSuccessDetails3": " как можно скорее для предотвращения перерывов в обслуживании.",
        "havingTrouble": "Есть проблемы? ",
        "contactUs": "Связь с нами",
        "startUsing": "Начать пользоваться HM3 сейчас",
        "missedUpdates": "${0} пропущенных обновлений",
        "updatesAreCritical": "Обновления критичны для того, чтобы HM3 продолжал импортировать истории раздач после изменений в клиентах покерных сетей. Также через изменения в программу добавляются новые функции и возможности.",
        "view": "Просмотреть",
        "oneYearOfUpdates": "Включает один год обновлений",
        "renew": "Возобновить (${0})",
        "startingAt": "Начато в",
        "upgrade": "Улучшить",
        "removesRestrictions1": "Удаляет ",
        "removesRestrictions2": "ограничения",
        "removesRestrictions3": " и включает один год обновлений",
        "upgradePrice": "Улучшить (${0})",
        "required": "Обязательно",
        "continueFreemium": "Продолжить бесплатную версию",
        "defaultFatalError": "Произошла непредвиденная внутренняя ошибка сервера, о чем уведомлен администратор. Повторите попытку покупки чуть позже.",
        "restrictCashHandsType": "Кешевые раздачи",
        "restrictTourneyType": "Турниры",
        "restrictLimitCashHandsType": "Кешевые раздачи FL",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Данные отчета",
        "restrictCashHands": "$ ${0} и ниже",
        "restrictLimitCashHands": "$ ${0} и ниже",
        "restrictTourney": "Макс ${0}",
        "restrictHud": "Макс ${0} столов",
        "restrictReportData": "Последние ${0} раздач",
        "restrictionUnlimited": "Неограниченно",
        "errorState": "Обязательно",
        "activeHoldemLicense": "АКТИВНАЯ ЛИЦЕНЗИЯ ХОЛДЕМ",
        "activeOmahaLicense": "АКТИВНАЯ ЛИЦЕНЗИЯ ОМАХА",
        "reinstallOldVersion": "Переустановить старую версию",
        "removesRestrictions3b": "и вернуться к прежней оплаченной лицензии, но обновления ",
        "removesRestrictions4b": "НЕ ВКЛЮЧЕНЫ",
        "noActiveHoldemLicense": "НЕТ АКТИВНОЙ ЛИЦЕНЗИИ ХОЛДЕМ",
        "noActiveOmahaLicense": "НЕТ АКТИВНОЙ ЛИЦЕНЗИИ ОМАХА",
        "free": "БЕСПЛАТНО",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} включено*",
        "recurringYear": "Год",
        "recurringMonth": "Месяц",
        "recurringDay": "День",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>ограничены</b> до большого блайнда $0.50\nFixed Limit Cash <b>ограничен</b> до большого блайнда $1.00 \nТурниры <b>ограничены</b> до бай-ина $22.00.",
        "afterDiscount": "Цена после срока действия скидки ",
        "upgradeDiscount": "СКИДКА НА АПГРЕЙД",
        "discountExpires": "Скидка истекает ${0}",
        "discountSinglePurchase": "Скидка действует на одну покупку.",
        "errorNetellerAccount": "Недействительная учетная запись Neteller",
        "errorNetellerSecureId": "Введите 6-значный Secure ID",
        "continueTrial": "Продолжить триал",
        "continueTrialDaysRemaining": "(${0} дней осталось)",
        "netellerInvalidCredentials": "Учетные данные Neteller проверить не удалось. Зайдите в аккаунт еще раз. ",
        "faq": "FAQ",
        "forMoreDetails": " для получения более подробной информации об управлении вашим ежегодным продлением поддержки и обслуживания.",
        "recurringSubscription": "* Cпособ платежа для списания платы за годовую поддержку и техобслуживание $${0}, счет будет выставлен через один год (${1}). Просмотр ",
        "positivePrice": "Счет за обновление годовой поддержки и техобслуживания $ ${0} будет выставлен через один год (${1}). Просмотр  ",
        "paymentSeeWebsite1": "См. ",
        "paymentSeeWebsite2": "МАГАЗИН",
        "paymentSeeWebsite3": " для других опций платежа",
        "paymentOr": "-ИЛИ-",
        "couldNotStartMlaTitle": "Обнаружена проблема",
        "couldNotStartMlaText": "Не удаётся открыть Мои лицензии. Системный администратор уведомлён. Попробуйте ещё раз позже. Однако, необходимо связаться с поддержкой, если проблема останется.",
        "skipEndOfHandLabel": "Пропустить конец раздачи",
        "inPosition": "В позиции",
        "outOfPosition": "Без позиции",
        "amountBb": "${0} бб",
        "amountBbPlus": "${0}+ бб",
        "amountBb100": "${0} бб/100",
        "cbetCbetSuccessTip": "Успех контбета: ${0} % <br/>Винрейт: ${1} бб/100",
        "riverBetEfficiencyTip": "${0}<br/>Эффективность ставки: ${1}<br/>В позиции: ${2}<br/>Без позиции: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Эффективность коллирования: ${1}<br/>В позиции: ${2}<br/>Без позиции: ${3}",
        "riverHandFrequencyTip": "Частота комбинации: ${0} % <br/>Винрейт: ${1} бб/100",
        "riverPotSizeFrequencyTip": "Частота размера банка: ${0} % <br/>Винрейт: ${1} бб/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Выигранно выставлений: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Винрейт: ${1} бб/100",
        "ipOopTip": "${0}<br/>В позиции: ${1}<br/>Без позиции: ${2}",
        "riverHereyoucanfind6": "Здесь можно узнать, как часто и как эффективно вы играете на ривере в зависимости от размера банка.",
        "riverCombinethisview6": "В сочетании с фильтрами этот обзор покажет, выигрываете ли вы много малых банков, проигрываете ли большие банки и другое.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Здесь можно узнать, как часто и как эффективно вы играете различные карманные карты на ривере.",
        "riverCombinethisview5": "Комбинируя этот обзор с фильтрами, можно узнать, как отличаются ваши диапазоны при ставках, коллах, рейзах и т.п.",
        "riverHereyoucanfind4": "Здесь можно узнать, как часто и как эффективно вы играете на ривере комбинации различной силы.",
        "riverCombinethisview4": "Комбинируя этот обзор с фильтрами, можно узнать, доходите ли вы до ривера со слишком слабыми картами, либо смотрите вскрытие с сильной рукой и другое.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RBE) показывает ваш прибыль для каждого большого блайнда, инвестированного в коллы и чек-коллы на ривере.",
        "riverCombinethisview3": "Комбинируя этот обзор с фильтрами, можно узнать, насколько эффективными являются ваши коллы на ривере, когда вы встречаетесь с контбетами, донкбетами, различными размерами ставок и др.",
        "riverSawShowdown": "С вскрытием",
        "riverNoShowdown": "Без вскрытия",
        "riverMadeRiverCbet": "Сделал контбет ривера",
        "riverMadeRiverDonkBet": "Сделал докнбет",
        "riverSmallriverbets": "Малые ставки на ривере (<50% банка)",
        "riverBigriverbets": "Большие ставки на ривере (>100% банка)",
        "riverFacedRiverCbet": "Встретил конбет ривера",
        "riverFacedRiverDonkBet": "Встретил донкбет",
        "riverRiverBet": "Ставка на ривере",
        "riverRiverCall": "Колл на ривере",
        "riverRiverRaise": "Повышение на ривере",
        "riverRiverFold": "Сброс на ривере",
        "riverWonHand": "Выиграл раздачу",
        "riverLostHand": "Проиграл раздачу",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) показывает ваш прибыль для каждого большого блайнда, инвестированного в ставки на ривере.",
        "riverCombinethisview2": "Комбинируя этот обзор с фильтрами, можно узнать, насколько эффективными являются ваши ставки на ривере, когда вы встречаетесь с контбетами, донкбетами, различными размерами ставок и др.",
        "riverHereyoucanfind": "Здесь можно узнать, как агрессивно вы играете на ривере, и ваши результаты по каждому игровому действию.",
        "tip": "Подсказка",
        "riverCombinethisview": "Комбинируя этот обзор с фильтрами, можно узнать, как различается ваша игра, когда вы являетесь агрессором, против агрессора и др.",
        "riverAsPreflopAggressor": "Как префлоп агрессор",
        "riverVsPreflopAggressor": "На префлоп агрессора",
        "riverCheckedToRiver": "Пропускал до ривера",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Всего раздач",
        "wonAtShowdown": "Выиграно на вскрытии",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Доход до вскрытия",
        "riverRiverHoleCards": "Карманные карты на ривере",
        "riverRiverHandStrength": "Сила комб. на ривере",
        "riverRiverAgression": "Агрессия на ривере %",
        "riverRiverCallEfficiency": "Эффективность колла на ривере",
        "riverRiverBetEfficiency": "Эффективность ставки на ривере",
        "riverRiverPotSize": "Размер банка на ривере",
        "numberOfTables": "Число столов",
        "sessions": "Сессии",
        "leakonomicsOpponentNoteColor": "Цвет заметки на оппонента",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Чистый выигрыш (бб)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} или меньше",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Выигрыши",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "на",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "При игре на многих столах",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "После выигрыша или проигрыша банка",
        "cbetSuccessP": "Успех контбета %",
        "winrate": "Винрейт",
        "winrateBB100": "Винрейт (бб/100)",
        "cbetActionHU": "Действия с контбетом: 1 на 1",
        "cbetActionMultiway": "Действия с контбетом: мультивей",
        "cbetActionHUNoHands": "1 на 1: Нет раздач",
        "cbetActionMultiwayNoHands": "Мультивей: Нет раздач",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Общий пропуск контбета",
        "cbetResultsSkippedDonutSubtitle": "Более ${0} раздач<br/>${1} бб/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Общий пропуск контбета: Нет раздач",
        "cbetResultsSkippedDonut2Title": "Общий успех контбета",
        "cbetResultsSkippedDonut2TitleNoHands": "Общий успех контбета: Нет раздач",
        "hands": "Раздачи",
        "cbetActionIP": "Действие контбета: В позиции",
        "cbetActionOOP": "Действие контбета: Без позиции",
        "cbetNoHandsIP": "В позиции: Нет раздач",
        "cbetNoHandsOOP": "Без позиции: Нет раздач",
        "cbetOverallSuccess": "Успех общий",
        "cbetFlopCBetSuccess": "Успех контбета на флопе",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "Успех контбета: Текстура борда",
        "cbetCBetSuccessPosition": "Успех контбета: Позиция",
        "cbetHandStrengthwhenCBettting": "Сила руки при контбете",
        "cbetCBetSpotsHeadsUpvsMultiway": "Контбет диаграммы  - 1 на 1  и Мультивей",
        "cbetCBetSpotsInPositionvsOutofPosition": "Контбет диаграммы - В позиции и Без позиции",
        "cbetResultsSkippedCBet": "Итоги пропуска контбета",
        "bubbleICMDescription5": "Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из вашего эффективного стека в начале раздачи.",
        "bubblePercentageDescription5": "Выигранный процент призового фонда при разных размерах эффективного стека",
        "bubblePreflopDescription5": "Ваши статы префлоп при разных размерах стека",
        "bubbleEffectiveStackSizebb": "Размер эффективного стека (бб)",
        "bubbleBubbleStackSize": "Размер стека на баббле",
        "bubbleCallingAllInRange": "Диапазон коллирования алл-ина",
        "bubbleSitNGoEntrants": "Участников SNG",
        "bubbleICMDescription4": "Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из числа участников турнира.",
        "bubblePercentageDescription4": "Выигранный процент призового фонда при разном числе участников",
        "bubblePreflopDescription4": "Ваши статы префлоп при разных размерах стека",
        "bubbleBubblePosition": "Позиция на баббле",
        "bubbleICMDescription3": "Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из вашей позиции за столом.",
        "bubblePercentageDescription3": "Выигранный процент призового фонда в разных позициях",
        "bubblePreflopDescription3": "Ваши статы префлоп в разных позициях",
        "bubblePreflopDescription2": "Выигранный процент призового фонда при разном числе оставшихся до баббла",
        "bubblePlayersAtBubble": "# игроков на баббле",
        "bubbleBubblePlayers": "Число игроков на баббле",
        "bubblePrizePoolP": "Призовой пул%",
        "bubbleBubbleStage": "Стадия баббла",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "Информация ниже показывает представление в ICM (модель независимых фишек) выигранной части призового фонда исходя из стадии турнира. Перед бабблом показывает все раздачи, в которых вы были задействованы перед достижением той стадии турнира, когда следующий выбитый игрок \"протыкает\" пузырь и все оставшиеся участники будут в призах.",
        "bubblePercentageDescription": "Часть призового фонда, выигранная до, во время и после баббла",
        "bubblePreflopDescription": "Ваши статы префлоп в зависимости от размера своего стека",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Средний стек",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Слишком мало раздач для отчёта",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Ожидание при достижении баббла",
        "bubblePositionTitle": "Позиция",
        "bubbleBeforeAndAfterTitle": "До и после",
        "bubbleStackSizeTitle": "Размер стека",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Повышение как пуш",
        "tourneyallinRaising3BetAI": "Повышение как алл-ин на 3бет",
        "tourneyallinRaisevsOpen": "Повышение на пуш",
        "tourneyallinRaisevs3Bet": "Повышение на 3-бет",
        "tourneyallinCallvsOpen": "Колл на пуш",
        "tourneyallinCallvs3Bet": "Колл на 3-бет алл-ин",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Эффективный стек на префлопе",
        "tourneyallinRacesWonPAxis": "Выиграно выставлений %",
        "tourneyallinEquityPAxis": "Эквити %",
        "tourneyallinCallingOpenAI": "Коллирование пуша",
        "tourneyallinCalling3BetAI": "Коллирование 3бет алл-ина",
        "tourneyallinPositionAxis": "Позиции",
        "tourneyallinExpectationAxis": "Ожидание",
        "threebetResultsTitle": "Результаты",
        "threebetPositionTitle": "Позиция",
        "threebetRangeTitle": "Диапазон трибета",
        "threebetSuccessTitle": "Успех трибета",
        "threebetFlopHandStrengthTitle": "Сила комбинации на флопе",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Винрейт по силе комб. (бб/100)",
        "threebetHandCount": "${0} (${1} Раздач)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Винрейт (бб/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Успех %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Убыток",
        "threebetNetwonMax": "Прибыль",
        "threebetDealtFrequencyTitle": "Частота получения",
        "threebetDealtFrequencyMin": "Менее часто",
        "threebetDealtFrequencyMax": "Более часто",
        "tourneyallinExpectedWon": "Ожидаемый выигрыш",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Неизвестно;Топ карты;Пара;2 Пары;Сет или трипс;Стрит;Флеш;Фул хаус;Каре;Стрит-флеш",
        "availableStringRiverMadeHandValueSummary": "Неизвестно;Топ карты;Пара;2 Пары;Сет или трипс;Стрит;Флеш;Фул хаус;Каре;Стрит-флеш",
        "availableStringFlopFlushTextureTypeAsString": "Флеш радужный;Флеш двутонный;Флеш монотонный",
        "availableStringFlopStraightTextureTypeAsString": "Стрит - несвязанный;Стрит - Связанный;Стрит - 1 пропуск;Стрит - 2 пропускаr;Стрит - Связ + 1 пропуск",
        "availableStringFlopPairedTextureTypeAsString": "Спаренный борд; Не спаренный",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "В позиции;Без позиции",
        "availableStringRiverplayCallEfficiency": "Эффективность колла;В позиции;Без позиции",
        "availableStringRiverplayBetEfficiency": "Эффективность ставки;В позиции;Без позиции",
        "availableStringCBetSpots": "Пропустил контбет;Встретил донк;Контбет и выиграл;Контбет и проиграл",
        "availableStringRiverFirstActionString": "Сброс;Пропуск;Коллирование;Ставка;Повышение",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Раздачи",
        "threebetNetBbAxis": "Чистых бб",
        "tourneyallinCallingByStackTitle": "Ожидание коллирования алл-ина по размеру стека",
        "tourneyallinRaisingByStackTitle": "Ожидание повышения до алл-ина по размеру стека",
        "tourneyallinRaisingAllinRangeTitle": "Диапазон повышения до алл-ина",
        "tourneyallinCallingAllinRangeTitle": "Диапазон коллирования алл-ина",
        "tourneyallinCallingAllinByPositionTitle": "Итоги коллирования алл-ина по позициям",
        "tourneyallinRaisingAllinByPositionTitle": "Итоги повышения до алл-ина по позициям",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Общий",
        "restrictionsWithYourLicenseText": "<b>Нет доступа</b> к HM3 Apps\nСообщение пробного периода в отчетах и в HUD\nдлительность 14 дней"
    },
    slovenian :{
        "notAllowedByLicense": "Licenca ne dovoli te igre",
        "selectHandToExport": "Izberi igro za izvoz",
        "selectFormat": "Izberi format...",
        "originalFormat": "Originalen format",
        "ctrlCToCopy": "Ctrl-C za kopiranje v odložišče",
        "availableTags": "Oznake",
        "welcomeToHm3": "Dobrodošli v HoldemManager3 Predvajalniku!",
        "theme": "Tema: ",
        "deck": "Karte: ",
        "showHandResults": "Pokaži rezultat igre: ",
        "showHeroCards": "Vedno pokaži herojeve karte: ",
        "showBB": "Pokaži žetone kot BB: ",
        "combineFolds": "Združi odstope: ",
        "maskPlayerNames": "Prekrij imena igralcev: ",
        "statsUpToTimeOfHand": "Statistika do trenutne Igre:",
        "showHud": "Pokaži HUD:",
        "replaySpeed": "Hitrost predvajalnika: ",
        "hand": "Igra",
        "next100Hands": "Naslednjih 100 Iger",
        "prev100Hands": "Prejšnjih 100 Iger",
        "addEditHandMarking": "Dodaj/Uredi oznake iger",
        "wonXBB": "Pridobil ${0} BB",
        "lostXBB": "Izgubil ${0} BB",
        "wonLossNA": "Zmaga/Izguba ND",
        "potBB": "Pot: ${0} BB",
        "userWentAllin": "Uporabnik je šel Allin",
        "pot": "Pot: ${0}",
        "potOdds": "Pot Oddsi: ${0}:1",
        "hhGameStart": "${0} igra ${1} se začne ${2}",
        "hhHandNotes": "Zapiski igre",
        "hhFold": "${0} odstopi",
        "hhCheck": "${0} čekira",
        "hhCall": "${0}kliče ${1}",
        "hhBet": "${0} stavi ${1}",
        "hhRaise": "${0} viša ${1}",
        "hhReturnedTo": "${1} vrnjeno igralcu ${0}",
        "hhWin": "${0} pridobi ${1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "Akcija se je zaključila.",
        "hhMuck": "${0} zapre ${1}",
        "hhShow": "${0} pokaže ${1}",
        "hhPostSB": "${0} postavi small blind",
        "hhPostBB": "${0} postavi big blind",
        "hhPostDB": "${0} postavi mrtvi blind",
        "backToReleaseNotes": "Nazaj na podrobnosti verzije",
        "backToMyLicense": "Nazaj na licenco",
        "backToCardInfo": "Nazaj na informacije o kreditni kartici",
        "backToPayment": "Nazaj na možnosti plačila",
        "orderBuyNow": "Kupi zdaj",
        "orderProceed": "Nadaljuj",
        "headerTextTrial": "Preizkus (${0} dni ostane)",
        "headerTextFree": "Brezplačno",
        "smallStakes": "Nizki Nivoji",
        "allStakes": "Vsi Nivoji",
        "smallStakesCaps": "NIZKI NIVOJI",
        "allStakesCaps": "VSI NIVOJI",
        "smallStakesMaintenance": "VZDRŽEVANJE NIZKIH NIVOJEV",
        "allStakesMaintenance": "VZDRŽEVANJE VSEH NIVOJEV",
        "buyHoldemSmallStakes": "Holdem Nizki Nivoji",
        "buyHoldemAllStakes": "Holdem Vsi Nivoji",
        "buyHoldemOmahaAllStakes": "Vsi Nivoji",
        "buyOmahaSmallStakes": "Omaha Nizki Nivoji",
        "buyOmahaAllStakes": "Omaha Vsi Nivoji",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "HM Aplikacije",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Pretečeno dne ${0}",
        "expiresOn": "Preteče dne ${0}",
        "recommended": "PRIPOROČLJIVO",
        "seeAllOptionsInStore": "Poglej vse možnosti v trgovini",
        "paypalExternalBrowser": "PayPal se bo odprl v zunanjem brskalniku za zaključitev plačilnega postopka.",
        "skrillExternalBrowser": "Skrill se bo naložil v zunanjem brskalniku za zaključitev plačilnega postopka.",
        "selectProduct": "IZBERITE IZDELEK",
        "availableUpdate": "POSODOBITEV NA RAZPOLAGO:",
        "versionAvailable": "Verzija ${0} je na razpolago: ${1}",
        "fullFaq": "FAQ o podrobnostih te verzije",
        "reviewOptions": "Preglej tvoje Holdem možnosti vzdrževanja predenj nadaljuješ s posodobitvijo",
        "maintenanceOptions": "Možnosti vzdrževanja",
        "addProductToLicense": "DODAJ ${0} TVOJI TRENUTNI LICENCI",
        "purchasePrice": "Nakup (${0})",
        "errorName": "Prosimo, vnesite ime in priimek",
        "errorAddress": "Prosimo, vnesite naslov ulice in hišno številko",
        "errorCountry": "Prosimo, vnesite državo",
        "errorCity": "Prosimo, vnesite mesto",
        "errorZip": "Prosimo, vnesite veljavno poštno številko",
        "billingInfo": "INFORMACIJE ZA OBRAČUN",
        "name": "Ime in Priimek",
        "address": "Naslov Ulice",
        "city": "Mesto",
        "state": "Zvezna država/Provinca",
        "zip": "Zip/Poštna Številka",
        "country": "Država",
        "selectCountry": "Izberite državo",
        "buyNowTip": "Prosimo, izberite obstoječ ali nov način plačlla pred nadaljevanjem",
        "licenses": "LICENCE",
        "version": "Verzija ${0}",
        "viewReleaseNotes": "Poglejte podrobnosti te verzije na spletni strani",
        "updateAndRenewMaintenance": "POSODOBI & OBNOVI VZDRŽEVANJE",
        "renewGetUpdatesUntil": "Z obnovitvijo vzdrževanja boste prejeli vse HM3 posodobitve preko ${0}",
        "update": "Posodobitev",
        "updateAndSwitchToFree": "POSODOBI & ZAMENJAJ NA BREZPLAČNO VERZIJO",
        "updateAndSwitchToFreeDetails1": "Prejeli boste posodobitev, ampak vaša HM3 (Holdem) programska oprema se bo vrnila na brezplačno verzijo in bo imela",
        "updateAndSwitchToFreeDetails2": "omejeno delovanje",
        "updateAndSwitch": "Posodobi & Zamenjaj",
        "errorCreditCardDigitsOnly": "Številka kreditne kartice mora vsebovati samo številke.",
        "errorCreditCard": "Prosimo, vnesite veljavno številko kreditne kartice.",
        "errorRequired": "Obvezno",
        "errorCardExpired": "Kartica je pretekla",
        "errorCvv": "CVV mora imeti vsaj ${0} številke.",
        "cardInfo": "PODATKI KREDITNE KARTICE",
        "cardNo": "Št. kartice",
        "expiry": "Veljavnost",
        "year": "leto",
        "month": "mesec",
        "month01": "Jan",
        "month02": "Feb",
        "month03": "Mar",
        "month04": "Apr",
        "month05": "Maj",
        "month06": "Jun",
        "month07": "Jul",
        "month08": "Avg",
        "month09": "Sep",
        "month10": "Okt",
        "month11": "Nov",
        "month12": "Dec",
        "cvv": "CVV",
        "active": "Aktivno",
        "manageSubscription": "Upravljaj naročnino",
        "youAreUpToDate": "Posodobljeni ste",
        "releaseNotes": "Podrobnosti za verzijo  ${0}",
        "netellerInfo": "Informacije o NETELLER računu",
        "netellerSignin": "Vpišite se v vaš NETELLER račun za zaključitev nakupa",
        "continue_": "Nadaljuj",
        "netellerAccount": "Neteller račun",
        "netellerPassword": "Geslo",
        "orderSummary": "POVZETEK NAROČILA: ",
        "changeProducts": "Zamenjaj Izdelek",
        "total": "Skupno",
        "paypalComplete": "PROSIMO, ZAKLJUČITE VAŠ PAYPAL NAKUP V VAŠEM BRSKALNIKU",
        "paypalOpenedInNewBrowser": "PayPal smo odprli v oknu vašega privzetega brskalnika. Prosimo, vpišite se v vaš PayPal račun in dokončajte nakup. Po zaključenem nakupu, se vrnite sem in kliknite 'Ponovno naloži licenco' za uporabo kupljene licence.",
        "reloadLicense": "Ponovno naloži licenco",
        "thankYouForPurchase": "Hvala za nakup",
        "purchaseConfirm1": "Kmalu boste prejeli potrditveno sporočilo na ${0}",
        "purchaseConfirm2": "Prosimo, kliknite na gumb 'Ponovno naloži licenco' in vaša kupljena licenca bo postala aktivna.",
        "restricted": "omejen dostop",
        "restrictionsWithYourLicense": "OMEJITVE TVOJE TRENUTNE LICENCE",
        "paymentPleaseChoose": "Prosimo, izberite način plačila",
        "paymentSelectExisting": "Izberi obstoječ način plačila:",
        "paymentSelectNew": "Dodaj nov način plačila:",
        "paymentMethod": "Način plačila:",
        "changePaymentMethod": "Zamenjaj način plačila",
        "licensedTo": "REGISTRACIJA NA",
        "learnMore": "Izvedi več",
        "startTrial": "Začni preizkus",
        "purchase": "Nakup",
        "trialSuccessfullyStarted": "Preizkusno obdobje je bilo uspešno zagnano",
        "trialSuccessDetails1": "Tvoje 14-dnevno preizkusno obdobje je sedaj aktivno. Prosimo",
        "trialSuccessDetails2": "nadgradite",
        "trialSuccessDetails3": " takoj, ko bo možno, da se izognete prekinitvi storitve",
        "havingTrouble": "Imate težavo?",
        "contactUs": "Kontaktirajte nas",
        "startUsing": "Nadaljuj v HM3",
        "missedUpdates": "${0} zamujenih posodobitev",
        "updatesAreCritical": "Posodobitve so nujne za zagotovitev neprekinjenega uvoza vaših zgodovin iger potem, ko poker strani naredijo spremembe v svoji programski opremi. Prav tako omogočajo prejem novih funkcij.",
        "view": "Pogled",
        "oneYearOfUpdates": "Vključi eno leto posodobitev",
        "renew": "Obnovi (${0})",
        "startingAt": "Že od:",
        "upgrade": "Nadgradi",
        "removesRestrictions1": "Odstrani",
        "removesRestrictions2": "omejitve",
        "removesRestrictions3": " in vključi eno leto posodobitev",
        "upgradePrice": "Nadgradi (${0})",
        "required": "Obvezno",
        "continueFreemium": "Nadaljuj z brezplačno verzijo",
        "defaultFatalError": "Zgodila se je nepričakovana notranja napaka strežnika, upravitelj je bil obveščen. Prosimo, poskusite kupiti ponovno kasneje.",
        "restrictCashHandsType": "Cash Igre",
        "restrictTourneyType": "Turnir",
        "restrictLimitCashHandsType": "Omeji Cash Igre",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Podatki Poročila",
        "restrictCashHands": "$ ${0} in nižje",
        "restrictLimitCashHands": "$ ${0} in nižje",
        "restrictTourney": "Max ${0}",
        "restrictHud": "Max ${0} Miz",
        "restrictReportData": "Zadnjih ${0} Iger",
        "restrictionUnlimited": "Neomejeno",
        "errorState": "Obvezno",
        "activeHoldemLicense": "AKTIVNA HOLDEM LICENCA",
        "activeOmahaLicense": "AKTIVNA OMAHA LICENCA",
        "reinstallOldVersion": "Ponovno namesti staro verzijo",
        "removesRestrictions3b": "in se vrne nazaj na vašo plačano licenco, ampak posodobitve",
        "removesRestrictions4b": "NISO VKLJUČENE",
        "noActiveHoldemLicense": "NI AKTIVNE HOLDEM LICENCE",
        "noActiveOmahaLicense": "NI AKTIVNE OMAHA LICENCE",
        "free": "BREZPLAČNO",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} Vključeno*",
        "recurringYear": "Leto",
        "recurringMonth": "Mesec",
        "recurringDay": "Dan",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>omejeno na</b> na $0.50 big blind\nFixed Limit Cash <b>omejeno na</b> na $1.00 big blind\nTournaments <b>omejeno na</b> na $22.00 buy-in.",
        "afterDiscount": "Cena po časovno omejenem popustu",
        "upgradeDiscount": "POPUST ZA NADGRADNJO",
        "discountExpires": "Popust preteče ${0}",
        "discountSinglePurchase": "Popust velja za en nakup.",
        "errorNetellerAccount": "Neveljaven ID Neteller računa",
        "errorNetellerSecureId": "Prosimo, vnesite svojo 6-mestno številko Secure ID",
        "continueTrial": "Nadaljuj preizkusno obdobje",
        "continueTrialDaysRemaining": "(${0} dni ostane)",
        "netellerInvalidCredentials": "Nismo mogli potrditi vaših Neteller podatkov. Prosimo, poskusite se ponovno vpisati.",
        "faq": "FAQ",
        "forMoreDetails": " za več informacij o upravljanju obnovitve vaše letne podpore & vzdrževanja.",
        "recurringSubscription": "* Za obnovitev letne podpore in vzdrževanja je potreben način plačlla $${0}, kar bo obračunano enkrat letno (${1}). Poglej",
        "positivePrice": "Za obnovitev letne podpore & vzdrževanja bo obračunano $${0} čez eno leto (${1}). Poglej",
        "paymentSeeWebsite1": "Poglej",
        "paymentSeeWebsite2": "TRGOVINA",
        "paymentSeeWebsite3": " za druge načine plačila",
        "paymentOr": "- Ali -",
        "couldNotStartMlaTitle": "Naleteli smo na problem",
        "couldNotStartMlaText": "Ni bilo možno zagnati Mojih Licenc. Skrbnik je bil obveščen. Prosimo, preverite ponovno kasneje. Če problem ne bo odpravljen, prosimo, kontaktirajte našo podporo.",
        "skipEndOfHandLabel": "Preskoči zaključek igre",
        "inPosition": "V poziciji",
        "outOfPosition": "Izven pozicije",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet uspeh: ${0} % <br/>Stopnja zmage: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Učinkovitost stave: ${1}<br/>V poziciji: ${2}<br/>Izven pozicije: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Učinkovitost klica: ${1}<br/>V poziciji: ${2}<br/>Izven pozicije: ${3}",
        "riverHandFrequencyTip": "Pogostost kart: ${0} % <br/>Stopnja zmage: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pogostost polnega pota: ${0} % <br/>Stopnja zmage: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Dobljenih Dirk: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Stopnja zmage: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Tukaj lahko ugotovite kako pogosto in kako učinkovito igrate na riverju glede na velikost pota.",
        "riverCombinethisview6": "Združite ta pogled s filtri da ugotovite ali zmagujete veliko majhnih potov, izgubljate velike pote in drugo.",
        "potSizeFrequencyP": "Pogostost polnega pota",
        "riverHereyoucanfind5": "Tukaj lahko vidite kako pogosto in kako učinkovito igrate različne začetne karte na riverju.",
        "riverCombinethisview5": "Združite ta pogled s filtri da ugotovite kako se vaš obseg začetnih kart razlikuje ko stavite, kličete, višate in drugo.",
        "riverHereyoucanfind4": "Tukaj lahko ugotovite kako pogosto in kako učinkovito igrate na riverju z različno vrednimi kombinacijami.",
        "riverCombinethisview4": "Združite ta pogled s filtri da ugotovite ali greste do riverja s prešibkimi kombinacijami, ali greste do razkritja z močnimi kombinacijami in drugo.",
        "riverRiverCallEfficiencyNetWon": "Učinkovitost klica na riverju Dobiček",
        "riverRCE": "Učinkovitost klica na riverju vam pokaže donosnost na vsak investiran big blind pri river klicih in ček-klicih.",
        "riverCombinethisview3": "Združite ta pogled s filtri da ugotovite kako učinkoviti so vaši klici na riverju ko ste soočeni s Cbeti, Donk beti, različnimi velikostmi stav in drugo.",
        "riverSawShowdown": "Videl razkritje",
        "riverNoShowdown": "Brez razkritja",
        "riverMadeRiverCbet": "Naredil river Cbet",
        "riverMadeRiverDonkBet": "Naredil river Donk bet",
        "riverSmallriverbets": "Majhne river stave (<50% pota)",
        "riverBigriverbets": "Velike river stave (>100% pota)",
        "riverFacedRiverCbet": "Soočen z river Cbetom",
        "riverFacedRiverDonkBet": "Soočen z river Donk betom",
        "riverRiverBet": "River Stava",
        "riverRiverCall": "River Klic",
        "riverRiverRaise": "River Višanje",
        "riverRiverFold": "River Odstop",
        "riverWonHand": "Zmagal Igro",
        "riverLostHand": "Izgubil Igro",
        "riverRiverBetEfficiencyNetWon": "Učinkovitost stave na riverju Dobiček",
        "riverRBE": "Učinkovitost stave na riverju vam pokaže donosnost na vsak investiran big blind pri river stavah.",
        "riverCombinethisview2": "Združite ta pogled s filtri da ugotovite kako učinkovite so vaše stave na riverju pri Cbetih, Donk betih, različniih velikostih stav in drugo.",
        "riverHereyoucanfind": "Tukaj lahko ugotovite kako agresivno igrate na riverju in vidite rezultate glede na vsako odigrano akcijo.",
        "tip": "Namig",
        "riverCombinethisview": "Združite ta pogled s filtri da ugotovite kako se vaša igra razlikuje ko ste agresor, ko igrate proti agresorju in drugo.",
        "riverAsPreflopAggressor": "Kot preflop agresor",
        "riverVsPreflopAggressor": "Proti preflop agresorju",
        "riverCheckedToRiver": "Čekirano do riverja",
        "handFrequencyP": "Pogostost kombinacij (%)",
        "totalHands": "Število iger",
        "wonAtShowdown": "Zmagal pri razkritju",
        "riverAggression": "River agresija",
        "riverCallEff": "Uč. river klica",
        "riverBetEff": "Uč. river stave",
        "riverWentToShowdown": "Šel do razkritja",
        "riverRiverHoleCards": "River začetne karte",
        "riverRiverHandStrength": "River moč kombinacije",
        "riverRiverAgression": "River agresija %",
        "riverRiverCallEfficiency": "Učinkovitost river klica",
        "riverRiverBetEfficiency": "Učinkovitost river stave",
        "riverRiverPotSize": "Velikost river pota",
        "numberOfTables": "Število miz",
        "sessions": "Seje",
        "leakonomicsOpponentNoteColor": "Barva beležke nasprotnika",
        "leakonomicsSessionProgressSessionNames": "Krajše;Povprečna dolžina seje;Daljše",
        "leakonomicsSessionProgressMin": "Seja v teku (min)",
        "netWonBb": "Dobiček (bb)",
        "leakonomicsSessionsSplit": "Razdeljene seje",
        "leakonomicsPotAmountWonbb": "Dobljena velikost pota (bb)",
        "orLess": "${0} ali manj",
        "leakonomicsAllinSplit": "All-in Razdeljeno",
        "leakonomicsAllinWinsInaRow": "Zaporednih All-in zmag",
        "winnings": "Dobiček",
        "leakonomicsRollingWindow": "Grafični prikaz oken",
        "leakonomicsNetWon": "Dobiček plus/minus",
        "leakonomicsUpDownSessionNames": "Ko v minusu;Nevtralno;Ko v plusu",
        "leakonomicsPreflopStatsDev": "Razlika PF Statistik",
        "leakonomicsBestWrt": "Naj stopnja zmage: ${0} bb",
        "leakonomicsBestWrtAt": "Pri ${0} min",
        "leakonomicsWinlossSessionNames": "Serija izgub;Nevtralno;Serija zmag",
        "leakonomicsAllinRate": "All-in Stopnja",
        "leakonomicsWinningP": "Zmaga: ${0}%",
        "leakonomicsLosingP": "Izguba: ${0}%",
        "leakonomicsBestWrt2": "Naj stopnja zmage: ${0} bb/ura",
        "leakonomicsBestWrtAt2": "Pri ${0} mizah",
        "at": "Pri",
        "leakonomicsWinrateBb100P": "Stopnja zmage: 5bb/100",
        "leakonomicsPotsLost": "Potov izgubljenih: ${0}%",
        "leakonomicsPotsWon": "Potov dobljenih: ${0}%",
        "leakonomicsWhenUporDownInSession": "Ko v plusu ali v minusu v seji",
        "leakonomicsSessionProgress": "Seja v teku",
        "leakonomicsAfterAllinSeries": "Po All-in seriji",
        "leakonomicsWhenMultitabling": "Pri večih mizah",
        "leakonomicsVsOpponentbyNoteColor": "Proti nasprotniku po barvi beležke",
        "leakonomicsAfterWinningorlosingapot": "Po zmagi ali izgubi pota",
        "cbetSuccessP": "Cbet uspeh %",
        "winrate": "Stopnja zmage",
        "winrateBB100": "Stopnja zmage (bb/100)",
        "cbetActionHU": "Cbet akcija: Heads Up",
        "cbetActionMultiway": "Cbet akcija: Več igralcev",
        "cbetActionHUNoHands": "Heads Up: Ni iger",
        "cbetActionMultiwayNoHands": "Več igralcev: Ni iger",
        "cbetWonLost": "$ Pridobil / Izgubil",
        "cbetResultsSkippedDonut1Title": "Skupno izpuščeni Cbeti",
        "cbetResultsSkippedDonutSubtitle": "Po ${0} Igrah<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Skupno izpuščenih Cbetov: Ni iger",
        "cbetResultsSkippedDonut2Title": "Skupno Cbet uspeh",
        "cbetResultsSkippedDonut2TitleNoHands": "Skupno Cbet uspeh: Ni iger",
        "hands": "Igre",
        "cbetActionIP": "CBet akcija: V poziciji",
        "cbetActionOOP": "Cbet akcija: Izven pozicije",
        "cbetNoHandsIP": "V poziciji: Ni iger",
        "cbetNoHandsOOP": "Izven pozicije: Ni iger",
        "cbetOverallSuccess": "Skupni uspeh",
        "cbetFlopCBetSuccess": "Flop CBet uspeh",
        "cbetCBetWinrate": "Cbet Stopnja zmage",
        "cbetSkippedCBetWinnings": "Izpuščeni Cbeti Dobiček",
        "cbetCBetSuccessBoardTexture": "Cbet uspeh: Textura boarda",
        "cbetCBetSuccessPosition": "Cbet uspeh: Pozicija",
        "cbetHandStrengthwhenCBettting": "Moč kombinacije pri CBetanju",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet situacije - Heads Up proti Več igralcev",
        "cbetCBetSpotsInPositionvsOutofPosition": "Cbet situacije - V poziciji proti Izven pozicije",
        "cbetResultsSkippedCBet": "Izpuščeni Cbeti Rezultat",
        "bubbleICMDescription5": "Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na vaš efektiven stack pri začetku igre.",
        "bubblePercentageDescription5": "Odstotki dobljenega nagradnega sklada razvrščeni po vašem efektivnem stacku.",
        "bubblePreflopDescription5": "Vaša preflop statistika razvrščena po velikosti vašega stacka.",
        "bubbleEffectiveStackSizebb": "Efektivna velikost stacka (bb)",
        "bubbleBubbleStackSize": "Velikost stacka na Balonu",
        "bubbleCallingAllInRange": "Klic All-In Rang",
        "bubbleSitNGoEntrants": "Sit 'N Go št. igralcev",
        "bubbleICMDescription4": "Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na število igralcev turnirja.",
        "bubblePercentageDescription4": "Odstotki dobljenega nagradnega sklada razvrščeni po številu udeležencev.",
        "bubblePreflopDescription4": "Vaša preflop statistika razvrščena po velikosti vašega stacka.",
        "bubbleBubblePosition": "Pozicija balona",
        "bubbleICMDescription3": "Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na pozicijo sedeža.",
        "bubblePercentageDescription3": "Odstotki dobljenega nagradnega sklada razvrščeni po vaši poziciji.",
        "bubblePreflopDescription3": "Vaša preflop statistika razvrščena po vaši poziciji",
        "bubblePreflopDescription2": "Odstotki dobljenega nagradnega sklada razvrščeni po številu obstoječih igralcev na balonu.",
        "bubblePlayersAtBubble": "# Igralcev ",
        "bubbleBubblePlayers": "Balon igralci na balonu",
        "bubblePrizePoolP": "Nagradni sklad%",
        "bubbleBubbleStage": "Faza balona",
        "bubbleEVbb100hands": "EV BB/100 Igre",
        "bubbleICMDescription": "Informacije spodaj predstavljajo ICM (independent chip model) reprezentacijo dobljenega nagradnega sklada glede na fazo turnirja. Pred balonom predstavlja vse igre v katere ste vpleteni pred fazo turnirja, kjer naslednji izpadli igralec poči balon, ostali pa pridejo do denarnih nagrad.",
        "bubblePercentageDescription": "Odstotki dobljenega nagradnega sklada pred, med in po balonu.",
        "bubblePreflopDescription": "Vaša preflop statistika razvrščena po velikosti vašega stacka.",
        "bubblePrizePoolWon": "Dobljeni nagradni sklad",
        "bubbleExpectedValue": "Pričakovana vrednost",
        "bubbleAverageStack": "Povprečna velikost stacka",
        "bubbleCallAIWinrate": "Klic AI Stopnja zmage",
        "bubbleShoveAIWinrate": "Potisk AI Stopnja zmage",
        "tooFewHands": "Premalo iger za to poročilo",
        "bubblePrizePoolWinningsTitle": "Dobiček nagradnega sklada",
        "bubbleExpectationWhenReachingBubbleTitle": "Pričakovana vrednost pri dosegu balona",
        "bubblePositionTitle": "Pozicija",
        "bubbleBeforeAndAfterTitle": "Pred in po",
        "bubbleStackSizeTitle": "Velikost stacka",
        "bubbleCallRangesTitle": "Klic Rangi",
        "bubbleShoveRangesTitle": "Potistk All-in Rangi",
        "tourneyallinRaisingOpenAI": "Višanje Odpiranja AI",
        "tourneyallinRaising3BetAI": "Višanje 3Bet AI",
        "tourneyallinRaisevsOpen": "Višanje proti Odprtju",
        "tourneyallinRaisevs3Bet": "Višanje proti 3-Betu",
        "tourneyallinCallvsOpen": "Klic proti Odprtju",
        "tourneyallinCallvs3Bet": "Klic proti 3-Betu",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop efektivna velikost stacka",
        "tourneyallinRacesWonPAxis": "Dobljenih Dirk %",
        "tourneyallinEquityPAxis": "Vrednost %",
        "tourneyallinCallingOpenAI": "Klic Odprtja AI",
        "tourneyallinCalling3BetAI": "Klic 3Bet AI",
        "tourneyallinPositionAxis": "Pozicija",
        "tourneyallinExpectationAxis": "Pričakovana vrednost",
        "threebetResultsTitle": "Rezultati",
        "threebetPositionTitle": "Pozicija",
        "threebetRangeTitle": "Three Bet Rang",
        "threebetSuccessTitle": "Three Bet Uspeh",
        "threebetFlopHandStrengthTitle": "Flop moč kombinacije",
        "threebetWinrate": "3Bet Stopnja zmage",
        "threebetFrequency": "3Bet pogostost",
        "threebetRange": "3Bet Rang",
        "threebetSuccessRate": "3Bet Stopnja uspeha",
        "threebetFlopWinrate": "Flop Stopnja zmage",
        "threebetWinrateHandStrengthAxis": "Moč kombinacije Stopnja zmage (bb/100)",
        "threebetHandCount": "${0} (${1} Iger)",
        "threebetWinrateKey": "Stopnja zmage",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Stopnja zmage (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Uspeh %",
        "threebetNetwonTitle": "Dobiček skupno",
        "threebetNetwonMin": "Izguba",
        "threebetNetwonMax": "Dobiček",
        "threebetDealtFrequencyTitle": "Pogostost ",
        "threebetDealtFrequencyMin": "Manj pogosto",
        "threebetDealtFrequencyMax": "Bolj pogosto",
        "tourneyallinExpectedWon": "Pričakovan dobiček",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Neznano;Visoka Karta;En Par;Dva Para;Tris;Lestvica;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Neznano;Visoka Karta;En Par;Dva Para;Tris;Lestvica;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Mavrica;Flush Dvobarvni;Flush Enobarvni",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Parni board;Brez para",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "V poziciji;Izven pozicije",
        "availableStringRiverplayCallEfficiency": "Učinkovitost klica;V poziciji;Izven pozicije",
        "availableStringRiverplayBetEfficiency": "Učinkovitost stave;V poziciji;Izven pozicije",
        "availableStringCBetSpots": "Izpuščeni Cbet;Soočeni z Donk betom;CBet & Zmaga igre;Cbet & Izguba igre",
        "availableStringRiverFirstActionString": "Odstop;Ček;Klic;Stava;Višanje",
        "ECCallCallVsVillainOpenAllinPreflop": "Klic Nasprotnikovega AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost pri Klicanju nasprotnikovega AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Klic nasprotnikovega 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost pri Klicanju nasprotnikovega 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF proti Višanju",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost AI PF proti Višanju",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF proti Po-Višanju",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost 3Bet AI PF proti Po-Višanju",
        "BPCCallCallVsVillainOpenAllinPreflop": "Klic nasprotnikovega AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost pri klicanju nasprotnikovega AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Klic nasprotnikovega 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Pričakovana vrednost pri Klicanju nasprotnikovega 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF proti Višanju",
        "BPRRaiseEVAllinVsRaisePreflop": "Pričakovana vrednost AI PF proti Višanju",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF proti Po-Višanju",
        "BPRTBetEVAllinVsRaisePreflop": "Pričakovana vrednost 3Bet AI PF proti Po-Višanju",
        "threebetHandAxis": "Igra",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Pričakovana vrednost Klicanja All-In po velikosti stacka",
        "tourneyallinRaisingByStackTitle": "Pričakovana vrednost Višanja All-In po velikosti stacka",
        "tourneyallinRaisingAllinRangeTitle": "Višanje All-In Rang",
        "tourneyallinCallingAllinRangeTitle": "Klic All-In Rang",
        "tourneyallinCallingAllinByPositionTitle": "Rezultati Klicanja All-In po poziciji",
        "tourneyallinRaisingAllinByPositionTitle": "Rezultati Višanja All-In po poziciji",
        "tourneyallinCallAIEVWinrate": "Klic AI EV Stopnja zmage",
        "tourneyallinRaiseAIEVWinrate": "Višanje AI Stopnja zmage",
        "tourneyallinCallAIWinrate": "Klic AI Stopnja zmage",
        "tourneyallinRaiseAIWinrate": "Višanje AI Stopnja zmage",
        "overall": "Skupno",
        "restrictionsWithYourLicenseText": "<b>Ni dostopa</b> do HM3 Aplikacij\nSporočilo preizkusne verzije v poročilih in HUDu\ntrajanje 14 dni"
    },
    spanish : {
        "notAllowedByLicense": "Mano No Permitida por Licencia",
        "selectHandToExport": "Seleccione Mano A Exportar",
        "selectFormat": "Seleccione formato...",
        "originalFormat": "Formato Original",
        "ctrlCToCopy": "Ctrl-C para Copiar al Portapapeles",
        "availableTags": "Etiquetas Disponibles",
        "welcomeToHm3": "Bienvenido al Replayer del HoldemManager3 ",
        "theme": "Tema:",
        "deck": "Cubierta:",
        "showHandResults": "Mostrador Resultados de Manos:",
        "showHeroCards": "Siempre Mostrar de Inicio de Hero:",
        "showBB": "Mostrar Manos en CG:",
        "combineFolds": "Combinar Carpetas:",
        "maskPlayerNames": "Máscara de los Nombres de los Jugadores:",
        "statsUpToTimeOfHand": "Estadísticas Hasta el Momento de la Mano:",
        "showHud": "MostrarHUD:",
        "replaySpeed": "Velocidad de Replay",
        "hand": "Mano",
        "next100Hands": "100 Manos Siguientes",
        "prev100Hands": "100 Manos Anteriores",
        "addEditHandMarking": "Añadir/Editar Marcas de Mano",
        "wonXBB": "Ganó ${0} CG",
        "lostXBB": "Perdió ${0} CG",
        "wonLossNA": "Ganó/Perdió NA",
        "potBB": "Bote: ${0} CG",
        "userWentAllin": "El Usuario Fue All In",
        "pot": "Bote: ${0}",
        "potOdds": "Probabilidades del Bote: $ {0}: 1",
        "hhGameStart": "El juego $ {0} $ {1} comienza en $ {2}",
        "hhHandNotes": "Nota(s) de Mano",
        "hhFold": "$ {0} Folds",
        "hhCheck": " ${0} Checks",
        "hhCall": "${0} Calls ${1}",
        "hhBet": "${0} Apuestas ${1}",
        "hhRaise": "${0} Aumentos ${1}",
        "hhReturnedTo": "$ {1} Devuelto a $ {0}",
        "hhWin": "$ {0} Gana $ {1}",
        "hhRake": "Rake: ${0}",
        "hhActionEnded": "La acción ha terminado.",
        "hhMuck": "$ {0} mucks $ {1}",
        "hhShow": "$ {0} muestra $ {1}",
        "hhPostSB": "${0} posts ciega grande",
        "hhPostBB": "${0} posts small grande",
        "hhPostDB": "${0} posts ciega muerta",
        "backToReleaseNotes": "Volver a Las Notas de Lanzamiento",
        "backToMyLicense": "Volver a Mi Licencia",
        "backToCardInfo": "Volver a La Información de La Tarjeta de Crédito",
        "backToPayment": "Volver a Método de Pago",
        "orderBuyNow": "Comprar Ahora",
        "orderProceed": "Proceder",
        "headerTextTrial": "Prueba ($ {0} Días Restantes)",
        "headerTextFree": "Gratis",
        "smallStakes": "Stakes Pequeños",
        "allStakes": "Todos Los Stakes",
        "smallStakesCaps": "Stakes Pequeños",
        "allStakesCaps": "Todos Los Stakes",
        "smallStakesMaintenance": "MANTENIMIENTO DE LOS STAKES PEQUEÑOS",
        "allStakesMaintenance": "MANTENIMIENTO DE TODOS LOS STAKES",
        "buyHoldemSmallStakes": "Stakes Pequeños Holdem",
        "buyHoldemAllStakes": "Todas Los Stakes de Holdem",
        "buyHoldemOmahaAllStakes": "Todos los Stakes",
        "buyOmahaSmallStakes": "Stakes Pequeños Omaha",
        "buyOmahaAllStakes": "Todos Los Stakes Omaha",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "OMAHA",
        "holdem": "Holdem",
        "omaha": "Omaha",
        "hmApps": "Apps HM",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Expiró en ${0}",
        "expiresOn": "Expira en ${0}",
        "recommended": "RECOMENDADO",
        "seeAllOptionsInStore": "Ver todas las opciones en la Tienda.",
        "paypalExternalBrowser": "PayPal se abrirá en un navegador externo para completar el proceso de pago.",
        "skrillExternalBrowser": "Skrill se cargará en un navegador externo para completar el proceso de pago.",
        "selectProduct": "SELECCIONAR PRODUCTO",
        "availableUpdate": "ACTUALIZACIÓN DISPONIBLE:",
        "versionAvailable": "La versión $ {0} está disponible: $ {1}",
        "fullFaq": "Preguntas Frecuentes de la Versión Completa",
        "reviewOptions": "Revise sus opciones de mantenimiento de Holdem antes de continuar con la actualización",
        "maintenanceOptions": "Opciones de Mantenimiento",
        "addProductToLicense": "AGREGUE $ {0} A SU LICENCIA ACTUAL",
        "purchasePrice": "Compra (${0})",
        "errorName": "Por Favor ingresa tu Nombre Completo",
        "errorAddress": "Por Favor ingresa el nombre de tu Calle y número",
        "errorCountry": "Por Favor ingresa tu País",
        "errorCity": "Por Favor ingresa tu Ciudad",
        "errorZip": "Por favor ingresa un Código Postal válido",
        "billingInfo": "INFORMACIÓN DE FACTURACIÓN",
        "name": "Nombre Completo",
        "address": "Dirección de Calle",
        "city": "Ciudad",
        "state": "Estado/Provincia",
        "zip": "Zip/´Código Postal",
        "country": "País",
        "selectCountry": "Selecciona un país",
        "buyNowTip": "Por favor selecciona un método de pago nuevo o existente antes de continuar.",
        "licenses": "LICENCIAS",
        "version": "Versión $ {0}",
        "viewReleaseNotes": "Ver las notas del lanzamiento en el sitio web",
        "updateAndRenewMaintenance": "ACTUALIZAR Y RENOVAR MANTENIMIENTO",
        "renewGetUpdatesUntil": "Al renovar el mantenimiento, recibirás todas las actualizaciones de HM3 por $ {0}",
        "update": "Actualizar",
        "updateAndSwitchToFree": "ACTUALIZAR Y CAMBIAR A LA VERSIÓN GRATUITA",
        "updateAndSwitchToFreeDetails1": "Recibirás la actualización, pero tu software HM3 (Holdem) volverá a la versión gratuita y tendrá",
        "updateAndSwitchToFreeDetails2": "funcionalidad limidad",
        "updateAndSwitch": "Actualizar y Cambiar",
        "errorCreditCardDigitsOnly": "El número de la tarjeta de crédito debe contener sólo dígitos.",
        "errorCreditCard": "Por favor, ingresa un número de tarjeta válido.",
        "errorRequired": "Requerido",
        "errorCardExpired": "Tarjeta Vencida",
        "errorCvv": "El CVV debe tener $ {0} dígitos de longitud",
        "cardInfo": "INFORMACIÓN DE TARJETA DE CRÉDITO",
        "cardNo": "No de Tarjeta",
        "expiry": "Vencimiento",
        "year": "año",
        "month": "mes",
        "month01": "Enero",
        "month02": "Febrero",
        "month03": "Marzo",
        "month04": "Abril",
        "month05": "Mayo",
        "month06": "Junio",
        "month07": "Julio",
        "month08": "Agosto",
        "month09": "Septiembre",
        "month10": "Octubre",
        "month11": "Noviembre",
        "month12": "Diciembre",
        "cvv": "CVV",
        "active": "Activa",
        "manageSubscription": "Administrar Suscripción",
        "youAreUpToDate": "Estas actualizado",
        "releaseNotes": "Notas de publicación para $ {0}",
        "netellerInfo": "Información de Cuenta de NETELLER",
        "netellerSignin": "Inicia Sesión en tu cuenta de NETELLER para completar tu compra",
        "continue_": "Continuar",
        "netellerAccount": "Cuenta de Neteller",
        "netellerPassword": "Contraseña",
        "orderSummary": "RESUMEN DE LA ORDEN:",
        "changeProducts": "Cambiar Producto(s)",
        "total": "Total",
        "paypalComplete": "POR FAVOR COMPLETA TU COMPRA POR PAYPAL EN TU NAVEGADOR",
        "paypalOpenedInNewBrowser": "Hemos abierto PayPal en la ventana de tu navegador de internet predeterminado. Por favor ingresa a tu cuenta de PayPal y completa la compra. Una vez que se haya completado la compra, regresa aquí y haz clic en \"Actualizar Licencia\" para cargar la licencia que has comprado.",
        "reloadLicense": "Actualizar Licencia",
        "thankYouForPurchase": "Gracias Por Tu Compra",
        "purchaseConfirm1": "Recibirás una confirmación por correo electrónico en breve en $ {0}",
        "purchaseConfirm2": "Haz clic en el botón de renovar licencia a continuación y tu licencia comprada estará activa.",
        "restricted": "restringido",
        "restrictionsWithYourLicense": "RESTRICCIONES CON TU LICENCIA ACTUAL",
        "paymentPleaseChoose": "Por favor, elije un método de pago",
        "paymentSelectExisting": "Selecciona un método de pago existente:",
        "paymentSelectNew": "Método de Pago",
        "paymentMethod": "Método de Pago:",
        "changePaymentMethod": "Cambiar Método de Pago",
        "licensedTo": "LICENCIA AUTORIZADA PARA",
        "learnMore": "Conocer Más",
        "startTrial": "Iniciar Prueba",
        "purchase": "Compra",
        "trialSuccessfullyStarted": "La Prueba se ha iniciado exitosamente",
        "trialSuccessDetails1": "Tu prueba de 14 días está activa ahora. Por favor ",
        "trialSuccessDetails2": "actualizar",
        "trialSuccessDetails3": "Tan pronto como sea posible para evitar interrupciones a tu servicio.",
        "havingTrouble": "¿Teniendo problemas?",
        "contactUs": "Contáctanos",
        "startUsing": "Empieza a usar HM3 ahora",
        "missedUpdates": "$ {0} actualizaciones perdidas",
        "updatesAreCritical": "Las actualizaciones son fundamentales para garantizar que HM3 continúe importando tu historial de manos después de que los sitios de póker realicen cambios en su software. Las nuevas características y funcionalidades también se lanzan a través de actualizaciones.",
        "view": "Ver",
        "oneYearOfUpdates": "Incluye un año de actualizaciones",
        "renew": "\nRenovar ($ {0})",
        "startingAt": "A partir de",
        "upgrade": "Actualización",
        "removesRestrictions1": "Elimina ",
        "removesRestrictions2": "Restricciones",
        "removesRestrictions3": " e incluye un año de actualizaciones",
        "upgradePrice": "Actualizar ($ {0})",
        "required": "Requerido",
        "continueFreemium": "Continuar con la Versión Gratuita",
        "defaultFatalError": "Se ha producido un error interno inesperado del servidor y se ha notificado a un administrador. Por favor, intenta comprar de nuevo más tarde.\n",
        "restrictCashHandsType": "Manos Mesa Abierta",
        "restrictTourneyType": "Torneo",
        "restrictLimitCashHandsType": "Manos Mesa abierta con Límite",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Informe de datos\n",
        "restrictCashHands": "$ $ {0} y por debajo",
        "restrictLimitCashHands": "$ $ {0} y por debajo\n",
        "restrictTourney": "Máx $ {0}\n",
        "restrictHud": "Máx ${0} Mesa(s)",
        "restrictReportData": "Últimas $ {0} Manos",
        "restrictionUnlimited": "Ilimitado",
        "errorState": "Requerido",
        "activeHoldemLicense": "ACTIVAR LICENCIA HOLDEM",
        "activeOmahaLicense": "ACTIVAR LICENCIA OMAHA",
        "reinstallOldVersion": "Reinstalar la Versión Antigua",
        "removesRestrictions3b": "y vuelve a stu licencia paga pero las actualizaciones son\n",
        "removesRestrictions4b": "NO INCLUIDO",
        "noActiveHoldemLicense": "LICENCIA HOLDEM NO ACTIVA",
        "noActiveOmahaLicense": "LICENCIA OMAHA NO ACTIVA",
        "free": "GRATIS",
        "netellerSecureId": "Identificación Segura",
        "recurringPriceDescription": "$ {0} $ {1} Incluido *",
        "recurringYear": "Año",
        "recurringMonth": "Mes",
        "recurringDay": "Día",
        "restrictionsSmall": "Sin Límite/Límite de Bote Cash <b>restringido</b> ciegas grandes hasta $0.50 \nLímite Fijo Cash <b>restringido</b> ciegas grandes hasta $1.00 Torneos<b>restringido</b>  buy-ins hasta $22.00.",
        "afterDiscount": "Precio luego del descuento por tiempo limitado \n",
        "upgradeDiscount": "ATUALIZAR DESCUENTO",
        "discountExpires": "El descuento Expira el 31 de Marzo de 2019",
        "discountSinglePurchase": "El descuento se aplica a una sola compra.",
        "errorNetellerAccount": "ID de Cuenta de Neteller no válida",
        "errorNetellerSecureId": "Por favor ingresa tu ID de seguridad de 6 dígitos\n",
        "continueTrial": "Continuar Prueba",
        "continueTrialDaysRemaining": "($ {0} Días Restantes)\n",
        "netellerInvalidCredentials": "No pudimos validar tus credenciales de Neteller. Por favor, intenta iniciar sesión de nuevo.\n",
        "faq": "FAQ",
        "forMoreDetails": " para obtener más detalles sobre la gestión de tu renovación anual de Soporte y Mantenimiento.\n ",
        "recurringSubscription": "* Se requiere un método de pago para la renovación anual de Soporte y Mantenimiento de $$ {0} que se facturará dentro de un año ($ {1}). Ver \n",
        "positivePrice": "La renovación anual de Soporte y Mantenimiento de $$ {0} se facturará en un año ($ {1}). Ver \n",
        "paymentSeeWebsite1": "Ver ",
        "paymentSeeWebsite2": "TIENDA",
        "paymentSeeWebsite3": " para más opciones de pago",
        "paymentOr": "- O -",
        "couldNotStartMlaTitle": "Encontramos un problema",
        "couldNotStartMlaText": "No se Pudieron Iniciar Mis Licencias. Hemos notificado a un administrador. Por favor verifica nuevamente más tarde. Si el problema persiste, comunícate con nuestro soporte técnico.",
        "skipEndOfHandLabel": "Skip End Of Hand",
        "inPosition": "In Position",
        "outOfPosition": "Out Of Position",
        "amountBb": "${0} bb",
        "amountBbPlus": "${0}+ bb",
        "amountBb100": "${0} bb/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Here you can find how often and how efficiently you play on the river based on pot size.",
        "riverCombinethisview6": "Combine this view with filters to find out if you are winning a lot of small pots, losing big pots and more.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Here you can find how often and how efficiently you play different hole cards on the river.",
        "riverCombinethisview5": "Combine this view with filters to find out how your ranges differ when betting, calling, raising, and more.",
        "riverHereyoucanfind4": "Here you can find how often and how efficiently you play on the river with different hand strengths.",
        "riverCombinethisview4": "Combine this view with filters to find out if you are getting to river with too many weak hands, if you are going to showdown with strong hands, and more.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RCE) shows you return for each big blind invested in river calls or check calls.",
        "riverCombinethisview3": "Combine this view with filters to find out how efficient your river calls are when facing CBets, Donk bets, different bet sizes and more.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "River Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) shows you return for each big blind invested in river bets.",
        "riverCombinethisview2": "Combine this view with filters to find out how efficient your river bets are when doing CBets, Donk bets, different bet sizes and more.",
        "riverHereyoucanfind": "Here you can find how aggressively you play on the river and your results for each action played.",
        "tip": "Tip",
        "riverCombinethisview": "Combine this view with filters to find out how your play differs when playing as aggressor, vs aggressor and more",
        "riverAsPreflopAggressor": "As Preflop Aggressor",
        "riverVsPreflopAggressor": "Vs Preflop Aggressor",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Total Hands",
        "wonAtShowdown": "Won At Showdown",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went To Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Number Of Tables",
        "sessions": "Sessions",
        "leakonomicsOpponentNoteColor": "Opponent Note Color",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} or less",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Winnings",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "At",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "When Multitabling",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "After Winning or losing a pot",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Hands",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "The information below represents the ICM (independent chip model) representation of the prize pool won based on your effective stack size at the start of the hand.",
        "bubblePercentageDescription5": "Percentage of the prize pool won categorized by your effective stack size",
        "bubblePreflopDescription5": "Your preflop stats categorized on your stack size",
        "bubbleEffectiveStackSizebb": "Effective Stack Size (bb)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Sit 'N Go Entrants",
        "bubbleICMDescription4": "The information below represents the ICM (independent chip model) representation of the prize pool won categorized by the number of entrants in the tournament.",
        "bubblePercentageDescription4": "Percentage of the prize pool won categorized by the number of entrants",
        "bubblePreflopDescription4": "Your preflop stats categorized on your stack size",
        "bubbleBubblePosition": "Bubble Position",
        "bubbleICMDescription3": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the position at the table you are sitting in.",
        "bubblePercentageDescription3": "Percentage of the prize pool won categorized by your position",
        "bubblePreflopDescription3": "Your preflop stats categorized by your position",
        "bubblePreflopDescription2": "Percentage of the prize pool won categorized by the number players remaining at the bubble",
        "bubblePlayersAtBubble": "# Players At Bubble",
        "bubbleBubblePlayers": "Bubble Players at Bubble",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Bubble Stage",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "The information below represents the ICM (independent chip model) representation of the prize pool won based on the stage of the tournament.  Before the bubble represents all hands you are involved in before reaching the stage in the tournament where the next player knocked out 'bursts' the buble with remaining players receiving prizes for the game.",
        "bubblePercentageDescription": "Percentage of the prize pool won before, during, and after the bubble",
        "bubblePreflopDescription": "Your preflop stats categorized on your stack size",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Too Few Hands For This Report",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Position",
        "bubbleBeforeAndAfterTitle": "Before And After",
        "bubbleStackSizeTitle": "Stack Size",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Preflop Effective Stack Size",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Position",
        "tourneyallinExpectationAxis": "Expectation",
        "threebetResultsTitle": "Results",
        "threebetPositionTitle": "Position",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Dealt Frequency",
        "threebetDealtFrequencyMin": "Less Frequent",
        "threebetDealtFrequencyMax": "More Frequent",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Hand",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Overall",
        "restrictionsWithYourLicenseText": "<b>No access</b> to HM3 Apps\r\nTrial version message in reports and HUD\r\n14 day duration"
    },
    ukrainian :{
        "notAllowedByLicense": "Роздача не допускається ліцензією",
        "selectHandToExport": "Обрати руку для експорту",
        "selectFormat": "Обрати формат...",
        "originalFormat": "Оригiнальний формат",
        "ctrlCToCopy": "Ctrl-C для копіювання в буфер",
        "availableTags": "Доступнi мiтки",
        "welcomeToHm3": "Ласкаво просимо в реплеер HoldemManager3!",
        "theme": "Тема: ",
        "deck": "Колода: ",
        "showHandResults": "Показати результат роздачі: ",
        "showHeroCards": "Завжди показувати карти Hero: ",
        "showBB": "Показати фішки в ВБ: ",
        "combineFolds": "Об'єднати фолди: ",
        "maskPlayerNames": "Сховати iмена гравцiв: ",
        "statsUpToTimeOfHand": "Стати на час початку роздачi: ",
        "showHud": "Показати HUD: ",
        "replaySpeed": "Швидкiсть реплееру: ",
        "hand": "Рука",
        "next100Hands": "Наст. 100 рук",
        "prev100Hands": "Попер. 100 рук",
        "addEditHandMarking": "Додати/Правити помiтки рук",
        "wonXBB": "Виграно ${0} ВБ",
        "lostXBB": "Програно ${0} ВБ",
        "wonLossNA": "Виграш/Програш NA",
        "potBB": "Банк: ${0} ВБ",
        "userWentAllin": "Гравець пiшов олл-iн",
        "pot": "Банк: ${0}",
        "potOdds": "Шанси банку: ${0}:1",
        "hhGameStart": "Гра ${0} ${1} почалася в ${2}",
        "hhHandNotes": "Помiтка(и) рук",
        "hhFold": "${0} фолд",
        "hhCheck": "${0} чек",
        "hhCall": "${0} кол ${1}",
        "hhBet": "${0} бет ${1}",
        "hhRaise": "${0} рейз ${1}",
        "hhReturnedTo": "${1} повернено до ${0}",
        "hhWin": "${0} виграв ${1}",
        "hhRake": "Рейк: ${0}",
        "hhActionEnded": "Дiя закiнчилася.",
        "hhMuck": "${0} сховав ${1}",
        "hhShow": "${0} показав ${1}",
        "hhPostSB": "${0} розміщує великий блайнд",
        "hhPostBB": "${0} розміщує малий блайнд",
        "hhPostDB": "${0} розміщує мертвий блайнд",
        "backToReleaseNotes": "Назад до приміток випуску",
        "backToMyLicense": "Назад до моєї ліцензії",
        "backToCardInfo": "Назад до інформації про кредитну картку",
        "backToPayment": "Назад до способу оплати",
        "orderBuyNow": "Придбати зараз",
        "orderProceed": "Виконати",
        "headerTextTrial": "Трiал (${0} днiв залишилося)",
        "headerTextFree": "Безкоштовно",
        "smallStakes": "Малi лiмiти",
        "allStakes": "Всi лiмiти",
        "smallStakesCaps": "МАЛI ЛIМIТИ",
        "allStakesCaps": "ВСI ЛIМIТИ",
        "smallStakesMaintenance": "ТЕХОБСЛУГОВУВАННЯ МАЛИХ СТАВОК",
        "allStakesMaintenance": "ТЕХОБСЛУГОВУВАННЯ ВСIХ ЛIМIТIВ",
        "buyHoldemSmallStakes": "Холдем малi лiмiти",
        "buyHoldemAllStakes": "Холдем всi лiмiти",
        "buyHoldemOmahaAllStakes": "Всi лiмiти",
        "buyOmahaSmallStakes": "Омаха малi лiмiти",
        "buyOmahaAllStakes": "Омаха всi лiмiти",
        "holdemManager": "Holdem Manager",
        "holdemManagerCaps": "HOLDEM MANAGER",
        "omahaCaps": "ОМАХА",
        "holdem": "Холдем",
        "omaha": "Омаха",
        "hmApps": "HM Apps",
        "hm3": "HM3",
        "om3": "OM3",
        "hm3andOm3": "HM3 + OM3",
        "expiredOn": "Термін дії закінчився ${0}",
        "expiresOn": "Закінчується ${0}",
        "recommended": "РЕКОМЕНДОВАНО",
        "seeAllOptionsInStore": "Переглянути всі параметри в магазині",
        "paypalExternalBrowser": "PayPal вiдкриється в зовнiшньюму браузерi для завершення процесу оплати.",
        "skrillExternalBrowser": "Skrill вiдкриється в зовнiшньюму браузерi для завершення процесу оплати.",
        "selectProduct": "ОБРАТИ ПРОДУКТ",
        "availableUpdate": "ДОСТУПНI ОНОВЛЕННЯ: ",
        "versionAvailable": "Версiя ${0} доступна: ${1}",
        "fullFaq": "FAQ по повнiй версії",
        "reviewOptions": "Перед початком оновлення перегляньте варіанти обслуговування Holdem",
        "maintenanceOptions": "Варіанти обслуговування",
        "addProductToLicense": "ДОДАТИ ${0} ДО ПОТОЧНОЇ ЛІЦЕНЗІЇ",
        "purchasePrice": "Придбати (${0})",
        "errorName": "Введiть повне iм'я",
        "errorAddress": "Введiть вулицю та номер будинка",
        "errorCountry": "Введiть країну",
        "errorCity": "Введiть мiсто",
        "errorZip": "Введiть поштовий iндекс",
        "billingInfo": "ПЛАТIЖНА IНФОРМАЦIЯ",
        "name": "Повне iм'я",
        "address": "Адреса",
        "city": "Мiсто",
        "state": "Область/провiнцiя",
        "zip": "Поштовий iндекс",
        "country": "Країна",
        "selectCountry": "Оберiть країну",
        "buyNowTip": "Оберiть iснуючий або новий метод плати перед початком",
        "licenses": "ЛІЦЕНЗІЇ",
        "version": "Версiя ${0}",
        "viewReleaseNotes": "Дивитися помiтки про змiни на сайтi",
        "updateAndRenewMaintenance": "ОНОВЛЕННЯ ТА ПОВТОРЕННЯ ОБСЛУГОВУВАННЯ",
        "renewGetUpdatesUntil": "Оновлюючи технічне обслуговування, ви отримаєте всі оновлення HM3 через ${0}",
        "update": "Поновити",
        "updateAndSwitchToFree": "ОНОВЛЕННЯ ТА ПЕРЕКЛЮЧЕННЯ ДО БЕЗКОШТОВНОЇ ВЕРСІЇ",
        "updateAndSwitchToFreeDetails1": "Ви отримаєте оновлення, але ваш HM3 (Holdem) повернеться до безкоштовної версії та буде мати",
        "updateAndSwitchToFreeDetails2": "обмежена функцiональнiсть",
        "updateAndSwitch": "Поновити та перейти",
        "errorCreditCardDigitsOnly": "Номер кредитної картки має містити лише цифри.",
        "errorCreditCard": "Введіть дійсний номер картки.",
        "errorRequired": "Обов'язкове",
        "errorCardExpired": "Термін дії картки закінчився",
        "errorCvv": "CVV має бути довжиною ${0} цифр",
        "cardInfo": "ДАНІ КРЕДИТНОЇ КАРТКИ",
        "cardNo": "Номер карти",
        "expiry": "Термін дії",
        "year": "рiк",
        "month": "мiсяць",
        "month01": "Сiч",
        "month02": "Лют",
        "month03": "Бер",
        "month04": "Квi",
        "month05": "Тра",
        "month06": "Чер",
        "month07": "Лип",
        "month08": "Сер",
        "month09": "Вер",
        "month10": "Жов",
        "month11": "Лис",
        "month12": "Гру",
        "cvv": "CVV",
        "active": "Активна",
        "manageSubscription": "Керувати підпискою",
        "youAreUpToDate": "Ви оновленi",
        "releaseNotes": "Примітки до випуску для ${0}",
        "netellerInfo": "Iнформацiя рахунку NETELLER",
        "netellerSignin": "Зайдiть в свiй рахунок NETELLER для завершення оплати",
        "continue_": "Продовжити",
        "netellerAccount": "Рахунок Neteller",
        "netellerPassword": "Пароль",
        "orderSummary": "ПІДСУМОК ЗАМОВЛЕННЯ: ",
        "changeProducts": "Змiнити продукт(и)",
        "total": "Загалом",
        "paypalComplete": "ЗАВЕРШIТЬ ПРИДБАННЯ ЧЕРЕЗ РАХУНОК PAYPAL В БРАУЗЕРI",
        "paypalOpenedInNewBrowser": "PayPal вiдкрито в iнтернет-браузерi за замовчуванням. Увійдіть до свого облікового запису PayPal і завершіть покупку. Після цього поверніться сюди та натисніть \"Перезавантажити ліцензію\", щоб завантажити ліцензію, яку ви придбали.",
        "reloadLicense": "Перезавантажити лiцензiю",
        "thankYouForPurchase": "Дякуємо за покупку",
        "purchaseConfirm1": "Незабаром ви отримаєте підтвердження електронною поштою на ${0}",
        "purchaseConfirm2": "Натисніть кнопку Перезавантаження ліцензії нижче, і ваша придбана ліцензія стане активна.",
        "restricted": "обмежено",
        "restrictionsWithYourLicense": "ОБМЕЖЕННЯ ВАШОЇ ЛІЦЕНЗІЇ",
        "paymentPleaseChoose": "Оберiть метод оплати",
        "paymentSelectExisting": "Оберiть метод оплати з iснуючих: ",
        "paymentSelectNew": "Метод оплати",
        "paymentMethod": "Метод оплати: ",
        "changePaymentMethod": "Змiнити метод оплати",
        "licensedTo": "ЛIЦЕНЗОВАНО ДЛЯ",
        "learnMore": "Взнати бiльше",
        "startTrial": "Почати трiал",
        "purchase": "Придбати",
        "trialSuccessfullyStarted": "Трiал успiшно почався",
        "trialSuccessDetails1": "Ваш 14-денний трiал тепер активний. Будь ласка ",
        "trialSuccessDetails2": "оновити",
        "trialSuccessDetails3": " якомога швидше, щоб уникнути перебоїв у роботі служби.",
        "havingTrouble": "З'явилися проблеми?",
        "contactUs": "Зв'язок з нами",
        "startUsing": "Почати використовувати HM3 зараз",
        "missedUpdates": "${0} пропущених оновлень",
        "updatesAreCritical": "Оновлення мають критичне значення для того, щоб HM3 продовжував імпортувати історії роздач після змін покерними сайтами свого програмного забезпечення. Нові функції та можливості також випускаються через оновлення.",
        "view": "Огляд",
        "oneYearOfUpdates": "Включає один рік оновлень",
        "renew": "Поновити ${0}",
        "startingAt": "Почато в ",
        "upgrade": "Поновити",
        "removesRestrictions1": "видаляє ",
        "removesRestrictions2": "обмеження",
        "removesRestrictions3": " та включає один рік оновлень",
        "upgradePrice": "Поновити ${0}",
        "required": "Обов'язкове",
        "continueFreemium": "Продовжити безкоштовну версiю",
        "defaultFatalError": "Трапилася несподiвана внутрiшня помилка серверу, адмiнiстратора повiдомлено. Спробуйте придбати знову пізніше.",
        "restrictCashHandsType": "Кешовi роздачi",
        "restrictTourneyType": "Турнiр",
        "restrictLimitCashHandsType": "Обмеження кешових роздач",
        "restrictHudType": "HUD",
        "restrictReportDataType": "Данi звiту",
        "restrictCashHands": "$ ${0} та нижче",
        "restrictLimitCashHands": "$ ${0} та нижче",
        "restrictTourney": "Макс ${0}",
        "restrictHud": "Макс ${0} столiв",
        "restrictReportData": "Останнi ${0} роздач",
        "restrictionUnlimited": "Необмежено",
        "errorState": "Обов'язкове",
        "activeHoldemLicense": "АКТИВНА ЛIЦЕНЗIЯ ХОЛДЕМ",
        "activeOmahaLicense": "АКТИВНА ЛIЦЕНЗIЯ ОМАХА",
        "reinstallOldVersion": "Перевстановіть стару версію",
        "removesRestrictions3b": "і повертається до вашої платної ліцензії, але оновлення",
        "removesRestrictions4b": "НЕ ВХОДИТЬ",
        "noActiveHoldemLicense": "НЕМАЄ АКТИВНОЇ ЛІЦЕНЗІЇ ХОЛДЕМ",
        "noActiveOmahaLicense": "НЕМАЄ АКТИВНОЇ ЛІЦЕНЗІЇ ОМАХА",
        "free": "БЕЗКОШТОВНО",
        "netellerSecureId": "Secure ID",
        "recurringPriceDescription": "${0} ${1} включені*",
        "recurringYear": "Рiк",
        "recurringMonth": "Мiсяць",
        "recurringDay": "День",
        "restrictionsSmall": "No Limit/Pot Limit Cash <b>обмежено</b> до великого блайнду $0.50\nFixed Limit Cash <b>обмежено</b> до великого блайнду $1.00\nTournaments <b>обмеженi</b> до бай-їну $22.00.",
        "afterDiscount": "Цiна пiсля строку дії знижки",
        "upgradeDiscount": "ЗНИЖКА НА ОНОВЛЕННЯ",
        "discountExpires": "Знижка закінчується 31 березня 2019",
        "discountSinglePurchase": "Знижка застосовується до однієї покупки.",
        "errorNetellerAccount": "Недійсний ідентифікатор облікового запису Neteller",
        "errorNetellerSecureId": "Введіть 6-значний Secure ID",
        "continueTrial": "Продовжити пробу",
        "continueTrialDaysRemaining": "(${0} днiв залишилося)",
        "netellerInvalidCredentials": "Не вдалося перевірити облікові дані Neteller. Спробуйте ввійти знову.",
        "faq": "FAQ",
        "forMoreDetails": " детальніше про управління щорічним оновленням підтримки та технічного обслуговування.",
        "recurringSubscription": "* Метод оплати необхідний для щорічного оновлення підтримки та технічного обслуговування $${0}, яке буде виставлено за один рік (${1}). Див. ",
        "positivePrice": "Оновлення рiчноЩорічне оновлення підтримки та технічного обслуговування $${0} буде виставлено за один рік (${1}). Див. ",
        "paymentSeeWebsite1": "Див. ",
        "paymentSeeWebsite2": "МАГАЗИН",
        "paymentSeeWebsite3": " iншi варiанти оплати",
        "paymentOr": "-АБО-",
        "couldNotStartMlaTitle": "Ми зіткнулися з проблемою",
        "couldNotStartMlaText": "Не вдалося вiдкрити роздiл 'Мої ліцензії'. Повідомлено адміністратора. Перевірте знову пізніше. Якщо проблема не зникає, зверніться до нашої служби підтримки.",
        "skipEndOfHandLabel": "Пропустити кінець роздачі",
        "inPosition": "У позиції",
        "outOfPosition": "Без позиції",
        "amountBb": "${0} вб",
        "amountBbPlus": "${0}+ вб",
        "amountBb100": "${0} вб/100",
        "cbetCbetSuccessTip": "Cbet Success: ${0} % <br/>Winrate: ${1} bb/100",
        "riverBetEfficiencyTip": "${0}<br/>Bet Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverCallEfficiencyTip": "${0}<br/>Call Efficiency: ${1}<br/>In Position: ${2}<br/>Out of Position: ${3}",
        "riverHandFrequencyTip": "Hand Frequency: ${0} % <br/>Winrate: ${1} bb/100",
        "riverPotSizeFrequencyTip": "Pot Size Frequency: ${0} % <br/>Winrate: ${1} bb/100\n",
        "tourneyallinRaisingCallingByPositionTip": "${0} (${1})<br/>Races Won: ${2}",
        "threebetBetFrequencyTip": "3-Bet: ${0} % <br/>Winrate: ${1} bb/100",
        "ipOopTip": "${0}<br/>In Position: ${1}<br/>Out of Position: ${2}",
        "riverHereyoucanfind6": "Тут можна дізнатися, як часто і як ефективно ви граєте на рівері в залежності від розміру банку.",
        "riverCombinethisview6": "У поєднанні з фільтрами цей огляд покаже, чи виграєте ви багато малих банків, програєте великі банки та інше.",
        "potSizeFrequencyP": "Pot Size Frequency (%)",
        "riverHereyoucanfind5": "Тут можна дізнатися, як часто і як ефективно ви граєте різні кишенькові карти на рівері.",
        "riverCombinethisview5": "Комбінуючий цей огляд із фільтрами, можна дізнатися, як відрiзняються ваші діапазони при ставках, коллах, рейзах і т.п.",
        "riverHereyoucanfind4": "Тут можна дізнатися, як часто і як ефективно ви граєте на рівері карти різної сили.",
        "riverCombinethisview4": "Комбінуючий цей огляд із фільтрами, можна дізнатися, чи доходите ви до риверу із дуже слабкими картами, або дивитесь відкриття із сильною рукою та інше.",
        "riverRiverCallEfficiencyNetWon": "River Call Efficiency Net Won",
        "riverRCE": "River Call Efficiency (RBE) показує ваш прибуток для кожного великого блайнда, інвестованого в коли та чек-коли на рівері.",
        "riverCombinethisview3": "Комбінуючий цей огляд із фільтрами, можна дізнатися, як ефективнi ефективні ваші коли на ривері, коли ви зустрічаєтесь з контбетами, донкбетами, різними розмірами ставок та інше.",
        "riverSawShowdown": "Saw Showdown",
        "riverNoShowdown": "No Showdown",
        "riverMadeRiverCbet": "Made River Cbet",
        "riverMadeRiverDonkBet": "Made River Donk Bet",
        "riverSmallriverbets": "Small river bets (<50% pot)",
        "riverBigriverbets": "Big river bets (>100% pot)",
        "riverFacedRiverCbet": "Faced River Cbet",
        "riverFacedRiverDonkBet": "Faced River Donk Bet",
        "riverRiverBet": "River Bet",
        "riverRiverCall": "River Call",
        "riverRiverRaise": "River Raise",
        "riverRiverFold": "River Fold",
        "riverWonHand": "Won Hand",
        "riverLostHand": "Lost Hand",
        "riverRiverBetEfficiencyNetWon": "iver Bet Efficiency Net Won",
        "riverRBE": "River Bet Efficiency (RBE) показує ваш прибуток для кожного великого блайнда, інвестованого в ставки на рівері.",
        "riverCombinethisview2": "Комбінуючий цей огляд із фільтрами, можна дізнатися, як ефективнi ефективні ваші ставки на ривері, коли ви зустрічаєтесь з контбетами, донкбетами, різними розмірами ставок та інше.",
        "riverHereyoucanfind": "Тут можна дізнатися, як агресивно ви граєте на рівері, та ваші результати по кожнiй ігровiй дії.",
        "tip": "Порада",
        "riverCombinethisview": "Комбінуючий цей огляд із фільтрами, можна дізнатися, як відрізняється ваша гра, коли ви є агресор, проти агресору та інше.",
        "riverAsPreflopAggressor": "Як префлоп агресор",
        "riverVsPreflopAggressor": "Проти префлоп агресора",
        "riverCheckedToRiver": "Checked To River",
        "handFrequencyP": "Hand Frequency (%)",
        "totalHands": "Всього роздач",
        "wonAtShowdown": "Виграно на розтині",
        "riverAggression": "River Aggression",
        "riverCallEff": "River Call Eff",
        "riverBetEff": "River Bet Eff",
        "riverWentToShowdown": "Went to Showdown",
        "riverRiverHoleCards": "River Hole Cards",
        "riverRiverHandStrength": "River Hand Strength",
        "riverRiverAgression": "River Agression %",
        "riverRiverCallEfficiency": "River Call Efficiency",
        "riverRiverBetEfficiency": "River Bet Efficiency",
        "riverRiverPotSize": "River Pot Size",
        "numberOfTables": "Число столiв",
        "sessions": "Сесії",
        "leakonomicsOpponentNoteColor": "Колір примітки на опонента",
        "leakonomicsSessionProgressSessionNames": "Shorter;Average Session Length;Longer",
        "leakonomicsSessionProgressMin": "Session Progress (Min)",
        "netWonBb": "Net Won (bb)",
        "leakonomicsSessionsSplit": "Sessions Split",
        "leakonomicsPotAmountWonbb": "Pot Amount Won (bb)",
        "orLess": "${0} або менше",
        "leakonomicsAllinSplit": "All-in Split",
        "leakonomicsAllinWinsInaRow": "All-in Wins in a Row",
        "winnings": "Виграші",
        "leakonomicsRollingWindow": "Rolling Window Graph",
        "leakonomicsNetWon": "Net Won Up/Down",
        "leakonomicsUpDownSessionNames": "When Down;Neutral;When Up",
        "leakonomicsPreflopStatsDev": "Preflop Stats Dev",
        "leakonomicsBestWrt": "Best wrt: ${0} bb",
        "leakonomicsBestWrtAt": "At ${0} min",
        "leakonomicsWinlossSessionNames": "Loss Series;Neutral;Win Series",
        "leakonomicsAllinRate": "All-in Rate",
        "leakonomicsWinningP": "Winning: ${0}%",
        "leakonomicsLosingP": "Losing: ${0}%",
        "leakonomicsBestWrt2": "Best wrt: ${0} bb/hr",
        "leakonomicsBestWrtAt2": "At ${0} table(s)",
        "at": "на",
        "leakonomicsWinrateBb100P": "Winrate: 5bb/100",
        "leakonomicsPotsLost": "Pots lost: ${0}%",
        "leakonomicsPotsWon": "Pots won: ${0}%",
        "leakonomicsWhenUporDownInSession": "When Up or Down In Session",
        "leakonomicsSessionProgress": "Session Progress",
        "leakonomicsAfterAllinSeries": "After All-in Series",
        "leakonomicsWhenMultitabling": "При грі на багатьох столах",
        "leakonomicsVsOpponentbyNoteColor": "Vs Opponent by Note Color",
        "leakonomicsAfterWinningorlosingapot": "Після виграшу або програшу банку",
        "cbetSuccessP": "CBet Success %",
        "winrate": "Winrate",
        "winrateBB100": "Winrate (bb/100)",
        "cbetActionHU": "CBet action: Heads Up",
        "cbetActionMultiway": "CBet action: Multiway",
        "cbetActionHUNoHands": "Heads Up: No Hands",
        "cbetActionMultiwayNoHands": "Multiway: No Hands",
        "cbetWonLost": "$ Won / Lost",
        "cbetResultsSkippedDonut1Title": "Overall Skipped Cbet",
        "cbetResultsSkippedDonutSubtitle": "Over ${0} Hands<br/>${1} bb/100",
        "cbetResultsSkippedDonut1TitleNoHands": "Overall Skipped Cbet: No Hands",
        "cbetResultsSkippedDonut2Title": "Overall CBet Success",
        "cbetResultsSkippedDonut2TitleNoHands": "Overall Cbet Success: No Hands",
        "hands": "Роздачі",
        "cbetActionIP": "CBet action: In Position",
        "cbetActionOOP": "CBet action: Out Of Position",
        "cbetNoHandsIP": "In Position: No Hands",
        "cbetNoHandsOOP": "Out Of Position: No Hands",
        "cbetOverallSuccess": "Overall Success",
        "cbetFlopCBetSuccess": "Flop CBet Success",
        "cbetCBetWinrate": "CBet Winrate",
        "cbetSkippedCBetWinnings": "Skipped CBet Winnings",
        "cbetCBetSuccessBoardTexture": "CBet Success: Board Texture",
        "cbetCBetSuccessPosition": "CBet Success: Position",
        "cbetHandStrengthwhenCBettting": "Hand Strength when CBettting",
        "cbetCBetSpotsHeadsUpvsMultiway": "CBet Spots - HeadsUp vs Multiway",
        "cbetCBetSpotsInPositionvsOutofPosition": "CBet Spots - In Position vs Out of Position",
        "cbetResultsSkippedCBet": "Results Skipped CBet",
        "bubbleICMDescription5": "Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з вашого ефективного стеку на початку роздачі.",
        "bubblePercentageDescription5": "Виграний відсоток призового фонду при різних розмірах ефективного стеку",
        "bubblePreflopDescription5": "Ваші стати префлоп при різних розмірах стеку",
        "bubbleEffectiveStackSizebb": "Розмір ефективного стеку (вб)",
        "bubbleBubbleStackSize": "Bubble Stack Size",
        "bubbleCallingAllInRange": "Calling All-In Range",
        "bubbleSitNGoEntrants": "Гравцiв в SNG",
        "bubbleICMDescription4": "Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з числа учасників турніру.",
        "bubblePercentageDescription4": "Виграний відсоток призового фонду при різному числі учасників",
        "bubblePreflopDescription4": "Ваші стати префлоп при різних розмірах стеку",
        "bubbleBubblePosition": "Позицiя на бабблi",
        "bubbleICMDescription3": "Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з вашої позиції за столом.",
        "bubblePercentageDescription3": "Виграний відсоток призового фонду в різних позиціях",
        "bubblePreflopDescription3": "Ваші стати префлоп в різних позиціях",
        "bubblePreflopDescription2": "Виграний відсоток призового фонду при різному числі залишилися до бабблу",
        "bubblePlayersAtBubble": "# гравцiв на бабблi",
        "bubbleBubblePlayers": "Гравцiв на бабблi",
        "bubblePrizePoolP": "Prize Pool%",
        "bubbleBubbleStage": "Стадiя бабблу",
        "bubbleEVbb100hands": "EV BB/100 Hands",
        "bubbleICMDescription": "Інформація нижче показує подання до ICM (модель незалежних фішок) виграної частини призового фонду виходячи з стадії турніру. Поперед бабла демонструє всі роздачі, в яких ви грали перед досягненням тієї стадії турніру, коли наступний вибитий гравець \"протикає\" пузир і тепер решта учасникiв буде в призах.",
        "bubblePercentageDescription": "Частина призового фонду, виграна до, пiд час та після бабла",
        "bubblePreflopDescription": "Ваші статі префлоп в залежності від величини свого стеку",
        "bubblePrizePoolWon": "Prize Pool Won",
        "bubbleExpectedValue": "Expected Value",
        "bubbleAverageStack": "Average Stack",
        "bubbleCallAIWinrate": "Call AI Winrate",
        "bubbleShoveAIWinrate": "Shove AI Winrate",
        "tooFewHands": "Занадто мало рук для цього звіту",
        "bubblePrizePoolWinningsTitle": "Prize Pool Winnings",
        "bubbleExpectationWhenReachingBubbleTitle": "Expectation When Reaching Bubble",
        "bubblePositionTitle": "Позицiя",
        "bubbleBeforeAndAfterTitle": "До і після",
        "bubbleStackSizeTitle": "Розмiр стеку",
        "bubbleCallRangesTitle": "Call Ranges",
        "bubbleShoveRangesTitle": "Shove Ranges",
        "tourneyallinRaisingOpenAI": "Raising Open AI",
        "tourneyallinRaising3BetAI": "Raising 3Bet AI",
        "tourneyallinRaisevsOpen": "Raise vs Open",
        "tourneyallinRaisevs3Bet": "Raise vs 3-Bet",
        "tourneyallinCallvsOpen": "Call vs Open",
        "tourneyallinCallvs3Bet": "Call vs 3-Bet",
        "tourneyallinPreflopEffectiveStackSizeAxis": "Ефективний стек префлоп",
        "tourneyallinRacesWonPAxis": "Races Won %",
        "tourneyallinEquityPAxis": "Equity %",
        "tourneyallinCallingOpenAI": "Calling Open AI",
        "tourneyallinCalling3BetAI": "Calling 3Bet AI",
        "tourneyallinPositionAxis": "Позицiя",
        "tourneyallinExpectationAxis": "Очікування",
        "threebetResultsTitle": "Результати",
        "threebetPositionTitle": "Позицiя",
        "threebetRangeTitle": "Three Bet Range",
        "threebetSuccessTitle": "Three Bet Success",
        "threebetFlopHandStrengthTitle": "Flop Hand Strength",
        "threebetWinrate": "3Bet Winrate",
        "threebetFrequency": "3Bet Frequency",
        "threebetRange": "3Bet Range",
        "threebetSuccessRate": "3Bet Success Rate",
        "threebetFlopWinrate": "Flop Winrate",
        "threebetWinrateHandStrengthAxis": "Winrate Hand Strength (bb/100)",
        "threebetHandCount": "${0} (${1} Hands)",
        "threebetWinrateKey": "Winrate",
        "threebetThreeBetPercentKey": "3-Bet %",
        "threebetWinrateAxis": "Winrate (bb/100)",
        "threebetThreeBetPercentAxis": "3-Bet %",
        "threebetSuccessPercentAxis": "Success %",
        "threebetNetwonTitle": "Net Won",
        "threebetNetwonMin": "Loss",
        "threebetNetwonMax": "Profit",
        "threebetDealtFrequencyTitle": "Частота отримання",
        "threebetDealtFrequencyMin": "Менш часто",
        "threebetDealtFrequencyMax": "Більш часто",
        "tourneyallinExpectedWon": "Expected Won",
        "availableStringPositionString": "EP;MP;CO;BTN;SB;BB",
        "availableStringFlopMadeHandValueString": "Unknown;High Card;One Pair;Two Pair;3 of a Kind;Straight;Flush;Full House;4 of a Kind;Straight Flush",
        "availableStringRiverMadeHandValueSummary": "Unknown;High Card;One Pair;Two Pair;Three of a Kind;Straight;Flush;Full House;Four of a Kind;Straight Flush",
        "availableStringFlopFlushTextureTypeAsString": "Flush Rainbow;Flush Two Tone;Flush Monotone",
        "availableStringFlopStraightTextureTypeAsString": "Str - Unconnected;Str - Connected;Str - 1 Gapper;Str - 2 Gapper;Str - Conn + 1 Gapper",
        "availableStringFlopPairedTextureTypeAsString": "Paired Board;Not Paired",
        "availableStringInPositionOnFlopShort": "IP;OOP",
        "availableStringInPositionOnFlopLong": "In Position;Out Of Position",
        "availableStringRiverplayCallEfficiency": "Call Efficiency;In Position;Out Of Position",
        "availableStringRiverplayBetEfficiency": "Bet Efficiency;In Position;Out Of Position",
        "availableStringCBetSpots": "Skipped CBet;Facing Donk;CBet & Won Hand;CBet & Lost Hand",
        "availableStringRiverFirstActionString": "Fold;Check;Call;Bet;Raise",
        "ECCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "ECCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "ECTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "ECTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "ERRaiseCallVsVillainOpenAllinPreflop": "AI PF vs Raise",
        "ERRaiseEVCallVsVillainOpenAllinPreflop": "Expectation AI PF vs Raise",
        "ERTBetCallVsVillainOpenAllinPreflop": "3Bet AI PF vs Re-Raise",
        "ERTBetEVCallVsVillainOpenAllinPreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "BPCCallCallVsVillainOpenAllinPreflop": "Call Opp AI PF",
        "BPCCallEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp AI PF",
        "BPCTBetCallVsVillainOpenAllinPreflop": "Call Opp 3Bet AI PF",
        "BPCTBetEVCallVsVillainOpenAllinPreflop": "Expectation Calling Opp 3Bet AI PF",
        "BPRRaiseAllinVsRaisePreflop": "AI PF vs Raise",
        "BPRRaiseEVAllinVsRaisePreflop": "Expectation AI PF vs Raise",
        "BPRTBetAllinVsRaisePreflop": "3Bet AI PF vs Re-Raise",
        "BPRTBetEVAllinVsRaisePreflop": "Expectation 3Bet AI PF vs Re-Raise",
        "threebetHandAxis": "Рука",
        "threebetNetBbAxis": "Net BBs",
        "tourneyallinCallingByStackTitle": "Expectation Calling All-In By Stack Size",
        "tourneyallinRaisingByStackTitle": "Expectation Raising All-In By Stack Size",
        "tourneyallinRaisingAllinRangeTitle": "Raising All-In Range",
        "tourneyallinCallingAllinRangeTitle": "Calling All-In Range",
        "tourneyallinCallingAllinByPositionTitle": "Calling All-In Results By Position",
        "tourneyallinRaisingAllinByPositionTitle": "Raising All-In Results By Position",
        "tourneyallinCallAIEVWinrate": "Call AI EV Winrate",
        "tourneyallinRaiseAIEVWinrate": "Raise AI EV Winrate",
        "tourneyallinCallAIWinrate": "Call AI Winrate",
        "tourneyallinRaiseAIWinrate": "Raise AI Winrate",
        "overall": "Загальний",
        "restrictionsWithYourLicenseText": "<B> Немає доступу</ b> до HM3 Apps\nПовідомлення пробного періоду в звітах і в HUD\nтривалість 14 днів"
    },

    init(language) {
        if ( this.initialized)
            return;
        this.initialized = true;
        for ( var name in this.keys) {
            this.keys[name] = name;
        }
        this.language = language;
        log(LogCategory.info,"localizer initialized " + this.language);
    },

    format(key, values ) {
        // Localizer.init() hasn't been called?
        console.assert(key != "");
        console.assert(this.initialized);
    
        var language = this.language;
        if ( typeof language !== 'string') {
            log(LogCategory.info,'fatal - invalid language ' + language);
            language = "en";
        }

        var useKeys = [];
        switch (language) {
            case "en":      useKeys = this.en; break;
            case "zh-CN":   useKeys = this.chinese; break;
            case "fr":      useKeys = this.french; break;
            case "de":      useKeys = this.german; break;
            case "it":      useKeys = this.italian; break;
            case "ja":      useKeys = this.japanese; break;
            case "pl":      useKeys = this.polish; break;
            case "pt":      useKeys = this.portugese; break;
            case "pt-br":   useKeys = this.portugese_br; break;
            case "ro":      useKeys = this.romanian; break;
            case "ru":      useKeys = this.russian; break;
            case "sl":      useKeys = this.slovenian; break;
            case "es":      useKeys = this.spanish; break;
            case "uk":      useKeys = this.ukrainian; break;
            default:
                // unknown or invalid language -> use english
                log(LogCategory.warn,"invalid language : " + language);
                useKeys = this.en;
                break;
        };
    
    
        if ( useKeys.length < 1)
            useKeys = this.keys;

        var msg = key;
        if ( typeof useKeys[key] !== 'undefined')
            msg = useKeys[key];
        else {
            // we don't have this key for a specific language - just default to 'en'
            useKeys = this.en;
            if (typeof useKeys[key] !== 'undefined')
                msg = useKeys[key];
        }
    
        if ( typeof values !== 'undefined') {
            // replace ${0} with value0 , ${1} with value1 etc.
            for ( var i in values) {
                var argName = "${" + i + "}";
                msg = msg.replace(argName, "" + values[i]);
            }
        }
    
        return msg;
    }
}


// WEBPACK FOOTER //
// ./src/format/localizer.js